(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports'], factory);
  else if (typeof exports === 'object')
    factory(module.exports);
  else
    root.drinkingGameKt = factory(typeof drinkingGameKt === 'undefined' ? {} : drinkingGameKt);
}(this, function (_) {
  'use strict';
  Default.prototype = Object.create(Random.prototype);
  Default.prototype.constructor = Default;
  XorWowRandom.prototype = Object.create(Random.prototype);
  XorWowRandom.prototype.constructor = XorWowRandom;
  IntProgressionIterator.prototype = Object.create(IntIterator.prototype);
  IntProgressionIterator.prototype.constructor = IntProgressionIterator;
  IntRange.prototype = Object.create(IntProgression.prototype);
  IntRange.prototype.constructor = IntRange;
  AbstractMutableCollection.prototype = Object.create(AbstractCollection.prototype);
  AbstractMutableCollection.prototype.constructor = AbstractMutableCollection;
  AbstractMutableList.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableList.prototype.constructor = AbstractMutableList;
  AbstractMutableSet.prototype = Object.create(AbstractMutableCollection.prototype);
  AbstractMutableSet.prototype.constructor = AbstractMutableSet;
  AbstractEntrySet.prototype = Object.create(AbstractMutableSet.prototype);
  AbstractEntrySet.prototype.constructor = AbstractEntrySet;
  _no_name_provided__11.prototype = Object.create(AbstractMutableSet.prototype);
  _no_name_provided__11.prototype.constructor = _no_name_provided__11;
  AbstractMutableMap.prototype = Object.create(AbstractMap.prototype);
  AbstractMutableMap.prototype.constructor = AbstractMutableMap;
  ArrayList.prototype = Object.create(AbstractMutableList.prototype);
  ArrayList.prototype.constructor = ArrayList;
  EntrySet.prototype = Object.create(AbstractEntrySet.prototype);
  EntrySet.prototype.constructor = EntrySet;
  HashMap.prototype = Object.create(AbstractMutableMap.prototype);
  HashMap.prototype.constructor = HashMap;
  HashSet.prototype = Object.create(AbstractMutableSet.prototype);
  HashSet.prototype.constructor = HashSet;
  ChainEntry.prototype = Object.create(SimpleEntry.prototype);
  ChainEntry.prototype.constructor = ChainEntry;
  EntrySet_0.prototype = Object.create(AbstractEntrySet.prototype);
  EntrySet_0.prototype.constructor = EntrySet_0;
  LinkedHashMap.prototype = Object.create(HashMap.prototype);
  LinkedHashMap.prototype.constructor = LinkedHashMap;
  LinkedHashSet.prototype = Object.create(HashSet.prototype);
  LinkedHashSet.prototype.constructor = LinkedHashSet;
  PrimitiveKClassImpl.prototype = Object.create(KClassImpl.prototype);
  PrimitiveKClassImpl.prototype.constructor = PrimitiveKClassImpl;
  NothingKClassImpl.prototype = Object.create(KClassImpl.prototype);
  NothingKClassImpl.prototype.constructor = NothingKClassImpl;
  SimpleKClassImpl.prototype = Object.create(KClassImpl.prototype);
  SimpleKClassImpl.prototype.constructor = SimpleKClassImpl;
  _no_name_provided__36.prototype = Object.create(AbstractCollection.prototype);
  _no_name_provided__36.prototype.constructor = _no_name_provided__36;
  Long.prototype = Object.create(Number_0.prototype);
  Long.prototype.constructor = Long;
  Exception.prototype = Object.create(Error.prototype);
  Exception.prototype.constructor = Exception;
  RuntimeException.prototype = Object.create(Exception.prototype);
  RuntimeException.prototype.constructor = RuntimeException;
  IllegalArgumentException.prototype = Object.create(RuntimeException.prototype);
  IllegalArgumentException.prototype.constructor = IllegalArgumentException;
  NoSuchElementException.prototype = Object.create(RuntimeException.prototype);
  NoSuchElementException.prototype.constructor = NoSuchElementException;
  IllegalStateException.prototype = Object.create(RuntimeException.prototype);
  IllegalStateException.prototype.constructor = IllegalStateException;
  IndexOutOfBoundsException.prototype = Object.create(RuntimeException.prototype);
  IndexOutOfBoundsException.prototype.constructor = IndexOutOfBoundsException;
  UnsupportedOperationException.prototype = Object.create(RuntimeException.prototype);
  UnsupportedOperationException.prototype.constructor = UnsupportedOperationException;
  ArithmeticException.prototype = Object.create(RuntimeException.prototype);
  ArithmeticException.prototype.constructor = ArithmeticException;
  NullPointerException.prototype = Object.create(RuntimeException.prototype);
  NullPointerException.prototype.constructor = NullPointerException;
  ClassCastException.prototype = Object.create(RuntimeException.prototype);
  ClassCastException.prototype.constructor = ClassCastException;
  StringAttribute.prototype = Object.create(Attribute.prototype);
  StringAttribute.prototype.constructor = StringAttribute;
  StringSetAttribute.prototype = Object.create(Attribute.prototype);
  StringSetAttribute.prototype.constructor = StringSetAttribute;
  BooleanAttribute.prototype = Object.create(Attribute.prototype);
  BooleanAttribute.prototype.constructor = BooleanAttribute;
  EnumAttribute.prototype = Object.create(Attribute.prototype);
  EnumAttribute.prototype.constructor = EnumAttribute;
  InputType.prototype = Object.create(Enum.prototype);
  InputType.prototype.constructor = InputType;
  BUTTON.prototype = Object.create(HTMLTag.prototype);
  BUTTON.prototype.constructor = BUTTON;
  DIV.prototype = Object.create(HTMLTag.prototype);
  DIV.prototype.constructor = DIV;
  INPUT.prototype = Object.create(HTMLTag.prototype);
  INPUT.prototype.constructor = INPUT;
  SPAN.prototype = Object.create(HTMLTag.prototype);
  SPAN.prototype.constructor = SPAN;
  function shuffle(_this_) {
    shuffle_0(_this_, Default_getInstance());
  }
  function first(_this_) {
    if (_this_.length === 0)
      throw NoSuchElementException_init_$Create$_0('Array is empty.');
    else {
    }
    return _this_[0];
  }
  function drop(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return takeLast(_this_, coerceAtLeast(_this_.length - n | 0, 0));
  }
  function toMutableList(_this_) {
    return ArrayList_init_$Create$_1(asCollection(_this_));
  }
  function shuffle_0(_this_, random) {
    var inductionVariable = _get_lastIndex_(_this_);
    if (1 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var j = random.nextInt_6(i + 1 | 0);
        var copy = _this_[i];
        _this_[i] = _this_[j];
        _this_[j] = copy;
      }
       while (1 <= inductionVariable);
  }
  function takeLast(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }if (n === 0)
      return emptyList();
    var size = _this_.length;
    if (n >= size)
      return toList(_this_);
    if (n === 1)
      return listOf(_this_[size - 1 | 0]);
    var list = ArrayList_init_$Create$_0(n);
    var inductionVariable = size - n | 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.add_16(_this_[index]);
        Unit_getInstance();
      }
       while (inductionVariable < size);
    return list;
  }
  function _get_lastIndex_(_this_) {
    return _this_.length - 1 | 0;
  }
  function toList(_this_) {
    var tmp0_subject = _this_.length;
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf(_this_[0]);
      default:return toMutableList(_this_);
    }
  }
  function contains(_this_, element) {
    return indexOf(_this_, element) >= 0;
  }
  function indexOf(_this_, element) {
    if (element == null) {
      var inductionVariable = 0;
      var last_0 = _this_.length - 1 | 0;
      if (inductionVariable <= last_0)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (_this_[index] == null) {
            return index;
          }}
         while (inductionVariable <= last_0);
    } else {
      var inductionVariable_0 = 0;
      var last_1 = _this_.length - 1 | 0;
      if (inductionVariable_0 <= last_1)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (equals_0(element, _this_[index_0])) {
            return index_0;
          }}
         while (inductionVariable_0 <= last_1);
    }
    return -1;
  }
  function toCollection(_this_, destination) {
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable < last_0) {
      var item = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      destination.add_16(item);
      Unit_getInstance();
    }
    return destination;
  }
  function joinToString(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo(_this_, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function joinTo(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var indexedObject = _this_;
    var inductionVariable = 0;
    var last_0 = indexedObject.length;
    $l$break: while (inductionVariable < last_0) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform) {
    return joinTo_0(_this_, StringBuilder_init_$Create$_0(), separator, prefix, postfix, limit, truncated, transform).toString();
  }
  function joinToString$default_0(_this_, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      separator = ', ';
    if (!(($mask0 & 2) === 0))
      prefix = '';
    if (!(($mask0 & 4) === 0))
      postfix = '';
    if (!(($mask0 & 8) === 0))
      limit = -1;
    if (!(($mask0 & 16) === 0))
      truncated = '...';
    if (!(($mask0 & 32) === 0))
      transform = null;
    return joinToString_0(_this_, separator, prefix, postfix, limit, truncated, transform);
  }
  function toSet(_this_) {
    if (isInterface(_this_, Collection)) {
      var tmp0_subject = _this_._get_size__26();
      var tmp;
      switch (tmp0_subject) {
        case 0:
          tmp = emptySet();
          break;
        case 1:
          var tmp_0;
          if (isInterface(_this_, List)) {
            tmp_0 = _this_.get_36(0);
          } else {
            {
              tmp_0 = _this_.iterator_38().next_14();
            }
          }

          tmp = setOf(tmp_0);
          break;
        default:tmp = toCollection_0(_this_, LinkedHashSet_init_$Create$_0(mapCapacity(_this_._get_size__26())));
          break;
      }
      return tmp;
    } else {
    }
    return optimizeReadOnlySet(toCollection_0(_this_, LinkedHashSet_init_$Create$()));
  }
  function joinTo_0(_this_, buffer, separator, prefix, postfix, limit, truncated, transform) {
    buffer.append_3(prefix);
    Unit_getInstance();
    var count = 0;
    var tmp0_iterator = _this_.iterator_38();
    $l$break: while (tmp0_iterator.hasNext_12()) {
      var element = tmp0_iterator.next_14();
      count = count + 1 | 0;
      if (count > 1) {
        buffer.append_3(separator);
        Unit_getInstance();
      } else {
      }
      if (limit < 0 ? true : count <= limit) {
        appendElement(buffer, element, transform);
      } else
        break $l$break;
    }
    if (limit >= 0 ? count > limit : false) {
      buffer.append_3(truncated);
      Unit_getInstance();
    }buffer.append_3(postfix);
    Unit_getInstance();
    return buffer;
  }
  function joinTo$default(_this_, buffer, separator, prefix, postfix, limit, truncated, transform, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      separator = ', ';
    if (!(($mask0 & 4) === 0))
      prefix = '';
    if (!(($mask0 & 8) === 0))
      postfix = '';
    if (!(($mask0 & 16) === 0))
      limit = -1;
    if (!(($mask0 & 32) === 0))
      truncated = '...';
    if (!(($mask0 & 64) === 0))
      transform = null;
    return joinTo_0(_this_, buffer, separator, prefix, postfix, limit, truncated, transform);
  }
  function toCollection_0(_this_, destination) {
    var tmp0_iterator = _this_.iterator_38();
    while (tmp0_iterator.hasNext_12()) {
      var item = tmp0_iterator.next_14();
      destination.add_16(item);
      Unit_getInstance();
    }
    return destination;
  }
  function asSequence(_this_) {
    return new _no_name_provided__1(_this_);
  }
  function minOrNull(_this_) {
    var iterator = _this_.iterator_38();
    if (!iterator.hasNext_12())
      return null;
    var min = iterator.next_14();
    while (iterator.hasNext_12()) {
      var e = iterator.next_14();
      if (compareTo(min, e) > 0)
        min = e;
    }
    return min;
  }
  function single(_this_) {
    var tmp0_subject = _this_;
    if (isInterface(tmp0_subject, List))
      return single_0(_this_);
    else {
      {
        var iterator = _this_.iterator_38();
        if (!iterator.hasNext_12())
          throw NoSuchElementException_init_$Create$_0('Collection is empty.');
        var single_1 = iterator.next_14();
        if (iterator.hasNext_12())
          throw IllegalArgumentException_init_$Create$('Collection has more than one element.');
        return single_1;
      }
    }
  }
  function single_0(_this_) {
    var tmp0_subject = _this_._get_size__26();
    var tmp;
    switch (tmp0_subject) {
      case 0:
        throw NoSuchElementException_init_$Create$_0('List is empty.');
      case 1:
        tmp = _this_.get_36(0);
        break;
      default:throw IllegalArgumentException_init_$Create$('List has more than one element.');
    }
    return tmp;
  }
  function last(_this_) {
    if (_this_.isEmpty_26())
      throw NoSuchElementException_init_$Create$_0('List is empty.');
    return _this_.get_36(_get_lastIndex__0(_this_));
  }
  function _no_name_provided__1($this_asSequence) {
    this._$this_asSequence = $this_asSequence;
  }
  _no_name_provided__1.prototype.iterator_2 = function () {
    return this._$this_asSequence.iterator_38();
  };
  _no_name_provided__1.prototype.iterator_38 = function () {
    return this.iterator_2();
  };
  _no_name_provided__1.$metadata$ = {
    simpleName: '<no name provided>_1',
    kind: 'class',
    interfaces: [Sequence]
  };
  function coerceAtLeast(_this_, minimumValue) {
    return _this_ < minimumValue ? minimumValue : _this_;
  }
  function downTo(_this_, to_0) {
    return Companion_getInstance_2().fromClosedRange(_this_, to_0, -1);
  }
  function until(_this_, to_0) {
    if (to_0 <= IntCompanionObject_getInstance()._MIN_VALUE)
      return Companion_getInstance_3()._EMPTY;
    return numberRangeToNumber(_this_, to_0 - 1 | 0);
  }
  function coerceIn(_this_, minimumValue, maximumValue) {
    if (minimumValue > maximumValue)
      throw IllegalArgumentException_init_$Create$('' + 'Cannot coerce value to an empty range: maximum ' + maximumValue + ' is less than minimum ' + minimumValue + '.');
    if (_this_ < minimumValue)
      return minimumValue;
    if (_this_ > maximumValue)
      return maximumValue;
    return _this_;
  }
  function coerceAtMost(_this_, maximumValue) {
    return _this_ > maximumValue ? maximumValue : _this_;
  }
  function toList_0(_this_) {
    return optimizeReadOnlyList(toMutableList_0(_this_));
  }
  function take(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested element count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp;
    if (n === 0) {
      tmp = emptySequence();
    } else {
      if (isInterface(_this_, DropTakeSequence)) {
        tmp = _this_.take_1(n);
      } else {
        {
          tmp = new TakeSequence(_this_, n);
        }
      }
    }
    return tmp;
  }
  function map(_this_, transform) {
    return new TransformingSequence(_this_, transform);
  }
  function toMutableList_0(_this_) {
    return toCollection_1(_this_, ArrayList_init_$Create$());
  }
  function toCollection_1(_this_, destination) {
    var tmp0_iterator = _this_.iterator_38();
    while (tmp0_iterator.hasNext_12()) {
      var item = tmp0_iterator.next_14();
      destination.add_16(item);
      Unit_getInstance();
    }
    return destination;
  }
  function plus(_this_, element) {
    var result = LinkedHashSet_init_$Create$_0(mapCapacity(_this_._get_size__26() + 1 | 0));
    result.addAll_1(_this_);
    Unit_getInstance();
    result.add_16(element);
    Unit_getInstance();
    return result;
  }
  function drop_0(_this_, n) {
    var tmp0_require_0 = n >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Requested character count ' + n + ' is less than zero.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_substring_0 = coerceAtMost(n, _this_.length);
    return _this_.substring(tmp1_substring_0);
  }
  function _no_name_provided_(this$0) {
    this._this$0 = this$0;
  }
  _no_name_provided_.prototype.invoke = function (it) {
    return it === this._this$0 ? '(this Collection)' : toString_0(it);
  };
  _no_name_provided_.prototype.invoke_293 = function (p1) {
    return this.invoke((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided_.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractCollection() {
  }
  AbstractCollection.prototype.contains_14 = function (element) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(this, Collection)) {
        tmp = this.isEmpty_26();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = false;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = this.iterator_38();
      while (tmp0_iterator_1.hasNext_12()) {
        var element_2 = tmp0_iterator_1.next_14();
        if (equals_0(element_2, element)) {
          tmp$ret$0 = true;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = false;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.containsAll_17 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_26();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_38();
      while (tmp0_iterator_1.hasNext_12()) {
        var element_2 = tmp0_iterator_1.next_14();
        if (!this.contains_14(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractCollection.prototype.isEmpty_26 = function () {
    return this._get_size__26() === 0;
  };
  AbstractCollection.prototype.toString = function () {
    return joinToString$default_0(this, ', ', '[', ']', 0, null, _no_name_provided_$factory(this), 24, null);
  };
  AbstractCollection.prototype.toArray = function () {
    return copyToArrayImpl_0(this);
  };
  AbstractCollection.$metadata$ = {
    simpleName: 'AbstractCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function _no_name_provided_$factory(this$0) {
    var i = new _no_name_provided_(this$0);
    return function (p1) {
      return i.invoke(p1);
    };
  }
  function Companion_0() {
    Companion_instance = this;
  }
  Companion_0.prototype.checkElementIndex = function (index, size) {
    if (index < 0 ? true : index >= size) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size);
    }};
  Companion_0.prototype.checkPositionIndex = function (index, size) {
    if (index < 0 ? true : index > size) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', size: ' + size);
    }};
  Companion_0.prototype.orderedHashCode = function (c) {
    var hashCode_1 = 1;
    var tmp0_iterator = c.iterator_38();
    while (tmp0_iterator.hasNext_12()) {
      var e = tmp0_iterator.next_14();
      var tmp = imul(31, hashCode_1);
      var tmp1_safe_receiver = e;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_0.prototype.orderedEquals = function (c, other) {
    if (!(c._get_size__26() === other._get_size__26()))
      return false;
    var otherIterator = other.iterator_38();
    var tmp0_iterator = c.iterator_38();
    while (tmp0_iterator.hasNext_12()) {
      var elem = tmp0_iterator.next_14();
      var elemOther = otherIterator.next_14();
      if (!equals_0(elem, elemOther)) {
        return false;
      }}
    return true;
  };
  Companion_0.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion_0();
    return Companion_instance;
  }
  function toString($this, o) {
    return o === $this ? '(this Map)' : toString_0(o);
  }
  function implFindEntry($this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_firstOrNull_0 = $this._get_entries__7();
      var tmp0_iterator_1 = tmp0_firstOrNull_0.iterator_38();
      while (tmp0_iterator_1.hasNext_12()) {
        var element_2 = tmp0_iterator_1.next_14();
        if (equals_0(element_2._get_key__3(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function Companion_1() {
    Companion_instance_0 = this;
  }
  Companion_1.prototype.entryHashCode = function (e) {
    var tmp2_safe_receiver_4 = e._get_key__3();
    var tmp3_elvis_lhs_3 = tmp2_safe_receiver_4 == null ? null : hashCode(tmp2_safe_receiver_4);
    var tmp = tmp3_elvis_lhs_3 == null ? 0 : tmp3_elvis_lhs_3;
    var tmp0_safe_receiver_6 = e._get_value__3();
    var tmp1_elvis_lhs_5 = tmp0_safe_receiver_6 == null ? null : hashCode(tmp0_safe_receiver_6);
    return tmp ^ (tmp1_elvis_lhs_5 == null ? 0 : tmp1_elvis_lhs_5);
  };
  Companion_1.prototype.entryToString = function (e) {
    return '' + e._get_key__3() + '=' + e._get_value__3();
  };
  Companion_1.prototype.entryEquals = function (e, other) {
    if (!(!(other == null) ? isInterface(other, Entry) : false))
      return false;
    else {
    }
    return equals_0(e._get_key__3(), other._get_key__3()) ? equals_0(e._get_value__3(), other._get_value__3()) : false;
  };
  Companion_1.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_1();
    return Companion_instance_0;
  }
  function _no_name_provided__0(this$0) {
    this._this$0_0 = this$0;
  }
  _no_name_provided__0.prototype.invoke_1 = function (it) {
    return this._this$0_0.toString_0(it);
  };
  _no_name_provided__0.prototype.invoke_293 = function (p1) {
    return this.invoke_1((!(p1 == null) ? isInterface(p1, Entry) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__0.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMap() {
    Companion_getInstance_0();
    this.__keys = null;
    this.__values = null;
  }
  AbstractMap.prototype.containsKey_9 = function (key) {
    return !(implFindEntry(this, key) == null);
  };
  AbstractMap.prototype.containsEntry_5 = function (entry) {
    if (!(!(entry == null) ? isInterface(entry, Entry) : false))
      return false;
    else {
    }
    var key = entry._get_key__3();
    var value = entry._get_value__3();
    var ourValue = (isInterface(this, Map_0) ? this : THROW_CCE()).get_25(key);
    if (!equals_0(value, ourValue)) {
      return false;
    }var tmp;
    if (ourValue == null) {
      tmp = !(isInterface(this, Map_0) ? this : THROW_CCE()).containsKey_9(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      return false;
    } else {
    }
    return true;
  };
  AbstractMap.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Map_0) : false))
      return false;
    else {
    }
    if (!(this._get_size__26() === other._get_size__26()))
      return false;
    var tmp$ret$0;
    l$ret$1: do {
      var tmp0_all_0 = other._get_entries__7();
      var tmp;
      if (isInterface(tmp0_all_0, Collection)) {
        tmp = tmp0_all_0.isEmpty_26();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = tmp0_all_0.iterator_38();
      while (tmp0_iterator_1.hasNext_12()) {
        var element_2 = tmp0_iterator_1.next_14();
        if (!this.containsEntry_5(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  AbstractMap.prototype.get_25 = function (key) {
    var tmp0_safe_receiver = implFindEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__3();
  };
  AbstractMap.prototype.hashCode = function () {
    return hashCode(this._get_entries__7());
  };
  AbstractMap.prototype.isEmpty_26 = function () {
    return this._get_size__26() === 0;
  };
  AbstractMap.prototype._get_size__26 = function () {
    return this._get_entries__7()._get_size__26();
  };
  AbstractMap.prototype.toString = function () {
    var tmp = this._get_entries__7();
    return joinToString$default_0(tmp, ', ', '{', '}', 0, null, _no_name_provided_$factory_0(this), 24, null);
  };
  AbstractMap.prototype.toString_0 = function (entry) {
    return toString(this, entry._get_key__3()) + '=' + toString(this, entry._get_value__3());
  };
  AbstractMap.$metadata$ = {
    simpleName: 'AbstractMap',
    kind: 'class',
    interfaces: [Map_0]
  };
  function _no_name_provided_$factory_0(this$0) {
    var i = new _no_name_provided__0(this$0);
    return function (p1) {
      return i.invoke_1(p1);
    };
  }
  function Companion_2() {
    Companion_instance_1 = this;
  }
  Companion_2.prototype.unorderedHashCode = function (c) {
    var hashCode_1 = 0;
    var tmp0_iterator = c.iterator_38();
    while (tmp0_iterator.hasNext_12()) {
      var element = tmp0_iterator.next_14();
      var tmp = hashCode_1;
      var tmp1_safe_receiver = element;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : hashCode(tmp1_safe_receiver);
      hashCode_1 = tmp + (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs) | 0;
    }
    return hashCode_1;
  };
  Companion_2.prototype.setEquals = function (c, other) {
    if (!(c._get_size__26() === other._get_size__26()))
      return false;
    return c.containsAll_17(other);
  };
  Companion_2.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_2();
    return Companion_instance_1;
  }
  function EmptyList() {
    EmptyList_instance = this;
    this._serialVersionUID = new Long(-1478467534, -1720727600);
  }
  EmptyList.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, List) : false) {
      tmp = other.isEmpty_26();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyList.prototype.hashCode = function () {
    return 1;
  };
  EmptyList.prototype.toString = function () {
    return '[]';
  };
  EmptyList.prototype._get_size__26 = function () {
    return 0;
  };
  EmptyList.prototype.isEmpty_26 = function () {
    return true;
  };
  EmptyList.prototype.containsAll_4 = function (elements) {
    return elements.isEmpty_26();
  };
  EmptyList.prototype.containsAll_17 = function (elements) {
    return this.containsAll_4(elements);
  };
  EmptyList.prototype.get_36 = function (index) {
    throw IndexOutOfBoundsException_init_$Create$('' + "Empty list doesn't contain element at index " + index + '.');
  };
  EmptyList.prototype.iterator_38 = function () {
    return EmptyIterator_getInstance();
  };
  EmptyList.$metadata$ = {
    simpleName: 'EmptyList',
    kind: 'object',
    interfaces: [List, Serializable, RandomAccess]
  };
  var EmptyList_instance;
  function EmptyList_getInstance() {
    if (EmptyList_instance == null)
      new EmptyList();
    return EmptyList_instance;
  }
  function asCollection(_this_) {
    return new ArrayAsCollection(_this_, false);
  }
  function emptyList() {
    return EmptyList_getInstance();
  }
  function EmptyIterator() {
    EmptyIterator_instance = this;
  }
  EmptyIterator.prototype.hasNext_12 = function () {
    return false;
  };
  EmptyIterator.prototype.next_14 = function () {
    throw NoSuchElementException_init_$Create$();
  };
  EmptyIterator.$metadata$ = {
    simpleName: 'EmptyIterator',
    kind: 'object',
    interfaces: [ListIterator]
  };
  var EmptyIterator_instance;
  function EmptyIterator_getInstance() {
    if (EmptyIterator_instance == null)
      new EmptyIterator();
    return EmptyIterator_instance;
  }
  function _get_indices_(_this_) {
    return numberRangeToNumber(0, _this_._get_size__26() - 1 | 0);
  }
  function arrayListOf(elements) {
    return elements.length === 0 ? ArrayList_init_$Create$() : ArrayList_init_$Create$_1(new ArrayAsCollection(elements, true));
  }
  function _get_lastIndex__0(_this_) {
    return _this_._get_size__26() - 1 | 0;
  }
  function optimizeReadOnlyList(_this_) {
    var tmp0_subject = _this_._get_size__26();
    switch (tmp0_subject) {
      case 0:
        return emptyList();
      case 1:
        return listOf(_this_.get_36(0));
      default:return _this_;
    }
  }
  function ArrayAsCollection(values_0, isVarargs) {
    this._values = values_0;
    this._isVarargs = isVarargs;
  }
  ArrayAsCollection.prototype._get_size__26 = function () {
    return this._values.length;
  };
  ArrayAsCollection.prototype.isEmpty_26 = function () {
    var tmp0_isEmpty_0 = this._values;
    return tmp0_isEmpty_0.length === 0;
  };
  ArrayAsCollection.prototype.contains_1 = function (element) {
    return contains(this._values, element);
  };
  ArrayAsCollection.prototype.containsAll_2 = function (elements) {
    var tmp$ret$0;
    l$ret$1: do {
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.isEmpty_26();
      } else {
        {
          tmp = false;
        }
      }
      if (tmp) {
        tmp$ret$0 = true;
        break l$ret$1;
      } else {
      }
      var tmp0_iterator_1 = elements.iterator_38();
      while (tmp0_iterator_1.hasNext_12()) {
        var element_2 = tmp0_iterator_1.next_14();
        if (!this.contains_1(element_2)) {
          tmp$ret$0 = false;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = true;
    }
     while (false);
    return tmp$ret$0;
  };
  ArrayAsCollection.prototype.containsAll_17 = function (elements) {
    return this.containsAll_2(elements);
  };
  ArrayAsCollection.prototype.iterator_38 = function () {
    return arrayIterator(this._values);
  };
  ArrayAsCollection.$metadata$ = {
    simpleName: 'ArrayAsCollection',
    kind: 'class',
    interfaces: [Collection]
  };
  function throwIndexOverflow() {
    throw ArithmeticException_init_$Create$('Index overflow has happened.');
  }
  function collectionSizeOrDefault(_this_, default_0) {
    var tmp;
    if (isInterface(_this_, Collection)) {
      tmp = _this_._get_size__26();
    } else {
      {
        tmp = default_0;
      }
    }
    return tmp;
  }
  function emptyMap() {
    var tmp = EmptyMap_getInstance();
    return isInterface(tmp, Map_0) ? tmp : THROW_CCE();
  }
  function EmptyMap() {
    EmptyMap_instance = this;
    this._serialVersionUID_0 = new Long(-888910638, 1920087921);
  }
  EmptyMap.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Map_0) : false) {
      tmp = other.isEmpty_26();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptyMap.prototype.hashCode = function () {
    return 0;
  };
  EmptyMap.prototype.toString = function () {
    return '{}';
  };
  EmptyMap.prototype._get_size__26 = function () {
    return 0;
  };
  EmptyMap.prototype.isEmpty_26 = function () {
    return true;
  };
  EmptyMap.prototype.containsKey_0 = function (key) {
    return false;
  };
  EmptyMap.prototype.containsKey_9 = function (key) {
    if (!(key == null ? true : isObject(key)))
      return false;
    else {
    }
    return this.containsKey_0((key == null ? true : isObject(key)) ? key : THROW_CCE());
  };
  EmptyMap.prototype.get_2 = function (key) {
    return null;
  };
  EmptyMap.prototype.get_25 = function (key) {
    if (!(key == null ? true : isObject(key)))
      return null;
    else {
    }
    return this.get_2((key == null ? true : isObject(key)) ? key : THROW_CCE());
  };
  EmptyMap.prototype._get_entries__7 = function () {
    return EmptySet_getInstance();
  };
  EmptyMap.$metadata$ = {
    simpleName: 'EmptyMap',
    kind: 'object',
    interfaces: [Map_0, Serializable]
  };
  var EmptyMap_instance;
  function EmptyMap_getInstance() {
    if (EmptyMap_instance == null)
      new EmptyMap();
    return EmptyMap_instance;
  }
  function Sequence() {
  }
  Sequence.$metadata$ = {
    simpleName: 'Sequence',
    kind: 'interface',
    interfaces: []
  };
  function generateSequence(seedFunction, nextFunction) {
    return new GeneratorSequence(seedFunction, nextFunction);
  }
  function emptySequence() {
    return EmptySequence_getInstance();
  }
  function DropTakeSequence() {
  }
  DropTakeSequence.$metadata$ = {
    simpleName: 'DropTakeSequence',
    kind: 'interface',
    interfaces: [Sequence]
  };
  function _no_name_provided__2(this$0) {
    this._this$0_1 = this$0;
    this._left = this._this$0_1._count;
    this._iterator = this._this$0_1._sequence.iterator_38();
  }
  _no_name_provided__2.prototype.next_14 = function () {
    if (this._left === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp0_this = this;
    var tmp1 = tmp0_this._left;
    tmp0_this._left = tmp1 - 1 | 0;
    Unit_getInstance();
    return this._iterator.next_14();
  };
  _no_name_provided__2.prototype.hasNext_12 = function () {
    return this._left > 0 ? this._iterator.hasNext_12() : false;
  };
  _no_name_provided__2.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function TakeSequence(sequence, count) {
    this._sequence = sequence;
    this._count = count;
    var tmp0_require_0 = this._count >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'count must be non-negative, but was ' + this._count + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }}
  TakeSequence.prototype.take_1 = function (n) {
    return n >= this._count ? this : new TakeSequence(this._sequence, n);
  };
  TakeSequence.prototype.iterator_38 = function () {
    return new _no_name_provided__2(this);
  };
  TakeSequence.$metadata$ = {
    simpleName: 'TakeSequence',
    kind: 'class',
    interfaces: [Sequence, DropTakeSequence]
  };
  function _no_name_provided__3(this$0) {
    this._this$0_2 = this$0;
    this._iterator_0 = this._this$0_2._sequence_0.iterator_38();
  }
  _no_name_provided__3.prototype.next_14 = function () {
    return this._this$0_2._transformer(this._iterator_0.next_14());
  };
  _no_name_provided__3.prototype.hasNext_12 = function () {
    return this._iterator_0.hasNext_12();
  };
  _no_name_provided__3.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function TransformingSequence(sequence, transformer) {
    this._sequence_0 = sequence;
    this._transformer = transformer;
  }
  TransformingSequence.prototype.iterator_38 = function () {
    return new _no_name_provided__3(this);
  };
  TransformingSequence.$metadata$ = {
    simpleName: 'TransformingSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function calcNext($this) {
    $this._nextItem = $this._nextState === -2 ? $this._this$0_3._getInitialValue() : $this._this$0_3._getNextValue(ensureNotNull($this._nextItem));
    $this._nextState = $this._nextItem == null ? 0 : 1;
  }
  function _no_name_provided__4(this$0) {
    this._this$0_3 = this$0;
    this._nextItem = null;
    this._nextState = -2;
  }
  _no_name_provided__4.prototype.next_14 = function () {
    if (this._nextState < 0)
      calcNext(this);
    if (this._nextState === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this._nextItem;
    var result = isObject(tmp) ? tmp : THROW_CCE();
    this._nextState = -1;
    return result;
  };
  _no_name_provided__4.prototype.hasNext_12 = function () {
    if (this._nextState < 0)
      calcNext(this);
    return this._nextState === 1;
  };
  _no_name_provided__4.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function GeneratorSequence(getInitialValue, getNextValue) {
    this._getInitialValue = getInitialValue;
    this._getNextValue = getNextValue;
  }
  GeneratorSequence.prototype.iterator_38 = function () {
    return new _no_name_provided__4(this);
  };
  GeneratorSequence.$metadata$ = {
    simpleName: 'GeneratorSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function EmptySequence() {
    EmptySequence_instance = this;
  }
  EmptySequence.prototype.iterator_38 = function () {
    return EmptyIterator_getInstance();
  };
  EmptySequence.prototype.take_1 = function (n) {
    return EmptySequence_getInstance();
  };
  EmptySequence.$metadata$ = {
    simpleName: 'EmptySequence',
    kind: 'object',
    interfaces: [Sequence, DropTakeSequence]
  };
  var EmptySequence_instance;
  function EmptySequence_getInstance() {
    if (EmptySequence_instance == null)
      new EmptySequence();
    return EmptySequence_instance;
  }
  function emptySet() {
    return EmptySet_getInstance();
  }
  function EmptySet() {
    EmptySet_instance = this;
    this._serialVersionUID_1 = new Long(1993859828, 793161749);
  }
  EmptySet.prototype.equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Set) : false) {
      tmp = other.isEmpty_26();
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  EmptySet.prototype.hashCode = function () {
    return 0;
  };
  EmptySet.prototype.toString = function () {
    return '[]';
  };
  EmptySet.prototype._get_size__26 = function () {
    return 0;
  };
  EmptySet.prototype.isEmpty_26 = function () {
    return true;
  };
  EmptySet.prototype.containsAll_4 = function (elements) {
    return elements.isEmpty_26();
  };
  EmptySet.prototype.containsAll_17 = function (elements) {
    return this.containsAll_4(elements);
  };
  EmptySet.prototype.iterator_38 = function () {
    return EmptyIterator_getInstance();
  };
  EmptySet.$metadata$ = {
    simpleName: 'EmptySet',
    kind: 'object',
    interfaces: [Set, Serializable]
  };
  var EmptySet_instance;
  function EmptySet_getInstance() {
    if (EmptySet_instance == null)
      new EmptySet();
    return EmptySet_instance;
  }
  function optimizeReadOnlySet(_this_) {
    var tmp0_subject = _this_._get_size__26();
    switch (tmp0_subject) {
      case 0:
        return emptySet();
      case 1:
        return setOf(_this_.iterator_38().next_14());
      default:return _this_;
    }
  }
  function hashSetOf(elements) {
    return toCollection(elements, HashSet_init_$Create$(mapCapacity(elements.length)));
  }
  function Default() {
    Default_instance = this;
    Random.call(this);
    this._defaultRandom = defaultPlatformRandom();
  }
  Default.prototype.nextBits_1 = function (bitCount) {
    return this._defaultRandom.nextBits_1(bitCount);
  };
  Default.prototype.nextInt_9 = function () {
    return this._defaultRandom.nextInt_9();
  };
  Default.prototype.nextInt_6 = function (until_0) {
    return this._defaultRandom.nextInt_6(until_0);
  };
  Default.prototype.nextInt_7 = function (from, until_0) {
    return this._defaultRandom.nextInt_7(from, until_0);
  };
  Default.$metadata$ = {
    simpleName: 'Default',
    kind: 'object',
    interfaces: []
  };
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Random() {
    Default_getInstance();
  }
  Random.prototype.nextInt_9 = function () {
    return this.nextBits_1(32);
  };
  Random.prototype.nextInt_6 = function (until_0) {
    return this.nextInt_7(0, until_0);
  };
  Random.prototype.nextInt_7 = function (from, until_0) {
    checkRangeBounds(from, until_0);
    var n = until_0 - from | 0;
    if (n > 0 ? true : n === IntCompanionObject_getInstance()._MIN_VALUE) {
      var tmp;
      if ((n & (-n | 0)) === n) {
        var bitCount = fastLog2(n);
        tmp = this.nextBits_1(bitCount);
      } else {
        var v;
        do {
          var bits = this.nextInt_9() >>> 1;
          v = bits % n;
        }
         while (((bits - v | 0) + (n - 1 | 0) | 0) < 0);
        tmp = v;
      }
      var rnd = tmp;
      return from + rnd | 0;
    } else {
      while (true) {
        var rnd_0 = this.nextInt_9();
        if (from <= rnd_0 ? rnd_0 < until_0 : false)
          return rnd_0;
      }
    }
  };
  Random.$metadata$ = {
    simpleName: 'Random',
    kind: 'class',
    interfaces: []
  };
  function checkRangeBounds(from, until_0) {
    var tmp0_require_0 = until_0 > from;
    var tmp;
    if (!tmp0_require_0) {
      var message_2 = boundsErrorMessage(from, until_0);
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }return tmp;
  }
  function fastLog2(value) {
    return 31 - Math.clz32(value) | 0;
  }
  function boundsErrorMessage(from, until_0) {
    return '' + 'Random range is empty: [' + from + ', ' + until_0 + ').';
  }
  function Random_0(seed) {
    return XorWowRandom_init_$Create$(seed, seed >> 31);
  }
  function takeUpperBits(_this_, bitCount) {
    return _this_ >>> (32 - bitCount | 0) & (-bitCount | 0) >> 31;
  }
  function XorWowRandom_init_$Init$(seed1, seed2, $this) {
    XorWowRandom.call($this, seed1, seed2, 0, 0, ~seed1, seed1 << 10 ^ seed2 >>> 4);
    return $this;
  }
  function XorWowRandom_init_$Create$(seed1, seed2) {
    return XorWowRandom_init_$Init$(seed1, seed2, Object.create(XorWowRandom.prototype));
  }
  function XorWowRandom(x, y, z, w, v, addend) {
    Random.call(this);
    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;
    this._v = v;
    this._addend = addend;
    var tmp0_require_0 = !((this._x | this._y | this._z | this._w | this._v) === 0);
    if (!tmp0_require_0) {
      var message_2 = 'Initial state must have at least one non-zero element.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var tmp1_repeat_0 = 64;
    var inductionVariable = 0;
    if (inductionVariable < tmp1_repeat_0)
      do {
        var index_3 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.nextInt_9();
        Unit_getInstance();
      }
       while (inductionVariable < tmp1_repeat_0);
  }
  XorWowRandom.prototype.nextInt_9 = function () {
    var t = this._x;
    t = t ^ t >>> 2;
    this._x = this._y;
    this._y = this._z;
    this._z = this._w;
    var v0 = this._v;
    this._w = v0;
    t = t ^ t << 1 ^ v0 ^ v0 << 4;
    this._v = t;
    var tmp0_this = this;
    tmp0_this._addend = tmp0_this._addend + 362437 | 0;
    return t + this._addend | 0;
  };
  XorWowRandom.prototype.nextBits_1 = function (bitCount) {
    return takeUpperBits(this.nextInt_9(), bitCount);
  };
  XorWowRandom.$metadata$ = {
    simpleName: 'XorWowRandom',
    kind: 'class',
    interfaces: []
  };
  function KClassifier() {
  }
  KClassifier.$metadata$ = {
    simpleName: 'KClassifier',
    kind: 'interface',
    interfaces: []
  };
  function appendElement(_this_, element, transform) {
    if (!(transform == null)) {
      _this_.append_3(transform(element));
      Unit_getInstance();
    } else {
      if (element == null ? true : isCharSequence(element)) {
        _this_.append_3(element);
        Unit_getInstance();
      } else {
        if (element instanceof Char) {
          _this_.append_2(element);
          Unit_getInstance();
        } else {
          {
            _this_.append_3(toString_0(element));
            Unit_getInstance();
          }
        }
      }
    }
  }
  function equals(_this_, other, ignoreCase) {
    if (_this_.equals(other))
      return true;
    if (!ignoreCase)
      return false;
    if (uppercaseChar(_this_).equals(uppercaseChar(other)))
      return true;
    var tmp0_asDynamic_0 = _this_.toString();
    var tmp1_unsafeCast_0 = tmp0_asDynamic_0.toLowerCase().charCodeAt(0);
    var tmp = numberToChar(tmp1_unsafeCast_0);
    var tmp2_asDynamic_0 = other.toString();
    var tmp3_unsafeCast_0 = tmp2_asDynamic_0.toLowerCase().charCodeAt(0);
    if (tmp.equals(numberToChar(tmp3_unsafeCast_0)))
      return true;
    else {
    }
    return false;
  }
  function trimIndent(_this_) {
    return replaceIndent(_this_, '');
  }
  function replaceIndent(_this_, newIndent) {
    var lines_0 = lines(_this_);
    var tmp0_filterTo_0_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1_2 = lines_0.iterator_38();
    while (tmp0_iterator_1_2.hasNext_12()) {
      var element_2_3 = tmp0_iterator_1_2.next_14();
      if (isNotBlank(element_2_3)) {
        tmp0_filterTo_0_1.add_16(element_2_3);
        Unit_getInstance();
      }}
    var tmp0_map_0 = tmp0_filterTo_0_1;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2_0 = tmp0_map_0.iterator_38();
    while (tmp0_iterator_1_2_0.hasNext_12()) {
      var item_2_3 = tmp0_iterator_1_2_0.next_14();
      tmp0_mapTo_0_1.add_16(indentWidth(item_2_3));
      Unit_getInstance();
    }
    var tmp0_elvis_lhs = minOrNull(tmp0_mapTo_0_1);
    var minCommonIndent = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_reindent_0 = _this_.length + imul(newIndent.length, lines_0._get_size__26()) | 0;
    var tmp2_reindent_0 = getIndentFunction(newIndent);
    var lastIndex_1 = _get_lastIndex__0(lines_0);
    var tmp1_mapIndexedNotNullTo_0_1 = ArrayList_init_$Create$();
    var index_1_2 = 0;
    var tmp0_iterator_2_3 = lines_0.iterator_38();
    while (tmp0_iterator_2_3.hasNext_12()) {
      var item_3_4 = tmp0_iterator_2_3.next_14();
      var tmp1_4_6 = index_1_2;
      index_1_2 = tmp1_4_6 + 1 | 0;
      var tmp0__anonymous__1_5_5 = checkIndexOverflow(tmp1_4_6);
      var tmp;
      if ((tmp0__anonymous__1_5_5 === 0 ? true : tmp0__anonymous__1_5_5 === lastIndex_1) ? isBlank(item_3_4) : false) {
        tmp = null;
      } else {
        var tmp0_safe_receiver_4_10 = drop_0(item_3_4, minCommonIndent);
        var tmp_0;
        if (tmp0_safe_receiver_4_10 == null) {
          tmp_0 = null;
        } else {
          tmp_0 = tmp2_reindent_0(tmp0_safe_receiver_4_10);
        }
        var tmp1_elvis_lhs_3_9 = tmp_0;
        tmp = tmp1_elvis_lhs_3_9 == null ? item_3_4 : tmp1_elvis_lhs_3_9;
      }
      var tmp0_safe_receiver_2_6_7 = tmp;
      if (tmp0_safe_receiver_2_6_7 == null)
        null;
      else {
        tmp1_mapIndexedNotNullTo_0_1.add_16(tmp0_safe_receiver_2_6_7);
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    var tmp_1 = StringBuilder_init_$Create$(tmp1_reindent_0);
    return joinTo$default(tmp1_mapIndexedNotNullTo_0_1, tmp_1, '\n', null, null, 0, null, null, 124, null).toString();
  }
  function indentWidth(_this_) {
    var tmp$ret$0;
    l$ret$1: do {
      var inductionVariable = 0;
      var last_0 = charSequenceLength(_this_) - 1 | 0;
      if (inductionVariable <= last_0)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0__anonymous__3 = charSequenceGet(_this_, index_2);
          if (!isWhitespace(tmp0__anonymous__3)) {
            tmp$ret$0 = index_2;
            break l$ret$1;
          } else {
          }
        }
         while (inductionVariable <= last_0);
      tmp$ret$0 = -1;
    }
     while (false);
    var tmp1_let_0 = tmp$ret$0;
    return tmp1_let_0 === -1 ? _this_.length : tmp1_let_0;
  }
  function getIndentFunction(indent) {
    var tmp;
    if (charSequenceLength(indent) === 0) {
      tmp = _no_name_provided_$factory_1();
    } else {
      {
        tmp = _no_name_provided_$factory_2(indent);
      }
    }
    return tmp;
  }
  function _no_name_provided__5() {
  }
  _no_name_provided__5.prototype.invoke_5 = function (line) {
    return line;
  };
  _no_name_provided__5.prototype.invoke_293 = function (p1) {
    return this.invoke_5((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__5.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__6($indent) {
    this._$indent = $indent;
  }
  _no_name_provided__6.prototype.invoke_5 = function (line) {
    return this._$indent + line;
  };
  _no_name_provided__6.prototype.invoke_293 = function (p1) {
    return this.invoke_5((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__6.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_1() {
    var i = new _no_name_provided__5();
    return function (p1) {
      return i.invoke_5(p1);
    };
  }
  function _no_name_provided_$factory_2($indent) {
    var i = new _no_name_provided__6($indent);
    return function (p1) {
      return i.invoke_5(p1);
    };
  }
  function trim(_this_) {
    var startIndex_1 = 0;
    var endIndex_2 = charSequenceLength(_this_) - 1 | 0;
    var startFound_3 = false;
    $l$break: while (startIndex_1 <= endIndex_2) {
      var index_4 = !startFound_3 ? startIndex_1 : endIndex_2;
      var match_5 = isWhitespace(charSequenceGet(_this_, index_4));
      if (!startFound_3) {
        if (!match_5)
          startFound_3 = true;
        else
          startIndex_1 = startIndex_1 + 1 | 0;
      } else {
        if (!match_5)
          break $l$break;
        else
          endIndex_2 = endIndex_2 - 1 | 0;
      }
    }
    return charSequenceSubSequence(_this_, startIndex_1, endIndex_2 + 1 | 0);
  }
  function lines(_this_) {
    return toList_0(lineSequence(_this_));
  }
  function isNotBlank(_this_) {
    return !isBlank(_this_);
  }
  function _get_lastIndex__1(_this_) {
    return charSequenceLength(_this_) - 1 | 0;
  }
  function lineSequence(_this_) {
    var tmp = ['\r\n', '\n', '\r'];
    return splitToSequence$default(_this_, tmp, false, 0, 6, null);
  }
  function splitToSequence(_this_, delimiters, ignoreCase, limit) {
    var tmp = rangesDelimitedBy$default(_this_, delimiters, 0, ignoreCase, limit, 2, null);
    return map(tmp, _no_name_provided_$factory_3(_this_));
  }
  function splitToSequence$default(_this_, delimiters, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      ignoreCase = false;
    if (!(($mask0 & 4) === 0))
      limit = 0;
    return splitToSequence(_this_, delimiters, ignoreCase, limit);
  }
  function substring(_this_, range) {
    return toString_1(charSequenceSubSequence(_this_, range._get_start_(), range._get_endInclusive_() + 1 | 0));
  }
  function rangesDelimitedBy(_this_, delimiters, startIndex, ignoreCase, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_2 = '' + 'Limit must be non-negative, but was ' + limit + '.';
      throw IllegalArgumentException_init_$Create$(toString_1(message_2));
    }var delimitersList = asList(delimiters);
    return new DelimitedRangesSequence(_this_, startIndex, limit, _no_name_provided_$factory_4(delimitersList, ignoreCase));
  }
  function rangesDelimitedBy$default(_this_, delimiters, startIndex, ignoreCase, limit, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    if (!(($mask0 & 8) === 0))
      limit = 0;
    return rangesDelimitedBy(_this_, delimiters, startIndex, ignoreCase, limit);
  }
  function calcNext_0($this) {
    if ($this._nextSearchIndex < 0) {
      $this._nextState_0 = 0;
      $this._nextItem_0 = null;
    } else {
      var tmp;
      var tmp_0;
      if ($this._this$0_4._limit > 0) {
        var tmp0_this = $this;
        tmp0_this._counter = tmp0_this._counter + 1 | 0;
        tmp_0 = tmp0_this._counter >= $this._this$0_4._limit;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        {
          tmp = $this._nextSearchIndex > charSequenceLength($this._this$0_4._input);
        }
      }
      if (tmp) {
        $this._nextItem_0 = numberRangeToNumber($this._currentStartIndex, _get_lastIndex__1($this._this$0_4._input));
        $this._nextSearchIndex = -1;
      } else {
        {
          var match = $this._this$0_4._getNextMatch($this._this$0_4._input, $this._nextSearchIndex);
          if (match == null) {
            $this._nextItem_0 = numberRangeToNumber($this._currentStartIndex, _get_lastIndex__1($this._this$0_4._input));
            $this._nextSearchIndex = -1;
          } else {
            var tmp1_container = match;
            var index = tmp1_container.component1();
            var length = tmp1_container.component2();
            $this._nextItem_0 = until($this._currentStartIndex, index);
            $this._currentStartIndex = index + length | 0;
            $this._nextSearchIndex = $this._currentStartIndex + (length === 0 ? 1 : 0) | 0;
          }
        }
      }
      $this._nextState_0 = 1;
    }
  }
  function _no_name_provided__7(this$0) {
    this._this$0_4 = this$0;
    this._nextState_0 = -1;
    this._currentStartIndex = coerceIn(this._this$0_4._startIndex, 0, charSequenceLength(this._this$0_4._input));
    this._nextSearchIndex = this._currentStartIndex;
    this._nextItem_0 = null;
    this._counter = 0;
  }
  _no_name_provided__7.prototype.next_14 = function () {
    if (this._nextState_0 === -1)
      calcNext_0(this);
    if (this._nextState_0 === 0)
      throw NoSuchElementException_init_$Create$();
    var tmp = this._nextItem_0;
    var result = tmp instanceof IntRange ? tmp : THROW_CCE();
    this._nextItem_0 = null;
    this._nextState_0 = -1;
    return result;
  };
  _no_name_provided__7.prototype.hasNext_12 = function () {
    if (this._nextState_0 === -1)
      calcNext_0(this);
    return this._nextState_0 === 1;
  };
  _no_name_provided__7.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  function DelimitedRangesSequence(input, startIndex, limit, getNextMatch) {
    this._input = input;
    this._startIndex = startIndex;
    this._limit = limit;
    this._getNextMatch = getNextMatch;
  }
  DelimitedRangesSequence.prototype.iterator_38 = function () {
    return new _no_name_provided__7(this);
  };
  DelimitedRangesSequence.$metadata$ = {
    simpleName: 'DelimitedRangesSequence',
    kind: 'class',
    interfaces: [Sequence]
  };
  function findAnyOf(_this_, strings, startIndex, ignoreCase, last_0) {
    if (!ignoreCase ? strings._get_size__26() === 1 : false) {
      var string = single(strings);
      var tmp;
      if (!last_0) {
        tmp = indexOf$default(_this_, string, startIndex, false, 4, null);
      } else {
        tmp = lastIndexOf$default(_this_, string, startIndex, false, 4, null);
      }
      var index = tmp;
      return index < 0 ? null : to(index, string);
    }var indices = !last_0 ? numberRangeToNumber(coerceAtLeast(startIndex, 0), charSequenceLength(_this_)) : downTo(coerceAtMost(startIndex, _get_lastIndex__1(_this_)), 0);
    if (typeof _this_ === 'string') {
      var inductionVariable = indices._first_0;
      var last_1 = indices._last;
      var step = indices._step_0;
      if ((step > 0 ? inductionVariable <= last_1 : false) ? true : step < 0 ? last_1 <= inductionVariable : false)
        do {
          var index_0 = inductionVariable;
          inductionVariable = inductionVariable + step | 0;
          var tmp$ret$0;
          l$ret$1: do {
            var tmp0_iterator_1 = strings.iterator_38();
            while (tmp0_iterator_1.hasNext_12()) {
              var element_2 = tmp0_iterator_1.next_14();
              if (regionMatches(element_2, 0, _this_, index_0, element_2.length, ignoreCase)) {
                tmp$ret$0 = element_2;
                break l$ret$1;
              } else {
              }
            }
            tmp$ret$0 = null;
          }
           while (false);
          var matchingString = tmp$ret$0;
          if (!(matchingString == null))
            return to(index_0, matchingString);
        }
         while (!(index_0 === last_1));
    } else {
      {
        var inductionVariable_0 = indices._first_0;
        var last_2 = indices._last;
        var step_0 = indices._step_0;
        if ((step_0 > 0 ? inductionVariable_0 <= last_2 : false) ? true : step_0 < 0 ? last_2 <= inductionVariable_0 : false)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_0 | 0;
            var tmp$ret$2;
            l$ret$3: do {
              var tmp0_iterator_1_0 = strings.iterator_38();
              while (tmp0_iterator_1_0.hasNext_12()) {
                var element_2_0 = tmp0_iterator_1_0.next_14();
                if (regionMatchesImpl(element_2_0, 0, _this_, index_1, element_2_0.length, ignoreCase)) {
                  tmp$ret$2 = element_2_0;
                  break l$ret$3;
                } else {
                }
              }
              tmp$ret$2 = null;
            }
             while (false);
            var matchingString_0 = tmp$ret$2;
            if (!(matchingString_0 == null))
              return to(index_1, matchingString_0);
          }
           while (!(index_1 === last_2));
      }
    }
    return null;
  }
  function indexOf_0(_this_, string, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      var tmp_1 = charSequenceLength(_this_);
      tmp = indexOf$default_0(_this_, string, startIndex, tmp_1, ignoreCase, false, 16, null);
    } else {
      {
        var tmp0_nativeIndexOf_0 = _this_;
        tmp = tmp0_nativeIndexOf_0.indexOf(string, startIndex);
      }
    }
    return tmp;
  }
  function indexOf$default(_this_, string, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return indexOf_0(_this_, string, startIndex, ignoreCase);
  }
  function lastIndexOf(_this_, string, startIndex, ignoreCase) {
    var tmp;
    var tmp_0;
    if (ignoreCase) {
      tmp_0 = true;
    } else {
      tmp_0 = !(typeof _this_ === 'string');
    }
    if (tmp_0) {
      tmp = indexOf_1(_this_, string, startIndex, 0, ignoreCase, true);
    } else {
      {
        var tmp0_nativeLastIndexOf_0 = _this_;
        tmp = tmp0_nativeLastIndexOf_0.lastIndexOf(string, startIndex);
      }
    }
    return tmp;
  }
  function lastIndexOf$default(_this_, string, startIndex, ignoreCase, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = _get_lastIndex__1(_this_);
    if (!(($mask0 & 4) === 0))
      ignoreCase = false;
    return lastIndexOf(_this_, string, startIndex, ignoreCase);
  }
  function regionMatchesImpl(_this_, thisOffset, other, otherOffset, length, ignoreCase) {
    if (((otherOffset < 0 ? true : thisOffset < 0) ? true : thisOffset > (charSequenceLength(_this_) - length | 0)) ? true : otherOffset > (charSequenceLength(other) - length | 0)) {
      return false;
    }var inductionVariable = 0;
    if (inductionVariable < length)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(charSequenceGet(_this_, thisOffset + index | 0), charSequenceGet(other, otherOffset + index | 0), ignoreCase))
          return false;
      }
       while (inductionVariable < length);
    return true;
  }
  function indexOf_1(_this_, other, startIndex, endIndex, ignoreCase, last_0) {
    var indices = !last_0 ? numberRangeToNumber(coerceAtLeast(startIndex, 0), coerceAtMost(endIndex, charSequenceLength(_this_))) : downTo(coerceAtMost(startIndex, _get_lastIndex__1(_this_)), coerceAtLeast(endIndex, 0));
    var tmp;
    if (typeof _this_ === 'string') {
      tmp = typeof other === 'string';
    } else {
      {
        tmp = false;
      }
    }
    if (tmp) {
      var inductionVariable = indices._first_0;
      var last_1 = indices._last;
      var step = indices._step_0;
      if ((step > 0 ? inductionVariable <= last_1 : false) ? true : step < 0 ? last_1 <= inductionVariable : false)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + step | 0;
          if (regionMatches(other, 0, _this_, index, charSequenceLength(other), ignoreCase))
            return index;
        }
         while (!(index === last_1));
    } else {
      {
        var inductionVariable_0 = indices._first_0;
        var last_2 = indices._last;
        var step_0 = indices._step_0;
        if ((step_0 > 0 ? inductionVariable_0 <= last_2 : false) ? true : step_0 < 0 ? last_2 <= inductionVariable_0 : false)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_0 | 0;
            if (regionMatchesImpl(other, 0, _this_, index_0, charSequenceLength(other), ignoreCase))
              return index_0;
          }
           while (!(index_0 === last_2));
      }
    }
    return -1;
  }
  function indexOf$default_0(_this_, other, startIndex, endIndex, ignoreCase, last_0, $mask0, $handler) {
    if (!(($mask0 & 16) === 0))
      last_0 = false;
    return indexOf_1(_this_, other, startIndex, endIndex, ignoreCase, last_0);
  }
  function _no_name_provided__8($this_splitToSequence) {
    this._$this_splitToSequence = $this_splitToSequence;
  }
  _no_name_provided__8.prototype.invoke_7 = function (it) {
    return substring(this._$this_splitToSequence, it);
  };
  _no_name_provided__8.prototype.invoke_293 = function (p1) {
    return this.invoke_7(p1 instanceof IntRange ? p1 : THROW_CCE());
  };
  _no_name_provided__8.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__9($delimitersList, $ignoreCase) {
    this._$delimitersList = $delimitersList;
    this._$ignoreCase = $ignoreCase;
  }
  _no_name_provided__9.prototype.invoke_9 = function (_this__0, currentIndex) {
    var tmp0_safe_receiver = findAnyOf(_this__0, this._$delimitersList, currentIndex, this._$ignoreCase, false);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = to(tmp0_safe_receiver._first, tmp0_safe_receiver._second.length);
    }
    return tmp;
  };
  _no_name_provided__9.prototype.invoke_62 = function (p1, p2) {
    var tmp = (!(p1 == null) ? isCharSequence(p1) : false) ? p1 : THROW_CCE();
    return this.invoke_9(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__9.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_3($this_splitToSequence) {
    var i = new _no_name_provided__8($this_splitToSequence);
    return function (p1) {
      return i.invoke_7(p1);
    };
  }
  function _no_name_provided_$factory_4($delimitersList, $ignoreCase) {
    var i = new _no_name_provided__9($delimitersList, $ignoreCase);
    return function (p1, p2) {
      return i.invoke_9(p1, p2);
    };
  }
  function MatchResult() {
  }
  MatchResult.$metadata$ = {
    simpleName: 'MatchResult',
    kind: 'interface',
    interfaces: []
  };
  function MatchGroupCollection() {
  }
  MatchGroupCollection.$metadata$ = {
    simpleName: 'MatchGroupCollection',
    kind: 'interface',
    interfaces: [Collection]
  };
  function Pair(first_0, second) {
    this._first = first_0;
    this._second = second;
  }
  Pair.prototype.toString = function () {
    return '' + '(' + this._first + ', ' + this._second + ')';
  };
  Pair.prototype.component1 = function () {
    return this._first;
  };
  Pair.prototype.component2 = function () {
    return this._second;
  };
  Pair.prototype.hashCode = function () {
    var result = this._first == null ? 0 : hashCode(this._first);
    result = imul(result, 31) + (this._second == null ? 0 : hashCode(this._second)) | 0;
    return result;
  };
  Pair.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Pair))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof Pair ? other : THROW_CCE();
    if (!equals_0(this._first, tmp0_other_with_cast._first))
      return false;
    if (!equals_0(this._second, tmp0_other_with_cast._second))
      return false;
    return true;
  };
  Pair.$metadata$ = {
    simpleName: 'Pair',
    kind: 'class',
    interfaces: [Serializable]
  };
  function to(_this_, that) {
    return new Pair(_this_, that);
  }
  function _UShort___init__impl_(data) {
    return data;
  }
  function _UShort___get_data__impl_(this_0) {
    return this_0;
  }
  function CharSequence() {
  }
  CharSequence.$metadata$ = {
    simpleName: 'CharSequence',
    kind: 'interface',
    interfaces: []
  };
  function Comparable() {
  }
  Comparable.$metadata$ = {
    simpleName: 'Comparable',
    kind: 'interface',
    interfaces: []
  };
  function Iterator() {
  }
  Iterator.$metadata$ = {
    simpleName: 'Iterator',
    kind: 'interface',
    interfaces: []
  };
  function ListIterator() {
  }
  ListIterator.$metadata$ = {
    simpleName: 'ListIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function MutableIterator() {
  }
  MutableIterator.$metadata$ = {
    simpleName: 'MutableIterator',
    kind: 'interface',
    interfaces: [Iterator]
  };
  function Number_0() {
  }
  Number_0.$metadata$ = {
    simpleName: 'Number',
    kind: 'class',
    interfaces: []
  };
  function IntIterator() {
  }
  IntIterator.prototype.next_14 = function () {
    return this.nextInt_9();
  };
  IntIterator.$metadata$ = {
    simpleName: 'IntIterator',
    kind: 'class',
    interfaces: [Iterator]
  };
  function IntProgressionIterator(first_0, last_0, step) {
    IntIterator.call(this);
    this._step = step;
    this._finalElement = last_0;
    this._hasNext = this._step > 0 ? first_0 <= last_0 : first_0 >= last_0;
    this._next = this._hasNext ? first_0 : this._finalElement;
  }
  IntProgressionIterator.prototype.hasNext_12 = function () {
    return this._hasNext;
  };
  IntProgressionIterator.prototype.nextInt_9 = function () {
    var value = this._next;
    if (value === this._finalElement) {
      if (!this._hasNext)
        throw NoSuchElementException_init_$Create$();
      this._hasNext = false;
    } else {
      var tmp0_this = this;
      tmp0_this._next = tmp0_this._next + this._step | 0;
    }
    return value;
  };
  IntProgressionIterator.$metadata$ = {
    simpleName: 'IntProgressionIterator',
    kind: 'class',
    interfaces: []
  };
  function Companion_3() {
    Companion_instance_2 = this;
  }
  Companion_3.prototype.fromClosedRange = function (rangeStart, rangeEnd, step) {
    return new IntProgression(rangeStart, rangeEnd, step);
  };
  Companion_3.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_3();
    return Companion_instance_2;
  }
  function IntProgression(start, endInclusive, step) {
    Companion_getInstance_2();
    if (step === 0)
      throw IllegalArgumentException_init_$Create$('Step must be non-zero.');
    if (step === IntCompanionObject_getInstance()._MIN_VALUE)
      throw IllegalArgumentException_init_$Create$('Step must be greater than Int.MIN_VALUE to avoid overflow on negation.');
    this._first_0 = start;
    this._last = getProgressionLastElement(start, endInclusive, step);
    this._step_0 = step;
  }
  IntProgression.prototype._get_first__0 = function () {
    return this._first_0;
  };
  IntProgression.prototype._get_last__0 = function () {
    return this._last;
  };
  IntProgression.prototype.iterator_38 = function () {
    return new IntProgressionIterator(this._first_0, this._last, this._step_0);
  };
  IntProgression.prototype.isEmpty_26 = function () {
    return this._step_0 > 0 ? this._first_0 > this._last : this._first_0 < this._last;
  };
  IntProgression.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntProgression) {
      tmp = (this.isEmpty_26() ? other.isEmpty_26() : false) ? true : (this._first_0 === other._first_0 ? this._last === other._last : false) ? this._step_0 === other._step_0 : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntProgression.prototype.hashCode = function () {
    return this.isEmpty_26() ? -1 : imul(31, imul(31, this._first_0) + this._last | 0) + this._step_0 | 0;
  };
  IntProgression.prototype.toString = function () {
    return this._step_0 > 0 ? '' + this._first_0 + '..' + this._last + ' step ' + this._step_0 : '' + this._first_0 + ' downTo ' + this._last + ' step ' + (-this._step_0 | 0);
  };
  IntProgression.$metadata$ = {
    simpleName: 'IntProgression',
    kind: 'class',
    interfaces: [Iterable]
  };
  function ClosedRange() {
  }
  ClosedRange.$metadata$ = {
    simpleName: 'ClosedRange',
    kind: 'interface',
    interfaces: []
  };
  function Companion_4() {
    Companion_instance_3 = this;
    this._EMPTY = new IntRange(1, 0);
  }
  Companion_4.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_4();
    return Companion_instance_3;
  }
  function IntRange(start, endInclusive) {
    Companion_getInstance_3();
    IntProgression.call(this, start, endInclusive, 1);
  }
  IntRange.prototype._get_start_ = function () {
    return this._get_first__0();
  };
  IntRange.prototype._get_endInclusive_ = function () {
    return this._get_last__0();
  };
  IntRange.prototype.isEmpty_26 = function () {
    return this._get_first__0() > this._get_last__0();
  };
  IntRange.prototype.equals = function (other) {
    var tmp;
    if (other instanceof IntRange) {
      tmp = (this.isEmpty_26() ? other.isEmpty_26() : false) ? true : this._get_first__0() === other._get_first__0() ? this._get_last__0() === other._get_last__0() : false;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  IntRange.prototype.hashCode = function () {
    return this.isEmpty_26() ? -1 : imul(31, this._get_first__0()) + this._get_last__0() | 0;
  };
  IntRange.prototype.toString = function () {
    return '' + this._get_first__0() + '..' + this._get_last__0();
  };
  IntRange.$metadata$ = {
    simpleName: 'IntRange',
    kind: 'class',
    interfaces: [ClosedRange]
  };
  function Unit() {
    Unit_instance = this;
  }
  Unit.prototype.toString = function () {
    return 'kotlin.Unit';
  };
  Unit.$metadata$ = {
    simpleName: 'Unit',
    kind: 'object',
    interfaces: []
  };
  var Unit_instance;
  function Unit_getInstance() {
    if (Unit_instance == null)
      new Unit();
    return Unit_instance;
  }
  function getProgressionLastElement(start, end, step) {
    var tmp;
    if (step > 0) {
      tmp = start >= end ? end : end - differenceModulo(end, start, step) | 0;
    } else if (step < 0) {
      tmp = start <= end ? end : end + differenceModulo(start, end, -step | 0) | 0;
    } else {
      throw IllegalArgumentException_init_$Create$('Step is zero.');
    }
    return tmp;
  }
  function differenceModulo(a, b, c) {
    return mod(mod(a, c) - mod(b, c) | 0, c);
  }
  function mod(a, b) {
    var mod_0 = a % b;
    return mod_0 >= 0 ? mod_0 : mod_0 + b | 0;
  }
  function IntCompanionObject_0() {
    IntCompanionObject_instance = this;
    this._MIN_VALUE = -2147483648;
    this._MAX_VALUE = 2147483647;
    this._SIZE_BYTES = 4;
    this._SIZE_BITS = 32;
  }
  IntCompanionObject_0.prototype._get_MIN_VALUE_ = function () {
    return this._MIN_VALUE;
  };
  IntCompanionObject_0.prototype._get_MAX_VALUE_ = function () {
    return this._MAX_VALUE;
  };
  IntCompanionObject_0.prototype._get_SIZE_BYTES_ = function () {
    return this._SIZE_BYTES;
  };
  IntCompanionObject_0.prototype._get_SIZE_BITS_ = function () {
    return this._SIZE_BITS;
  };
  IntCompanionObject_0.$metadata$ = {
    simpleName: 'IntCompanionObject',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(IntCompanionObject_0.prototype, 'MIN_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MIN_VALUE_
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'MAX_VALUE', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_MAX_VALUE_
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BYTES', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BYTES_
  });
  Object.defineProperty(IntCompanionObject_0.prototype, 'SIZE_BITS', {
    configurable: true,
    get: IntCompanionObject_0.prototype._get_SIZE_BITS_
  });
  var IntCompanionObject_instance;
  function IntCompanionObject_getInstance() {
    if (IntCompanionObject_instance == null)
      new IntCompanionObject_0();
    return IntCompanionObject_instance;
  }
  function mapCapacity(expectedSize) {
    return expectedSize;
  }
  function listOf(element) {
    return arrayListOf([element]);
  }
  function setOf(element) {
    return hashSetOf([element]);
  }
  function copyToArray_0(collection) {
    var tmp;
    if (collection.toArray !== undefined) {
      var tmp0_unsafeCast_0 = collection.toArray();
      tmp = tmp0_unsafeCast_0;
    } else {
      {
        var tmp1_unsafeCast_0 = copyToArrayImpl_0(collection);
        tmp = tmp1_unsafeCast_0;
      }
    }
    return tmp;
  }
  function copyToArrayImpl_0(collection) {
    var array = [];
    var iterator = collection.iterator_38();
    while (iterator.hasNext_12()) {
      array.push(iterator.next_14());
    }
    return array;
  }
  function checkIndexOverflow(index) {
    if (index < 0) {
      throwIndexOverflow();
    }return index;
  }
  function AbstractMutableCollection() {
    AbstractCollection.call(this);
  }
  AbstractMutableCollection.prototype.remove_12 = function (element) {
    this.checkIsMutable_11();
    var iterator = this.iterator_38();
    while (iterator.hasNext_12()) {
      if (equals_0(iterator.next_14(), element)) {
        iterator.remove_10();
        return true;
      }}
    return false;
  };
  AbstractMutableCollection.prototype.addAll_1 = function (elements) {
    this.checkIsMutable_11();
    var modified = false;
    var tmp0_iterator = elements.iterator_38();
    while (tmp0_iterator.hasNext_12()) {
      var element = tmp0_iterator.next_14();
      if (this.add_16(element))
        modified = true;
    }
    return modified;
  };
  AbstractMutableCollection.prototype.toJSON = function () {
    return this.toArray();
  };
  AbstractMutableCollection.prototype.checkIsMutable_11 = function () {
  };
  AbstractMutableCollection.$metadata$ = {
    simpleName: 'AbstractMutableCollection',
    kind: 'class',
    interfaces: [MutableCollection]
  };
  function IteratorImpl($outer) {
    this._$this = $outer;
    this._index = 0;
    this._last_0 = -1;
  }
  IteratorImpl.prototype.hasNext_12 = function () {
    return this._index < this._$this._get_size__26();
  };
  IteratorImpl.prototype.next_14 = function () {
    if (!this.hasNext_12())
      throw NoSuchElementException_init_$Create$();
    var tmp = this;
    var tmp0_this = this;
    var tmp1 = tmp0_this._index;
    tmp0_this._index = tmp1 + 1 | 0;
    tmp._last_0 = tmp1;
    return this._$this.get_36(this._last_0);
  };
  IteratorImpl.prototype.remove_10 = function () {
    var tmp0_check_0 = !(this._last_0 === -1);
    if (!tmp0_check_0) {
      var message_1 = 'Call next() or previous() before removing element from the iterator.';
      throw IllegalStateException_init_$Create$(toString_1(message_1));
    }this._$this.removeAt_0(this._last_0);
    Unit_getInstance();
    this._index = this._last_0;
    this._last_0 = -1;
  };
  IteratorImpl.$metadata$ = {
    simpleName: 'IteratorImpl',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function AbstractMutableList() {
    AbstractMutableCollection.call(this);
    this._modCount = 0;
  }
  AbstractMutableList.prototype._set_modCount__0 = function (_set___) {
    this._modCount = _set___;
  };
  AbstractMutableList.prototype._get_modCount__0 = function () {
    return this._modCount;
  };
  AbstractMutableList.prototype.add_16 = function (element) {
    this.checkIsMutable_11();
    this.add_8(this._get_size__26(), element);
    return true;
  };
  AbstractMutableList.prototype.iterator_38 = function () {
    return new IteratorImpl(this);
  };
  AbstractMutableList.prototype.contains_14 = function (element) {
    return this.indexOf_0(element) >= 0;
  };
  AbstractMutableList.prototype.indexOf_0 = function (element) {
    var inductionVariable = 0;
    var last_0 = _get_lastIndex__0(this);
    if (inductionVariable <= last_0)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_0(this.get_36(index), element)) {
          return index;
        }}
       while (!(index === last_0));
    return -1;
  };
  AbstractMutableList.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, List) : false))
      return false;
    else {
    }
    return Companion_getInstance().orderedEquals(this, other);
  };
  AbstractMutableList.prototype.hashCode = function () {
    return Companion_getInstance().orderedHashCode(this);
  };
  AbstractMutableList.$metadata$ = {
    simpleName: 'AbstractMutableList',
    kind: 'class',
    interfaces: [MutableList]
  };
  function _no_name_provided__10($entryIterator) {
    this._$entryIterator = $entryIterator;
  }
  _no_name_provided__10.prototype.hasNext_12 = function () {
    return this._$entryIterator.hasNext_12();
  };
  _no_name_provided__10.prototype.next_14 = function () {
    return this._$entryIterator.next_14()._get_key__3();
  };
  _no_name_provided__10.prototype.remove_10 = function () {
    return this._$entryIterator.remove_10();
  };
  _no_name_provided__10.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function SimpleEntry(key, value) {
    this._key = key;
    this.__value = value;
  }
  SimpleEntry.prototype._get_key__3 = function () {
    return this._key;
  };
  SimpleEntry.prototype._get_value__3 = function () {
    return this.__value;
  };
  SimpleEntry.prototype.setValue_1 = function (newValue) {
    var oldValue = this.__value;
    this.__value = newValue;
    return oldValue;
  };
  SimpleEntry.prototype.hashCode = function () {
    return Companion_getInstance_0().entryHashCode(this);
  };
  SimpleEntry.prototype.toString = function () {
    return Companion_getInstance_0().entryToString(this);
  };
  SimpleEntry.prototype.equals = function (other) {
    return Companion_getInstance_0().entryEquals(this, other);
  };
  SimpleEntry.$metadata$ = {
    simpleName: 'SimpleEntry',
    kind: 'class',
    interfaces: [MutableEntry]
  };
  function AbstractEntrySet() {
    AbstractMutableSet.call(this);
  }
  AbstractEntrySet.prototype.contains_14 = function (element) {
    return this.containsEntry_4(element);
  };
  AbstractEntrySet.$metadata$ = {
    simpleName: 'AbstractEntrySet',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__11(this$0) {
    this._this$0_5 = this$0;
    AbstractMutableSet.call(this);
  }
  _no_name_provided__11.prototype.add_4 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on keys');
  };
  _no_name_provided__11.prototype.add_16 = function (element) {
    return this.add_4((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__11.prototype.contains_12 = function (element) {
    return this._this$0_5.containsKey_9(element);
  };
  _no_name_provided__11.prototype.contains_14 = function (element) {
    if (!(element == null ? true : isObject(element)))
      return false;
    else {
    }
    return this.contains_12((element == null ? true : isObject(element)) ? element : THROW_CCE());
  };
  _no_name_provided__11.prototype.iterator_38 = function () {
    var entryIterator = this._this$0_5._get_entries__7().iterator_38();
    return new _no_name_provided__10(entryIterator);
  };
  _no_name_provided__11.prototype._get_size__26 = function () {
    return this._this$0_5._get_size__26();
  };
  _no_name_provided__11.prototype.checkIsMutable_11 = function () {
    return this._this$0_5.checkIsMutable_11();
  };
  _no_name_provided__11.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function AbstractMutableMap() {
    AbstractMap.call(this);
    this.__keys_0 = null;
    this.__values_0 = null;
  }
  AbstractMutableMap.prototype._get_keys__1 = function () {
    if (this.__keys_0 == null) {
      var tmp = this;
      tmp.__keys_0 = new _no_name_provided__11(this);
    }return ensureNotNull(this.__keys_0);
  };
  AbstractMutableMap.prototype.putAll_0 = function (from) {
    this.checkIsMutable_11();
    var tmp0_iterator = from._get_entries__7().iterator_38();
    while (tmp0_iterator.hasNext_12()) {
      var tmp1_loop_parameter = tmp0_iterator.next_14();
      var key = tmp1_loop_parameter._get_key__3();
      var value = tmp1_loop_parameter._get_value__3();
      this.put_7(key, value);
      Unit_getInstance();
    }
  };
  AbstractMutableMap.prototype.checkIsMutable_11 = function () {
  };
  AbstractMutableMap.$metadata$ = {
    simpleName: 'AbstractMutableMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function AbstractMutableSet() {
    AbstractMutableCollection.call(this);
  }
  AbstractMutableSet.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(!(other == null) ? isInterface(other, Set) : false))
      return false;
    else {
    }
    return Companion_getInstance_1().setEquals(this, other);
  };
  AbstractMutableSet.prototype.hashCode = function () {
    return Companion_getInstance_1().unorderedHashCode(this);
  };
  AbstractMutableSet.$metadata$ = {
    simpleName: 'AbstractMutableSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function ArrayList_init_$Init$($this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$() {
    return ArrayList_init_$Init$(Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_0(initialCapacity, $this) {
    ArrayList.call($this, []);
    return $this;
  }
  function ArrayList_init_$Create$_0(initialCapacity) {
    return ArrayList_init_$Init$_0(initialCapacity, Object.create(ArrayList.prototype));
  }
  function ArrayList_init_$Init$_1(elements, $this) {
    ArrayList.call($this, copyToArray_0(elements));
    return $this;
  }
  function ArrayList_init_$Create$_1(elements) {
    return ArrayList_init_$Init$_1(elements, Object.create(ArrayList.prototype));
  }
  function rangeCheck($this, index) {
    Companion_getInstance().checkElementIndex(index, $this._get_size__26());
    return index;
  }
  function insertionRangeCheck($this, index) {
    Companion_getInstance().checkPositionIndex(index, $this._get_size__26());
    return index;
  }
  function ArrayList(array) {
    AbstractMutableList.call(this);
    this._array = array;
    this._isReadOnly = false;
  }
  ArrayList.prototype._get_size__26 = function () {
    return this._array.length;
  };
  ArrayList.prototype.get_36 = function (index) {
    var tmp = this._array[rangeCheck(this, index)];
    return (tmp == null ? true : isObject(tmp)) ? tmp : THROW_CCE();
  };
  ArrayList.prototype.add_16 = function (element) {
    this.checkIsMutable_11();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.push(element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    return true;
  };
  ArrayList.prototype.add_8 = function (index, element) {
    this.checkIsMutable_11();
    var tmp0_asDynamic_0 = this._array;
    tmp0_asDynamic_0.splice(insertionRangeCheck(this, index), 0, element);
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
  };
  ArrayList.prototype.removeAt_0 = function (index) {
    this.checkIsMutable_11();
    rangeCheck(this, index);
    Unit_getInstance();
    var tmp0_this = this;
    var tmp1 = tmp0_this._get_modCount__0();
    tmp0_this._set_modCount__0(tmp1 + 1 | 0);
    Unit_getInstance();
    var tmp;
    if (index === _get_lastIndex__0(this)) {
      var tmp0_asDynamic_0 = this._array;
      tmp = tmp0_asDynamic_0.pop();
    } else {
      var tmp1_asDynamic_0 = this._array;
      tmp = tmp1_asDynamic_0.splice(index, 1)[0];
    }
    return tmp;
  };
  ArrayList.prototype.remove_12 = function (element) {
    this.checkIsMutable_11();
    var inductionVariable = 0;
    var last_0 = this._array.length - 1 | 0;
    if (inductionVariable <= last_0)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals_0(this._array[index], element)) {
          var tmp0_asDynamic_0 = this._array;
          tmp0_asDynamic_0.splice(index, 1);
          var tmp1_this = this;
          var tmp2 = tmp1_this._get_modCount__0();
          tmp1_this._set_modCount__0(tmp2 + 1 | 0);
          Unit_getInstance();
          return true;
        }}
       while (inductionVariable <= last_0);
    return false;
  };
  ArrayList.prototype.indexOf_0 = function (element) {
    return indexOf(this._array, element);
  };
  ArrayList.prototype.toString = function () {
    return arrayToString(this._array);
  };
  ArrayList.prototype.toArray_0 = function () {
    return [].slice.call(this._array);
  };
  ArrayList.prototype.toArray = function () {
    return this.toArray_0();
  };
  ArrayList.prototype.checkIsMutable_11 = function () {
    if (this._isReadOnly)
      throw UnsupportedOperationException_init_$Create$();
  };
  ArrayList.$metadata$ = {
    simpleName: 'ArrayList',
    kind: 'class',
    interfaces: [MutableList, RandomAccess]
  };
  function HashCode() {
    HashCode_instance = this;
  }
  HashCode.prototype.equals_1 = function (value1, value2) {
    return equals_0(value1, value2);
  };
  HashCode.prototype.getHashCode_0 = function (value) {
    var tmp0_safe_receiver = value;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  HashCode.$metadata$ = {
    simpleName: 'HashCode',
    kind: 'object',
    interfaces: [EqualityComparator]
  };
  var HashCode_instance;
  function HashCode_getInstance() {
    if (HashCode_instance == null)
      new HashCode();
    return HashCode_instance;
  }
  function EqualityComparator() {
  }
  EqualityComparator.$metadata$ = {
    simpleName: 'EqualityComparator',
    kind: 'interface',
    interfaces: []
  };
  function EntrySet($outer) {
    this._$this_0 = $outer;
    AbstractEntrySet.call(this);
  }
  EntrySet.prototype.add_12 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet.prototype.add_16 = function (element) {
    return this.add_12((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet.prototype.containsEntry_4 = function (element) {
    return this._$this_0.containsEntry_5(element);
  };
  EntrySet.prototype.iterator_38 = function () {
    return this._$this_0._internalMap.iterator_38();
  };
  EntrySet.prototype._get_size__26 = function () {
    return this._$this_0._get_size__26();
  };
  EntrySet.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function HashMap_init_$Init$(internalMap, $this) {
    AbstractMutableMap.call($this);
    HashMap.call($this);
    $this._internalMap = internalMap;
    $this._equality = internalMap._get_equality__0();
    return $this;
  }
  function HashMap_init_$Init$_0($this) {
    HashMap_init_$Init$(new InternalHashCodeMap(HashCode_getInstance()), $this);
    return $this;
  }
  function HashMap_init_$Create$() {
    return HashMap_init_$Init$_0(Object.create(HashMap.prototype));
  }
  function HashMap_init_$Init$_1(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_0($this);
    var tmp0_require_0 = initialCapacity >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Negative initial capacity: ' + initialCapacity;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_require_0 = loadFactor >= 0;
    if (!tmp1_require_0) {
      var message_1_0 = '' + 'Non-positive load factor: ' + loadFactor;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1_0));
    }return $this;
  }
  function HashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return HashMap_init_$Init$_1(initialCapacity, loadFactor, Object.create(HashMap.prototype));
  }
  HashMap.prototype.containsKey_9 = function (key) {
    return this._internalMap.contains_12(key);
  };
  HashMap.prototype._get_entries__7 = function () {
    if (this.__entries == null) {
      this.__entries = this.createEntrySet_0();
    }return ensureNotNull(this.__entries);
  };
  HashMap.prototype.createEntrySet_0 = function () {
    return new EntrySet(this);
  };
  HashMap.prototype.get_25 = function (key) {
    return this._internalMap.get_25(key);
  };
  HashMap.prototype.put_7 = function (key, value) {
    return this._internalMap.put_7(key, value);
  };
  HashMap.prototype.remove_11 = function (key) {
    return this._internalMap.remove_11(key);
  };
  HashMap.prototype._get_size__26 = function () {
    return this._internalMap._get_size__26();
  };
  function HashMap() {
    this.__entries = null;
  }
  HashMap.$metadata$ = {
    simpleName: 'HashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function HashSet_init_$Init$(initialCapacity, loadFactor, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = HashMap_init_$Create$_0(initialCapacity, loadFactor);
    return $this;
  }
  function HashSet_init_$Init$_0(initialCapacity, $this) {
    HashSet_init_$Init$(initialCapacity, 0.0, $this);
    return $this;
  }
  function HashSet_init_$Create$(initialCapacity) {
    return HashSet_init_$Init$_0(initialCapacity, Object.create(HashSet.prototype));
  }
  function HashSet_init_$Init$_1(map_0, $this) {
    AbstractMutableSet.call($this);
    HashSet.call($this);
    $this._map = map_0;
    return $this;
  }
  HashSet.prototype._get_map__0 = function () {
    return this._map;
  };
  HashSet.prototype.add_16 = function (element) {
    var old = this._map.put_7(element, this);
    return old == null;
  };
  HashSet.prototype.contains_14 = function (element) {
    return this._map.containsKey_9(element);
  };
  HashSet.prototype.isEmpty_26 = function () {
    return this._map.isEmpty_26();
  };
  HashSet.prototype.iterator_38 = function () {
    return this._map._get_keys__1().iterator_38();
  };
  HashSet.prototype._get_size__26 = function () {
    return this._map._get_size__26();
  };
  function HashSet() {
  }
  HashSet.$metadata$ = {
    simpleName: 'HashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function computeNext($this) {
    if ($this._chainOrEntry != null ? $this._isChain : false) {
      var tmp0_unsafeCast_0 = $this._chainOrEntry;
      var chainSize = tmp0_unsafeCast_0.length;
      var tmp0_this = $this;
      tmp0_this._itemIndex = tmp0_this._itemIndex + 1 | 0;
      if (tmp0_this._itemIndex < chainSize)
        return 0;
      else {
      }
    }var tmp1_this = $this;
    tmp1_this._keyIndex = tmp1_this._keyIndex + 1 | 0;
    if (tmp1_this._keyIndex < $this._keys.length) {
      $this._chainOrEntry = $this._this$0_6._backingMap[$this._keys[$this._keyIndex]];
      var tmp = $this;
      var tmp_0 = $this._chainOrEntry;
      tmp._isChain = !(tmp_0 == null) ? isArray(tmp_0) : false;
      $this._itemIndex = 0;
      return 0;
    } else {
      {
        $this._chainOrEntry = null;
        return 1;
      }
    }
  }
  function getEntry($this, key) {
    var tmp0_elvis_lhs = getChainOrEntryOrNull($this, $this._equality_0.getHashCode_0(key));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if ($this._equality_0.equals_1(entry._get_key__3(), key)) {
        return entry;
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        return findEntryInChain(chain, $this, key);
      }
    }
  }
  function findEntryInChain(_this_, $this, key) {
    var tmp$ret$0;
    l$ret$1: do {
      var indexedObject = _this_;
      var inductionVariable = 0;
      var last_0 = indexedObject.length;
      while (inductionVariable < last_0) {
        var element_2 = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if ($this._equality_0.equals_1(element_2._get_key__3(), key)) {
          tmp$ret$0 = element_2;
          break l$ret$1;
        } else {
        }
      }
      tmp$ret$0 = null;
    }
     while (false);
    return tmp$ret$0;
  }
  function getChainOrEntryOrNull($this, hashCode_1) {
    var chainOrEntry = $this._backingMap[hashCode_1];
    return chainOrEntry === undefined ? null : chainOrEntry;
  }
  function _no_name_provided__12(this$0) {
    this._this$0_6 = this$0;
    this._state = -1;
    this._keys = Object.keys(this._this$0_6._backingMap);
    this._keyIndex = -1;
    this._chainOrEntry = null;
    this._isChain = false;
    this._itemIndex = -1;
    this._lastEntry = null;
  }
  _no_name_provided__12.prototype.hasNext_12 = function () {
    if (this._state === -1)
      this._state = computeNext(this);
    return this._state === 0;
  };
  _no_name_provided__12.prototype.next_14 = function () {
    if (!this.hasNext_12())
      throw NoSuchElementException_init_$Create$();
    var tmp;
    if (this._isChain) {
      var tmp0_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp0_unsafeCast_0[this._itemIndex];
    } else {
      var tmp1_unsafeCast_0 = this._chainOrEntry;
      tmp = tmp1_unsafeCast_0;
    }
    var lastEntry = tmp;
    this._lastEntry = lastEntry;
    this._state = -1;
    return lastEntry;
  };
  _no_name_provided__12.prototype.remove_10 = function () {
    var tmp0_checkNotNull_0 = this._lastEntry;
    var tmp$ret$0;
    l$ret$1: do {
      if (tmp0_checkNotNull_0 == null) {
        var message_2_1 = 'Required value was null.';
        throw IllegalStateException_init_$Create$(toString_1(message_2_1));
      } else {
        tmp$ret$0 = tmp0_checkNotNull_0;
        break l$ret$1;
      }
    }
     while (false);
    Unit_getInstance();
    this._this$0_6.remove_11(ensureNotNull(this._lastEntry)._get_key__3());
    Unit_getInstance();
    this._lastEntry = null;
    var tmp0_this = this;
    var tmp1 = tmp0_this._itemIndex;
    tmp0_this._itemIndex = tmp1 - 1 | 0;
    Unit_getInstance();
  };
  _no_name_provided__12.$metadata$ = {
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function InternalHashCodeMap(equality) {
    this._equality_0 = equality;
    this._backingMap = this.createJsMap_0();
    this._size = 0;
  }
  InternalHashCodeMap.prototype._get_equality__0 = function () {
    return this._equality_0;
  };
  InternalHashCodeMap.prototype._get_size__26 = function () {
    return this._size;
  };
  InternalHashCodeMap.prototype.put_7 = function (key, value) {
    var hashCode_1 = this._equality_0.getHashCode_0(key);
    var chainOrEntry = getChainOrEntryOrNull(this, hashCode_1);
    if (chainOrEntry == null) {
      this._backingMap[hashCode_1] = new SimpleEntry(key, value);
    } else {
      if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
        var entry = chainOrEntry;
        if (this._equality_0.equals_1(entry._get_key__3(), key)) {
          return entry.setValue_1(value);
        } else {
          var tmp0_arrayOf_0 = [entry, new SimpleEntry(key, value)];
          this._backingMap[hashCode_1] = tmp0_arrayOf_0;
          var tmp0_this = this;
          var tmp1 = tmp0_this._size;
          tmp0_this._size = tmp1 + 1 | 0;
          Unit_getInstance();
          return null;
        }
      } else {
        {
          var chain = chainOrEntry;
          var entry_0 = findEntryInChain(chain, this, key);
          if (!(entry_0 == null)) {
            return entry_0.setValue_1(value);
          }chain.push(new SimpleEntry(key, value));
        }
      }
    }
    var tmp2_this = this;
    var tmp3 = tmp2_this._size;
    tmp2_this._size = tmp3 + 1 | 0;
    Unit_getInstance();
    return null;
  };
  InternalHashCodeMap.prototype.remove_11 = function (key) {
    var hashCode_1 = this._equality_0.getHashCode_0(key);
    var tmp0_elvis_lhs = getChainOrEntryOrNull(this, hashCode_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var chainOrEntry = tmp;
    if (!(!(chainOrEntry == null) ? isArray(chainOrEntry) : false)) {
      var entry = chainOrEntry;
      if (this._equality_0.equals_1(entry._get_key__3(), key)) {
        jsDeleteProperty(this._backingMap, hashCode_1);
        var tmp1_this = this;
        var tmp2 = tmp1_this._size;
        tmp1_this._size = tmp2 - 1 | 0;
        Unit_getInstance();
        return entry._get_value__3();
      } else {
        return null;
      }
    } else {
      {
        var chain = chainOrEntry;
        var inductionVariable = 0;
        var last_0 = chain.length - 1 | 0;
        if (inductionVariable <= last_0)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var entry_0 = chain[index];
            if (this._equality_0.equals_1(key, entry_0._get_key__3())) {
              if (chain.length === 1) {
                chain.length = 0;
                jsDeleteProperty(this._backingMap, hashCode_1);
              } else {
                chain.splice(index, 1);
              }
              var tmp4_this = this;
              var tmp5 = tmp4_this._size;
              tmp4_this._size = tmp5 - 1 | 0;
              Unit_getInstance();
              return entry_0._get_value__3();
            }}
           while (inductionVariable <= last_0);
      }
    }
    return null;
  };
  InternalHashCodeMap.prototype.contains_12 = function (key) {
    return !(getEntry(this, key) == null);
  };
  InternalHashCodeMap.prototype.get_25 = function (key) {
    var tmp0_safe_receiver = getEntry(this, key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__3();
  };
  InternalHashCodeMap.prototype.iterator_38 = function () {
    return new _no_name_provided__12(this);
  };
  InternalHashCodeMap.$metadata$ = {
    simpleName: 'InternalHashCodeMap',
    kind: 'class',
    interfaces: [InternalMap]
  };
  function InternalMap() {
  }
  InternalMap.prototype.createJsMap_0 = function () {
    var result = Object.create(null);
    result['foo'] = 1;
    jsDeleteProperty(result, 'foo');
    return result;
  };
  InternalMap.$metadata$ = {
    simpleName: 'InternalMap',
    kind: 'interface',
    interfaces: [MutableIterable]
  };
  function EntryIterator($outer) {
    this._$this_1 = $outer;
    this._last_1 = null;
    this._next_0 = null;
    this._next_0 = this._$this_1._$this_3._head;
  }
  EntryIterator.prototype.hasNext_12 = function () {
    return !(this._next_0 === null);
  };
  EntryIterator.prototype.next_14 = function () {
    if (!this.hasNext_12())
      throw NoSuchElementException_init_$Create$();
    var current = ensureNotNull(this._next_0);
    this._last_1 = current;
    var tmp = this;
    var tmp0_takeIf_0 = current._next_1;
    var tmp_0;
    if (!(tmp0_takeIf_0 === this._$this_1._$this_3._head)) {
      tmp_0 = tmp0_takeIf_0;
    } else {
      {
        tmp_0 = null;
      }
    }
    tmp._next_0 = tmp_0;
    return current;
  };
  EntryIterator.prototype.remove_10 = function () {
    var tmp0_check_0 = !(this._last_1 == null);
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString_1(message_2_1));
    }this._$this_1.checkIsMutable_11();
    remove(ensureNotNull(this._last_1), this._$this_1._$this_3);
    this._$this_1._$this_3._map_0.remove_11(ensureNotNull(this._last_1)._get_key__3());
    Unit_getInstance();
    this._last_1 = null;
  };
  EntryIterator.$metadata$ = {
    simpleName: 'EntryIterator',
    kind: 'class',
    interfaces: [MutableIterator]
  };
  function ChainEntry($outer, key, value) {
    this._$this_2 = $outer;
    SimpleEntry.call(this, key, value);
    this._next_1 = null;
    this._prev = null;
  }
  ChainEntry.prototype.setValue_1 = function (newValue) {
    this._$this_2.checkIsMutable_11();
    return SimpleEntry.prototype.setValue_1.call(this, newValue);
  };
  ChainEntry.$metadata$ = {
    simpleName: 'ChainEntry',
    kind: 'class',
    interfaces: []
  };
  function EntrySet_0($outer) {
    this._$this_3 = $outer;
    AbstractEntrySet.call(this);
  }
  EntrySet_0.prototype.add_12 = function (element) {
    throw UnsupportedOperationException_init_$Create$_0('Add is not supported on entries');
  };
  EntrySet_0.prototype.add_16 = function (element) {
    return this.add_12((!(element == null) ? isInterface(element, MutableEntry) : false) ? element : THROW_CCE());
  };
  EntrySet_0.prototype.containsEntry_4 = function (element) {
    return this._$this_3.containsEntry_5(element);
  };
  EntrySet_0.prototype.iterator_38 = function () {
    return new EntryIterator(this);
  };
  EntrySet_0.prototype._get_size__26 = function () {
    return this._$this_3._get_size__26();
  };
  EntrySet_0.prototype.checkIsMutable_11 = function () {
    return this._$this_3.checkIsMutable_11();
  };
  EntrySet_0.$metadata$ = {
    simpleName: 'EntrySet',
    kind: 'class',
    interfaces: []
  };
  function addToEnd(_this_, $this) {
    var tmp0_check_0 = _this_._next_1 == null ? _this_._prev == null : false;
    if (!tmp0_check_0) {
      var message_2_1 = 'Check failed.';
      throw IllegalStateException_init_$Create$(toString_1(message_2_1));
    }var _head = $this._head;
    if (_head == null) {
      $this._head = _this_;
      _this_._next_1 = _this_;
      _this_._prev = _this_;
    } else {
      var tmp1_checkNotNull_0 = _head._prev;
      var tmp$ret$0;
      l$ret$1: do {
        if (tmp1_checkNotNull_0 == null) {
          var message_2_1_0 = 'Required value was null.';
          throw IllegalStateException_init_$Create$(toString_1(message_2_1_0));
        } else {
          tmp$ret$0 = tmp1_checkNotNull_0;
          break l$ret$1;
        }
      }
       while (false);
      var _tail = tmp$ret$0;
      _this_._prev = _tail;
      _this_._next_1 = _head;
      _head._prev = _this_;
      _tail._next_1 = _this_;
    }
  }
  function remove(_this_, $this) {
    if (_this_._next_1 === _this_) {
      $this._head = null;
    } else {
      if ($this._head === _this_) {
        $this._head = _this_._next_1;
      }ensureNotNull(_this_._next_1)._prev = _this_._prev;
      ensureNotNull(_this_._prev)._next_1 = _this_._next_1;
    }
    _this_._next_1 = null;
    _this_._prev = null;
  }
  function LinkedHashMap_init_$Init$($this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$() {
    return LinkedHashMap_init_$Init$(Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_0(initialCapacity, loadFactor, $this) {
    HashMap_init_$Init$_1(initialCapacity, loadFactor, $this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    return $this;
  }
  function LinkedHashMap_init_$Create$_0(initialCapacity, loadFactor) {
    return LinkedHashMap_init_$Init$_0(initialCapacity, loadFactor, Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_1(initialCapacity, $this) {
    LinkedHashMap_init_$Init$_0(initialCapacity, 0.0, $this);
    return $this;
  }
  function LinkedHashMap_init_$Create$_1(initialCapacity) {
    return LinkedHashMap_init_$Init$_1(initialCapacity, Object.create(LinkedHashMap.prototype));
  }
  function LinkedHashMap_init_$Init$_2(original, $this) {
    HashMap_init_$Init$_0($this);
    LinkedHashMap.call($this);
    $this._map_0 = HashMap_init_$Create$();
    $this.putAll_0(original);
    return $this;
  }
  function LinkedHashMap_init_$Create$_2(original) {
    return LinkedHashMap_init_$Init$_2(original, Object.create(LinkedHashMap.prototype));
  }
  LinkedHashMap.prototype.containsKey_9 = function (key) {
    return this._map_0.containsKey_9(key);
  };
  LinkedHashMap.prototype.createEntrySet_0 = function () {
    return new EntrySet_0(this);
  };
  LinkedHashMap.prototype.get_25 = function (key) {
    var tmp0_safe_receiver = this._map_0.get_25(key);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver._get_value__3();
  };
  LinkedHashMap.prototype.put_7 = function (key, value) {
    this.checkIsMutable_11();
    var old = this._map_0.get_25(key);
    if (old == null) {
      var newEntry = new ChainEntry(this, key, value);
      this._map_0.put_7(key, newEntry);
      Unit_getInstance();
      addToEnd(newEntry, this);
      return null;
    } else {
      return old.setValue_1(value);
    }
  };
  LinkedHashMap.prototype.remove_11 = function (key) {
    this.checkIsMutable_11();
    var entry = this._map_0.remove_11(key);
    if (!(entry == null)) {
      remove(entry, this);
      return entry._get_value__3();
    }return null;
  };
  LinkedHashMap.prototype._get_size__26 = function () {
    return this._map_0._get_size__26();
  };
  LinkedHashMap.prototype.checkIsMutable_11 = function () {
    if (this._isReadOnly_0)
      throw UnsupportedOperationException_init_$Create$();
  };
  function LinkedHashMap() {
    this._head = null;
    this._isReadOnly_0 = false;
  }
  LinkedHashMap.$metadata$ = {
    simpleName: 'LinkedHashMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function LinkedHashSet_init_$Init$($this) {
    HashSet_init_$Init$_1(LinkedHashMap_init_$Create$(), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Create$() {
    return LinkedHashSet_init_$Init$(Object.create(LinkedHashSet.prototype));
  }
  function LinkedHashSet_init_$Init$_0(initialCapacity, loadFactor, $this) {
    HashSet_init_$Init$_1(LinkedHashMap_init_$Create$_0(initialCapacity, loadFactor), $this);
    LinkedHashSet.call($this);
    return $this;
  }
  function LinkedHashSet_init_$Init$_1(initialCapacity, $this) {
    LinkedHashSet_init_$Init$_0(initialCapacity, 0.0, $this);
    return $this;
  }
  function LinkedHashSet_init_$Create$_0(initialCapacity) {
    return LinkedHashSet_init_$Init$_1(initialCapacity, Object.create(LinkedHashSet.prototype));
  }
  LinkedHashSet.prototype.checkIsMutable_11 = function () {
    return this._get_map__0().checkIsMutable_11();
  };
  function LinkedHashSet() {
  }
  LinkedHashSet.$metadata$ = {
    simpleName: 'LinkedHashSet',
    kind: 'class',
    interfaces: [MutableSet]
  };
  function RandomAccess() {
  }
  RandomAccess.$metadata$ = {
    simpleName: 'RandomAccess',
    kind: 'interface',
    interfaces: []
  };
  function Serializable() {
  }
  Serializable.$metadata$ = {
    simpleName: 'Serializable',
    kind: 'interface',
    interfaces: []
  };
  function roundToInt(_this_) {
    var tmp;
    if (isNaN_0(_this_)) {
      throw IllegalArgumentException_init_$Create$('Cannot round NaN value.');
    } else if (_this_ > IntCompanionObject_getInstance()._MAX_VALUE) {
      tmp = IntCompanionObject_getInstance()._MAX_VALUE;
    } else if (_this_ < IntCompanionObject_getInstance()._MIN_VALUE) {
      tmp = IntCompanionObject_getInstance()._MIN_VALUE;
    } else {
      var tmp0_unsafeCast_0 = Math.round(_this_);
      tmp = numberToInt(tmp0_unsafeCast_0);
    }
    return tmp;
  }
  function isNaN_0(_this_) {
    return !(_this_ === _this_);
  }
  function defaultPlatformRandom() {
    var tmp0_unsafeCast_0 = Math.random() * Math.pow(2, 32) | 0;
    return Random_0(tmp0_unsafeCast_0);
  }
  function _get_js_(_this_) {
    return (_this_ instanceof KClassImpl ? _this_ : THROW_CCE())._get_jClass__2();
  }
  function KClass() {
  }
  KClass.$metadata$ = {
    simpleName: 'KClass',
    kind: 'interface',
    interfaces: [KClassifier]
  };
  function KClassImpl(jClass) {
    this._jClass = jClass;
  }
  KClassImpl.prototype._get_jClass__2 = function () {
    return this._jClass;
  };
  KClassImpl.prototype.equals = function (other) {
    var tmp;
    if (other instanceof KClassImpl) {
      tmp = equals_0(this._get_jClass__2(), other._get_jClass__2());
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  KClassImpl.prototype.hashCode = function () {
    var tmp0_safe_receiver = this._get_simpleName__2();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  KClassImpl.prototype.toString = function () {
    return '' + 'class ' + this._get_simpleName__2();
  };
  KClassImpl.$metadata$ = {
    simpleName: 'KClassImpl',
    kind: 'class',
    interfaces: [KClass]
  };
  function PrimitiveKClassImpl(jClass, givenSimpleName, isInstanceFunction) {
    KClassImpl.call(this, jClass);
    this._givenSimpleName = givenSimpleName;
    this._isInstanceFunction = isInstanceFunction;
  }
  PrimitiveKClassImpl.prototype.equals = function (other) {
    if (!(other instanceof PrimitiveKClassImpl))
      return false;
    else {
    }
    return KClassImpl.prototype.equals.call(this, other) ? this._givenSimpleName === other._givenSimpleName : false;
  };
  PrimitiveKClassImpl.prototype._get_simpleName__2 = function () {
    return this._givenSimpleName;
  };
  PrimitiveKClassImpl.$metadata$ = {
    simpleName: 'PrimitiveKClassImpl',
    kind: 'class',
    interfaces: []
  };
  function NothingKClassImpl() {
    NothingKClassImpl_instance = this;
    KClassImpl.call(this, Object);
    this._simpleName = 'Nothing';
  }
  NothingKClassImpl.prototype._get_simpleName__2 = function () {
    return this._simpleName;
  };
  NothingKClassImpl.prototype._get_jClass__2 = function () {
    throw UnsupportedOperationException_init_$Create$_0("There's no native JS class for Nothing type");
  };
  NothingKClassImpl.prototype.equals = function (other) {
    return other === this;
  };
  NothingKClassImpl.prototype.hashCode = function () {
    return 0;
  };
  NothingKClassImpl.$metadata$ = {
    simpleName: 'NothingKClassImpl',
    kind: 'object',
    interfaces: []
  };
  var NothingKClassImpl_instance;
  function NothingKClassImpl_getInstance() {
    if (NothingKClassImpl_instance == null)
      new NothingKClassImpl();
    return NothingKClassImpl_instance;
  }
  function ErrorKClass() {
  }
  ErrorKClass.prototype.equals = function (other) {
    return other === this;
  };
  ErrorKClass.prototype.hashCode = function () {
    return 0;
  };
  ErrorKClass.$metadata$ = {
    simpleName: 'ErrorKClass',
    kind: 'class',
    interfaces: [KClass]
  };
  function SimpleKClassImpl(jClass) {
    KClassImpl.call(this, jClass);
    var tmp = this;
    var tmp0_safe_receiver = jClass.$metadata$;
    var tmp0_unsafeCast_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.simpleName;
    tmp._simpleName_0 = tmp0_unsafeCast_0;
  }
  SimpleKClassImpl.prototype._get_simpleName__2 = function () {
    return this._simpleName_0;
  };
  SimpleKClassImpl.$metadata$ = {
    simpleName: 'SimpleKClassImpl',
    kind: 'class',
    interfaces: []
  };
  var functionClasses;
  function _no_name_provided__13() {
  }
  _no_name_provided__13.prototype.invoke_56 = function (it) {
    return isObject(it);
  };
  _no_name_provided__13.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__13.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__14() {
  }
  _no_name_provided__14.prototype.invoke_56 = function (it) {
    return isNumber(it);
  };
  _no_name_provided__14.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__14.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__15() {
  }
  _no_name_provided__15.prototype.invoke_56 = function (it) {
    return !(it == null) ? typeof it === 'boolean' : false;
  };
  _no_name_provided__15.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__15.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__16() {
  }
  _no_name_provided__16.prototype.invoke_56 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__16.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__16.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__17() {
  }
  _no_name_provided__17.prototype.invoke_56 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__17.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__17.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__18() {
  }
  _no_name_provided__18.prototype.invoke_56 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__18.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__18.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__19() {
  }
  _no_name_provided__19.prototype.invoke_56 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__19.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__19.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__20() {
  }
  _no_name_provided__20.prototype.invoke_56 = function (it) {
    return !(it == null) ? typeof it === 'number' : false;
  };
  _no_name_provided__20.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__20.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__21() {
  }
  _no_name_provided__21.prototype.invoke_56 = function (it) {
    return !(it == null) ? isArray(it) : false;
  };
  _no_name_provided__21.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__21.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__22() {
  }
  _no_name_provided__22.prototype.invoke_56 = function (it) {
    return !(it == null) ? typeof it === 'string' : false;
  };
  _no_name_provided__22.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__22.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__23() {
  }
  _no_name_provided__23.prototype.invoke_56 = function (it) {
    return it instanceof Error;
  };
  _no_name_provided__23.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__23.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__24() {
  }
  _no_name_provided__24.prototype.invoke_56 = function (it) {
    return !(it == null) ? isBooleanArray(it) : false;
  };
  _no_name_provided__24.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__24.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__25() {
  }
  _no_name_provided__25.prototype.invoke_56 = function (it) {
    return !(it == null) ? isCharArray(it) : false;
  };
  _no_name_provided__25.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__25.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__26() {
  }
  _no_name_provided__26.prototype.invoke_56 = function (it) {
    return !(it == null) ? isByteArray(it) : false;
  };
  _no_name_provided__26.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__26.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__27() {
  }
  _no_name_provided__27.prototype.invoke_56 = function (it) {
    return !(it == null) ? isShortArray(it) : false;
  };
  _no_name_provided__27.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__27.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__28() {
  }
  _no_name_provided__28.prototype.invoke_56 = function (it) {
    return !(it == null) ? isIntArray(it) : false;
  };
  _no_name_provided__28.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__28.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__29() {
  }
  _no_name_provided__29.prototype.invoke_56 = function (it) {
    return !(it == null) ? isLongArray(it) : false;
  };
  _no_name_provided__29.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__29.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__30() {
  }
  _no_name_provided__30.prototype.invoke_56 = function (it) {
    return !(it == null) ? isFloatArray(it) : false;
  };
  _no_name_provided__30.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__30.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__31() {
  }
  _no_name_provided__31.prototype.invoke_56 = function (it) {
    return !(it == null) ? isDoubleArray(it) : false;
  };
  _no_name_provided__31.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__31.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__32($arity) {
    this._$arity = $arity;
  }
  _no_name_provided__32.prototype.invoke_56 = function (it) {
    var tmp;
    if (typeof it === 'function') {
      tmp = it.length === this._$arity;
    } else {
      tmp = false;
    }
    return tmp;
  };
  _no_name_provided__32.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__32.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function PrimitiveClasses_0() {
    PrimitiveClasses_instance = this;
    var tmp = this;
    var tmp0_unsafeCast_0 = Object;
    var tmp_0 = tmp0_unsafeCast_0;
    tmp._anyClass = new PrimitiveKClassImpl(tmp_0, 'Any', _no_name_provided_$factory_5());
    var tmp_1 = this;
    var tmp0_unsafeCast_0_0 = Number;
    var tmp_2 = tmp0_unsafeCast_0_0;
    tmp_1._numberClass = new PrimitiveKClassImpl(tmp_2, 'Number', _no_name_provided_$factory_6());
    this._nothingClass = NothingKClassImpl_getInstance();
    var tmp_3 = this;
    var tmp0_unsafeCast_0_1 = Boolean;
    var tmp_4 = tmp0_unsafeCast_0_1;
    tmp_3._booleanClass = new PrimitiveKClassImpl(tmp_4, 'Boolean', _no_name_provided_$factory_7());
    var tmp_5 = this;
    var tmp0_unsafeCast_0_2 = Number;
    var tmp_6 = tmp0_unsafeCast_0_2;
    tmp_5._byteClass = new PrimitiveKClassImpl(tmp_6, 'Byte', _no_name_provided_$factory_8());
    var tmp_7 = this;
    var tmp0_unsafeCast_0_3 = Number;
    var tmp_8 = tmp0_unsafeCast_0_3;
    tmp_7._shortClass = new PrimitiveKClassImpl(tmp_8, 'Short', _no_name_provided_$factory_9());
    var tmp_9 = this;
    var tmp0_unsafeCast_0_4 = Number;
    var tmp_10 = tmp0_unsafeCast_0_4;
    tmp_9._intClass = new PrimitiveKClassImpl(tmp_10, 'Int', _no_name_provided_$factory_10());
    var tmp_11 = this;
    var tmp0_unsafeCast_0_5 = Number;
    var tmp_12 = tmp0_unsafeCast_0_5;
    tmp_11._floatClass = new PrimitiveKClassImpl(tmp_12, 'Float', _no_name_provided_$factory_11());
    var tmp_13 = this;
    var tmp0_unsafeCast_0_6 = Number;
    var tmp_14 = tmp0_unsafeCast_0_6;
    tmp_13._doubleClass = new PrimitiveKClassImpl(tmp_14, 'Double', _no_name_provided_$factory_12());
    var tmp_15 = this;
    var tmp0_unsafeCast_0_7 = Array;
    var tmp_16 = tmp0_unsafeCast_0_7;
    tmp_15._arrayClass = new PrimitiveKClassImpl(tmp_16, 'Array', _no_name_provided_$factory_13());
    var tmp_17 = this;
    var tmp0_unsafeCast_0_8 = String;
    var tmp_18 = tmp0_unsafeCast_0_8;
    tmp_17._stringClass = new PrimitiveKClassImpl(tmp_18, 'String', _no_name_provided_$factory_14());
    var tmp_19 = this;
    var tmp0_unsafeCast_0_9 = Error;
    var tmp_20 = tmp0_unsafeCast_0_9;
    tmp_19._throwableClass = new PrimitiveKClassImpl(tmp_20, 'Throwable', _no_name_provided_$factory_15());
    var tmp_21 = this;
    var tmp0_unsafeCast_0_10 = Array;
    var tmp_22 = tmp0_unsafeCast_0_10;
    tmp_21._booleanArrayClass = new PrimitiveKClassImpl(tmp_22, 'BooleanArray', _no_name_provided_$factory_16());
    var tmp_23 = this;
    var tmp0_unsafeCast_0_11 = Uint16Array;
    var tmp_24 = tmp0_unsafeCast_0_11;
    tmp_23._charArrayClass = new PrimitiveKClassImpl(tmp_24, 'CharArray', _no_name_provided_$factory_17());
    var tmp_25 = this;
    var tmp0_unsafeCast_0_12 = Int8Array;
    var tmp_26 = tmp0_unsafeCast_0_12;
    tmp_25._byteArrayClass = new PrimitiveKClassImpl(tmp_26, 'ByteArray', _no_name_provided_$factory_18());
    var tmp_27 = this;
    var tmp0_unsafeCast_0_13 = Int16Array;
    var tmp_28 = tmp0_unsafeCast_0_13;
    tmp_27._shortArrayClass = new PrimitiveKClassImpl(tmp_28, 'ShortArray', _no_name_provided_$factory_19());
    var tmp_29 = this;
    var tmp0_unsafeCast_0_14 = Int32Array;
    var tmp_30 = tmp0_unsafeCast_0_14;
    tmp_29._intArrayClass = new PrimitiveKClassImpl(tmp_30, 'IntArray', _no_name_provided_$factory_20());
    var tmp_31 = this;
    var tmp0_unsafeCast_0_15 = Array;
    var tmp_32 = tmp0_unsafeCast_0_15;
    tmp_31._longArrayClass = new PrimitiveKClassImpl(tmp_32, 'LongArray', _no_name_provided_$factory_21());
    var tmp_33 = this;
    var tmp0_unsafeCast_0_16 = Float32Array;
    var tmp_34 = tmp0_unsafeCast_0_16;
    tmp_33._floatArrayClass = new PrimitiveKClassImpl(tmp_34, 'FloatArray', _no_name_provided_$factory_22());
    var tmp_35 = this;
    var tmp0_unsafeCast_0_17 = Float64Array;
    var tmp_36 = tmp0_unsafeCast_0_17;
    tmp_35._doubleArrayClass = new PrimitiveKClassImpl(tmp_36, 'DoubleArray', _no_name_provided_$factory_23());
  }
  PrimitiveClasses_0.prototype._get_anyClass_ = function () {
    return this._anyClass;
  };
  PrimitiveClasses_0.prototype._get_numberClass_ = function () {
    return this._numberClass;
  };
  PrimitiveClasses_0.prototype._get_nothingClass_ = function () {
    return this._nothingClass;
  };
  PrimitiveClasses_0.prototype._get_booleanClass_ = function () {
    return this._booleanClass;
  };
  PrimitiveClasses_0.prototype._get_byteClass_ = function () {
    return this._byteClass;
  };
  PrimitiveClasses_0.prototype._get_shortClass_ = function () {
    return this._shortClass;
  };
  PrimitiveClasses_0.prototype._get_intClass_ = function () {
    return this._intClass;
  };
  PrimitiveClasses_0.prototype._get_floatClass_ = function () {
    return this._floatClass;
  };
  PrimitiveClasses_0.prototype._get_doubleClass_ = function () {
    return this._doubleClass;
  };
  PrimitiveClasses_0.prototype._get_arrayClass_ = function () {
    return this._arrayClass;
  };
  PrimitiveClasses_0.prototype._get_stringClass_ = function () {
    return this._stringClass;
  };
  PrimitiveClasses_0.prototype._get_throwableClass_ = function () {
    return this._throwableClass;
  };
  PrimitiveClasses_0.prototype._get_booleanArrayClass_ = function () {
    return this._booleanArrayClass;
  };
  PrimitiveClasses_0.prototype._get_charArrayClass_ = function () {
    return this._charArrayClass;
  };
  PrimitiveClasses_0.prototype._get_byteArrayClass_ = function () {
    return this._byteArrayClass;
  };
  PrimitiveClasses_0.prototype._get_shortArrayClass_ = function () {
    return this._shortArrayClass;
  };
  PrimitiveClasses_0.prototype._get_intArrayClass_ = function () {
    return this._intArrayClass;
  };
  PrimitiveClasses_0.prototype._get_longArrayClass_ = function () {
    return this._longArrayClass;
  };
  PrimitiveClasses_0.prototype._get_floatArrayClass_ = function () {
    return this._floatArrayClass;
  };
  PrimitiveClasses_0.prototype._get_doubleArrayClass_ = function () {
    return this._doubleArrayClass;
  };
  PrimitiveClasses_0.prototype.functionClass = function (arity) {
    var tmp0_elvis_lhs = functionClasses[arity];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp0_unsafeCast_0_3 = Function;
      var tmp_0 = tmp0_unsafeCast_0_3;
      var tmp_1 = '' + 'Function' + arity;
      var result_2 = new PrimitiveKClassImpl(tmp_0, tmp_1, _no_name_provided_$factory_24(arity));
      var tmp1_asDynamic_0_5 = functionClasses;
      tmp1_asDynamic_0_5[arity] = result_2;
      tmp = result_2;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  PrimitiveClasses_0.$metadata$ = {
    simpleName: 'PrimitiveClasses',
    kind: 'object',
    interfaces: []
  };
  Object.defineProperty(PrimitiveClasses_0.prototype, 'anyClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_anyClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'numberClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_numberClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'nothingClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_nothingClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'arrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_arrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'stringClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_stringClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'throwableClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_throwableClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'booleanArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_booleanArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'charArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_charArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'byteArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_byteArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'shortArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_shortArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'intArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_intArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'longArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_longArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'floatArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_floatArrayClass_
  });
  Object.defineProperty(PrimitiveClasses_0.prototype, 'doubleArrayClass', {
    configurable: true,
    get: PrimitiveClasses_0.prototype._get_doubleArrayClass_
  });
  var PrimitiveClasses_instance;
  function PrimitiveClasses_getInstance() {
    if (PrimitiveClasses_instance == null)
      new PrimitiveClasses_0();
    return PrimitiveClasses_instance;
  }
  function _no_name_provided_$factory_5() {
    var i = new _no_name_provided__13();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_6() {
    var i = new _no_name_provided__14();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_7() {
    var i = new _no_name_provided__15();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_8() {
    var i = new _no_name_provided__16();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_9() {
    var i = new _no_name_provided__17();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_10() {
    var i = new _no_name_provided__18();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_11() {
    var i = new _no_name_provided__19();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_12() {
    var i = new _no_name_provided__20();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_13() {
    var i = new _no_name_provided__21();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_14() {
    var i = new _no_name_provided__22();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_15() {
    var i = new _no_name_provided__23();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_16() {
    var i = new _no_name_provided__24();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_17() {
    var i = new _no_name_provided__25();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_18() {
    var i = new _no_name_provided__26();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_19() {
    var i = new _no_name_provided__27();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_20() {
    var i = new _no_name_provided__28();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_21() {
    var i = new _no_name_provided__29();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_22() {
    var i = new _no_name_provided__30();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_23() {
    var i = new _no_name_provided__31();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function _no_name_provided_$factory_24($arity) {
    var i = new _no_name_provided__32($arity);
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function functionClasses$init$() {
    var tmp0_arrayOfNulls_0 = 0;
    return fillArrayVal(Array(tmp0_arrayOfNulls_0), null);
  }
  function getKClass_0(jClass) {
    var tmp;
    if (Array.isArray(jClass)) {
      tmp = getKClassM_0(jClass);
    } else {
      tmp = getKClass1_0(jClass);
    }
    return tmp;
  }
  function getKClassM_0(jClasses) {
    var tmp0_subject = jClasses.length;
    var tmp;
    switch (tmp0_subject) {
      case 1:
        tmp = getKClass1_0(jClasses[0]);
        break;
      case 0:
        var tmp0_unsafeCast_0 = NothingKClassImpl_getInstance();
        tmp = tmp0_unsafeCast_0;
        break;
      default:var tmp1_unsafeCast_0 = new ErrorKClass();
        tmp = tmp1_unsafeCast_0;
        break;
    }
    return tmp;
  }
  function getKClass1_0(jClass) {
    if (jClass === String) {
      var tmp0_unsafeCast_0 = PrimitiveClasses_getInstance()._stringClass;
      return tmp0_unsafeCast_0;
    }var metadata = jClass.$metadata$;
    var tmp;
    if (metadata != null) {
      var tmp_0;
      if (metadata.$kClass$ == null) {
        var kClass = new SimpleKClassImpl(jClass);
        metadata.$kClass$ = kClass;
        tmp_0 = kClass;
      } else {
        tmp_0 = metadata.$kClass$;
      }
      tmp = tmp_0;
    } else {
      tmp = new SimpleKClassImpl(jClass);
    }
    return tmp;
  }
  function Appendable() {
  }
  Appendable.$metadata$ = {
    simpleName: 'Appendable',
    kind: 'interface',
    interfaces: []
  };
  function StringBuilder_init_$Init$(capacity, $this) {
    StringBuilder_init_$Init$_0($this);
    return $this;
  }
  function StringBuilder_init_$Create$(capacity) {
    return StringBuilder_init_$Init$(capacity, Object.create(StringBuilder.prototype));
  }
  function StringBuilder_init_$Init$_0($this) {
    StringBuilder.call($this, '');
    return $this;
  }
  function StringBuilder_init_$Create$_0() {
    return StringBuilder_init_$Init$_0(Object.create(StringBuilder.prototype));
  }
  function StringBuilder(content) {
    this._string = !(content === undefined) ? content : '';
  }
  StringBuilder.prototype._get_length__0 = function () {
    var tmp0_asDynamic_0 = this._string;
    return tmp0_asDynamic_0.length;
  };
  StringBuilder.prototype.get_36 = function (index) {
    var tmp0_getOrElse_0 = this._string;
    var tmp;
    if (index >= 0 ? index <= _get_lastIndex__1(tmp0_getOrElse_0) : false) {
      tmp = charSequenceGet(tmp0_getOrElse_0, index);
    } else {
      throw IndexOutOfBoundsException_init_$Create$('' + 'index: ' + index + ', length: ' + this._get_length__0() + '}');
    }
    return tmp;
  };
  StringBuilder.prototype.subSequence_1 = function (startIndex, endIndex) {
    var tmp0_substring_0 = this._string;
    return tmp0_substring_0.substring(startIndex, endIndex);
  };
  StringBuilder.prototype.append_2 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + value;
    return this;
  };
  StringBuilder.prototype.append_3 = function (value) {
    var tmp0_this = this;
    tmp0_this._string = tmp0_this._string + toString_0(value);
    return this;
  };
  StringBuilder.prototype.append_4 = function (value) {
    var tmp0_this = this;
    var tmp = tmp0_this;
    var tmp_0 = tmp0_this._string;
    var tmp1_elvis_lhs = value;
    tmp._string = tmp_0 + (tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs);
    return this;
  };
  StringBuilder.prototype.toString = function () {
    return this._string;
  };
  StringBuilder.$metadata$ = {
    simpleName: 'StringBuilder',
    kind: 'class',
    interfaces: [Appendable, CharSequence]
  };
  function isWhitespace(_this_) {
    return matches(_this_.toString(), '[\\s\\xA0]');
  }
  function uppercaseChar(_this_) {
    var tmp0_asDynamic_0 = _this_.toString();
    var tmp = tmp0_asDynamic_0.toUpperCase();
    var uppercase = (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : THROW_CCE();
    return uppercase.length > 1 ? _this_ : charSequenceGet(uppercase, 0);
  }
  function Regex_init_$Init$(pattern, $this) {
    Regex.call($this, pattern, emptySet());
    return $this;
  }
  function Regex_init_$Create$(pattern) {
    return Regex_init_$Init$(pattern, Object.create(Regex.prototype));
  }
  function Companion_5() {
    Companion_instance_4 = this;
    this._patternEscape = new RegExp('[-\\\\^$*+?.()|[\\]{}]', 'g');
    this._replacementEscape = new RegExp('\\$', 'g');
  }
  Companion_5.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    if (Companion_instance_4 == null)
      new Companion_5();
    return Companion_instance_4;
  }
  function _no_name_provided__33(this$0, $input, $startIndex) {
    this._this$0_7 = this$0;
    this._$input = $input;
    this._$startIndex = $startIndex;
  }
  _no_name_provided__33.prototype.invoke_287 = function () {
    return this._this$0_7.find(this._$input, this._$startIndex);
  };
  _no_name_provided__33.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__34() {
  }
  _no_name_provided__34.prototype.invoke_52 = function (match) {
    return match.next_14();
  };
  _no_name_provided__34.prototype.invoke_293 = function (p1) {
    return this.invoke_52((!(p1 == null) ? isInterface(p1, MatchResult) : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__34.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function Regex(pattern, options_1) {
    Companion_getInstance_4();
    this._pattern = pattern;
    this._options = toSet(options_1);
    var tmp = this;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(options_1, 10));
    var tmp0_iterator_1_2 = options_1.iterator_38();
    while (tmp0_iterator_1_2.hasNext_12()) {
      var item_2_3 = tmp0_iterator_1_2.next_14();
      tmp0_mapTo_0_1.add_16(item_2_3.value__error);
      Unit_getInstance();
    }
    tmp._nativePattern = new RegExp(pattern, joinToString$default_0(tmp0_mapTo_0_1, '', null, null, 0, null, null, 62, null) + 'g');
  }
  Regex.prototype.find = function (input, startIndex) {
    if (startIndex < 0 ? true : startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }return findNext(this._nativePattern, toString_1(input), startIndex);
  };
  Regex.prototype.findAll = function (input, startIndex) {
    if (startIndex < 0 ? true : startIndex > charSequenceLength(input)) {
      throw IndexOutOfBoundsException_init_$Create$('' + 'Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
    }var tmp = _no_name_provided_$factory_25(this, input, startIndex);
    return generateSequence(tmp, _no_name_provided_$factory_26());
  };
  Regex.prototype.findAll$default = function (input, startIndex, $mask0, $handler) {
    if (!(($mask0 & 2) === 0))
      startIndex = 0;
    return this.findAll(input, startIndex);
  };
  Regex.prototype.replaceFirst = function (input, replacement) {
    var tmp0_map_0 = this._options;
    var tmp0_mapTo_0_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(tmp0_map_0, 10));
    var tmp0_iterator_1_2 = tmp0_map_0.iterator_38();
    while (tmp0_iterator_1_2.hasNext_12()) {
      var item_2_3 = tmp0_iterator_1_2.next_14();
      tmp0_mapTo_0_1.add_16(item_2_3.value__error);
      Unit_getInstance();
    }
    var nonGlobalOptions = joinToString$default_0(tmp0_mapTo_0_1, '', null, null, 0, null, null, 62, null);
    var tmp1_nativeReplace_0 = toString_1(input);
    var tmp2_nativeReplace_0 = new RegExp(this._pattern, nonGlobalOptions);
    return tmp1_nativeReplace_0.replace(tmp2_nativeReplace_0, replacement);
  };
  Regex.prototype.split = function (input, limit) {
    var tmp0_require_0 = limit >= 0;
    if (!tmp0_require_0) {
      var message_1 = '' + 'Limit must be non-negative, but was ' + limit;
      throw IllegalArgumentException_init_$Create$(toString_1(message_1));
    }var tmp1_let_0 = this.findAll$default(input, 0, 2, null);
    var matches_0 = limit === 0 ? tmp1_let_0 : take(tmp1_let_0, limit - 1 | 0);
    var result = ArrayList_init_$Create$();
    var lastStart = 0;
    var tmp0_iterator = matches_0.iterator_38();
    while (tmp0_iterator.hasNext_12()) {
      var match = tmp0_iterator.next_14();
      result.add_16(toString_1(charSequenceSubSequence(input, lastStart, match._get_range__0()._get_start_())));
      Unit_getInstance();
      lastStart = match._get_range__0()._get_endInclusive_() + 1 | 0;
    }
    result.add_16(toString_1(charSequenceSubSequence(input, lastStart, charSequenceLength(input))));
    Unit_getInstance();
    return result;
  };
  Regex.prototype.toString = function () {
    return this._nativePattern.toString();
  };
  Regex.$metadata$ = {
    simpleName: 'Regex',
    kind: 'class',
    interfaces: []
  };
  function findNext(_this_, input, from) {
    _this_.lastIndex = from;
    var match = _this_.exec(input);
    if (match == null)
      return null;
    var range = numberRangeToNumber(match.index, _this_.lastIndex - 1 | 0);
    return new _no_name_provided__37(range, match, _this_, input);
  }
  function MatchGroup(value) {
    this._value = value;
  }
  MatchGroup.prototype.toString = function () {
    return '' + 'MatchGroup(value=' + this._value + ')';
  };
  MatchGroup.prototype.hashCode = function () {
    return getStringHashCode(this._value);
  };
  MatchGroup.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MatchGroup))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof MatchGroup ? other : THROW_CCE();
    if (!(this._value === tmp0_other_with_cast._value))
      return false;
    return true;
  };
  MatchGroup.$metadata$ = {
    simpleName: 'MatchGroup',
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__35(this$0) {
    this._this$0_8 = this$0;
  }
  _no_name_provided__35.prototype.invoke_54 = function (it) {
    return this._this$0_8.get_36(it);
  };
  _no_name_provided__35.prototype.invoke_293 = function (p1) {
    return this.invoke_54((!(p1 == null) ? typeof p1 === 'number' : false) ? p1 : THROW_CCE());
  };
  _no_name_provided__35.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__36($match) {
    this._$match = $match;
    AbstractCollection.call(this);
  }
  _no_name_provided__36.prototype._get_size__26 = function () {
    return this._$match.length;
  };
  _no_name_provided__36.prototype.iterator_38 = function () {
    var tmp = asSequence(_get_indices_(this));
    return map(tmp, _no_name_provided_$factory_27(this)).iterator_38();
  };
  _no_name_provided__36.prototype.get_36 = function (index) {
    var tmp0_safe_receiver = this._$match[index];
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = new MatchGroup(tmp0_safe_receiver);
    }
    return tmp;
  };
  _no_name_provided__36.$metadata$ = {
    kind: 'class',
    interfaces: [MatchGroupCollection]
  };
  function _no_name_provided__37($range, $match, $this_findNext, $input) {
    this._$range = $range;
    this._$match_0 = $match;
    this._$this_findNext = $this_findNext;
    this._$input_0 = $input;
    this._range = this._$range;
    var tmp = this;
    tmp._groups = new _no_name_provided__36(this._$match_0);
    this._groupValues_ = null;
  }
  _no_name_provided__37.prototype._get_range__0 = function () {
    return this._range;
  };
  _no_name_provided__37.prototype.next_14 = function () {
    return findNext(this._$this_findNext, this._$input_0, this._$range.isEmpty_26() ? this._$range._get_start_() + 1 | 0 : this._$range._get_endInclusive_() + 1 | 0);
  };
  _no_name_provided__37.$metadata$ = {
    kind: 'class',
    interfaces: [MatchResult]
  };
  function _no_name_provided_$factory_25(this$0, $input, $startIndex) {
    var i = new _no_name_provided__33(this$0, $input, $startIndex);
    return function () {
      return i.invoke_287();
    };
  }
  function _no_name_provided_$factory_26() {
    var i = new _no_name_provided__34();
    return function (p1) {
      return i.invoke_52(p1);
    };
  }
  function _no_name_provided_$factory_27(this$0) {
    var i = new _no_name_provided__35(this$0);
    return function (p1) {
      return i.invoke_54(p1);
    };
  }
  function capitalize(_this_) {
    var tmp;
    if (charSequenceLength(_this_) > 0) {
      var tmp0_substring_0 = 0;
      var tmp1_substring_0 = 1;
      var tmp2_toUpperCase_0 = _this_.substring(tmp0_substring_0, tmp1_substring_0);
      var tmp_0 = tmp2_toUpperCase_0.toUpperCase();
      var tmp3_substring_0 = 1;
      tmp = tmp_0 + _this_.substring(tmp3_substring_0);
    } else {
      {
        tmp = _this_;
      }
    }
    return tmp;
  }
  function isBlank(_this_) {
    var tmp;
    if (charSequenceLength(_this_) === 0) {
      tmp = true;
    } else {
      var tmp_0;
      if (typeof _this_ === 'string') {
        tmp_0 = _this_;
      } else {
        {
          tmp_0 = toString_1(_this_);
        }
      }
      tmp = matches(tmp_0, '^[\\s\\xA0]+$');
    }
    return tmp;
  }
  function matches(_this_, regex) {
    var result = _this_.match(regex);
    return !(result == null) ? !(result.length === 0) : false;
  }
  function regionMatches(_this_, thisOffset, other, otherOffset, length, ignoreCase) {
    return regionMatchesImpl(_this_, thisOffset, other, otherOffset, length, ignoreCase);
  }
  function Companion_6() {
    Companion_instance_5 = this;
    this._MIN_VALUE_0 = new Char(0);
    this._MAX_VALUE_0 = new Char(65535);
    this._MIN_HIGH_SURROGATE = new Char(55296);
    this._MAX_HIGH_SURROGATE = new Char(56319);
    this._MIN_LOW_SURROGATE = new Char(56320);
    this._MAX_LOW_SURROGATE = new Char(57343);
    this._MIN_SURROGATE = new Char(55296);
    this._MAX_SURROGATE = new Char(57343);
    this._SIZE_BYTES_0 = 2;
    this._SIZE_BITS_0 = 16;
  }
  Companion_6.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    if (Companion_instance_5 == null)
      new Companion_6();
    return Companion_instance_5;
  }
  function Char(code) {
    Companion_getInstance_5();
    var tmp = this;
    tmp._value_0 = _UShort___get_data__impl_(code) & 65535;
  }
  Char.prototype.compareTo_0 = function (other) {
    return this._value_0 - other._value_0 | 0;
  };
  Char.prototype.compareTo_5 = function (other) {
    return this.compareTo_0(other instanceof Char ? other : THROW_CCE());
  };
  Char.prototype.toInt_5 = function () {
    return this._value_0;
  };
  Char.prototype.equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Char))
      return false;
    else {
    }
    return this._value_0 === other._value_0;
  };
  Char.prototype.hashCode = function () {
    return this._value_0;
  };
  Char.prototype.toString = function () {
    var tmp0_unsafeCast_0 = String.fromCharCode(this._value_0);
    return tmp0_unsafeCast_0;
  };
  Char.$metadata$ = {
    simpleName: 'Char',
    kind: 'class',
    interfaces: [Comparable]
  };
  function Iterable() {
  }
  Iterable.$metadata$ = {
    simpleName: 'Iterable',
    kind: 'interface',
    interfaces: []
  };
  function Entry() {
  }
  Entry.$metadata$ = {
    simpleName: 'Entry',
    kind: 'interface',
    interfaces: []
  };
  function Map_0() {
  }
  Map_0.$metadata$ = {
    simpleName: 'Map',
    kind: 'interface',
    interfaces: []
  };
  function Set() {
  }
  Set.$metadata$ = {
    simpleName: 'Set',
    kind: 'interface',
    interfaces: [Collection]
  };
  function List() {
  }
  List.$metadata$ = {
    simpleName: 'List',
    kind: 'interface',
    interfaces: [Collection]
  };
  function MutableEntry() {
  }
  MutableEntry.$metadata$ = {
    simpleName: 'MutableEntry',
    kind: 'interface',
    interfaces: [Entry]
  };
  function MutableMap() {
  }
  MutableMap.$metadata$ = {
    simpleName: 'MutableMap',
    kind: 'interface',
    interfaces: [Map_0]
  };
  function Collection() {
  }
  Collection.$metadata$ = {
    simpleName: 'Collection',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function MutableList() {
  }
  MutableList.$metadata$ = {
    simpleName: 'MutableList',
    kind: 'interface',
    interfaces: [List, MutableCollection]
  };
  function MutableSet() {
  }
  MutableSet.$metadata$ = {
    simpleName: 'MutableSet',
    kind: 'interface',
    interfaces: [Set, MutableCollection]
  };
  function MutableCollection() {
  }
  MutableCollection.$metadata$ = {
    simpleName: 'MutableCollection',
    kind: 'interface',
    interfaces: [Collection, MutableIterable]
  };
  function MutableIterable() {
  }
  MutableIterable.$metadata$ = {
    simpleName: 'MutableIterable',
    kind: 'interface',
    interfaces: [Iterable]
  };
  function Companion_7() {
    Companion_instance_6 = this;
  }
  Companion_7.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    if (Companion_instance_6 == null)
      new Companion_7();
    return Companion_instance_6;
  }
  function Enum(name, ordinal) {
    Companion_getInstance_6();
    this._name = name;
    this._ordinal = ordinal;
  }
  Enum.prototype.compareTo_2 = function (other) {
    return compareTo(this._ordinal, other._ordinal);
  };
  Enum.prototype.compareTo_5 = function (other) {
    return this.compareTo_2(other instanceof Enum ? other : THROW_CCE());
  };
  Enum.prototype.equals = function (other) {
    return this === other;
  };
  Enum.prototype.hashCode = function () {
    return identityHashCode(this);
  };
  Enum.prototype.toString = function () {
    return this._name;
  };
  Enum.$metadata$ = {
    simpleName: 'Enum',
    kind: 'class',
    interfaces: [Comparable]
  };
  function toString_0(_this_) {
    var tmp0_safe_receiver = _this_;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toString_1(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs;
  }
  function fillArrayVal(array, initValue) {
    var inductionVariable = 0;
    var last_0 = array.length - 1 | 0;
    if (inductionVariable <= last_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        array[i] = initValue;
      }
       while (!(i === last_0));
    return array;
  }
  function arrayIterator(array) {
    return new _no_name_provided__38(array);
  }
  function _no_name_provided__38($array) {
    this._$array = $array;
    this._index_0 = 0;
  }
  _no_name_provided__38.prototype.hasNext_12 = function () {
    return !(this._index_0 === this._$array.length);
  };
  _no_name_provided__38.prototype.next_14 = function () {
    var tmp;
    if (!(this._index_0 === this._$array.length)) {
      var tmp0_this = this;
      var tmp1 = tmp0_this._index_0;
      tmp0_this._index_0 = tmp1 + 1 | 0;
      tmp = this._$array[tmp1];
    } else {
      throw NoSuchElementException_init_$Create$_0('' + this._index_0);
    }
    return tmp;
  };
  _no_name_provided__38.$metadata$ = {
    kind: 'class',
    interfaces: [Iterator]
  };
  var buf;
  var bufFloat64;
  var bufInt32;
  var lowIndex;
  var highIndex;
  function getNumberHashCode(obj) {
    var tmp0_unsafeCast_0 = jsBitwiseOr(obj, 0);
    if (tmp0_unsafeCast_0 === obj) {
      return numberToInt(obj);
    } else {
    }
    bufFloat64[0] = obj;
    return imul(bufInt32[highIndex], 31) + bufInt32[lowIndex] | 0;
  }
  function bufFloat64$init$() {
    var tmp0_unsafeCast_0 = new Float64Array(buf);
    return tmp0_unsafeCast_0;
  }
  function bufInt32$init$() {
    var tmp0_unsafeCast_0 = new Int32Array(buf);
    return tmp0_unsafeCast_0;
  }
  function lowIndex$init$() {
    bufFloat64[0] = -1.0;
    return !(bufInt32[0] === 0) ? 1 : 0;
  }
  function charSequenceGet(a, index) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.charCodeAt(index);
      var tmp1_Char_0 = tmp0_unsafeCast_0;
      var tmp_0;
      var tmp0__get_code__0_1 = new Char(0);
      if (tmp1_Char_0 < tmp0__get_code__0_1.toInt_5()) {
        tmp_0 = true;
      } else {
        {
          var tmp1__get_code__0_2 = new Char(65535);
          tmp_0 = tmp1_Char_0 > tmp1__get_code__0_2.toInt_5();
        }
      }
      if (tmp_0) {
        throw IllegalArgumentException_init_$Create$('' + 'Invalid Char code: ' + tmp1_Char_0);
      } else {
      }
      tmp = new Char(_UShort___init__impl_(toShort(tmp1_Char_0)));
    } else {
      tmp = a.get_36(index);
    }
    return tmp;
  }
  function isString(a) {
    return typeof a === 'string';
  }
  function charSequenceLength(a) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.length;
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a._get_length__0();
    }
    return tmp;
  }
  function charSequenceSubSequence(a, startIndex, endIndex) {
    var tmp;
    if (isString(a)) {
      var tmp0_unsafeCast_0 = a.substring(startIndex, endIndex);
      tmp = tmp0_unsafeCast_0;
    } else {
      tmp = a.subSequence_1(startIndex, endIndex);
    }
    return tmp;
  }
  function arrayToString(array) {
    return joinToString$default(array, ', ', '[', ']', 0, null, _no_name_provided_$factory_28(), 24, null);
  }
  function _no_name_provided__39() {
  }
  _no_name_provided__39.prototype.invoke_56 = function (it) {
    return toString_1(it);
  };
  _no_name_provided__39.prototype.invoke_293 = function (p1) {
    return this.invoke_56((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
  };
  _no_name_provided__39.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_28() {
    var i = new _no_name_provided__39();
    return function (p1) {
      return i.invoke_56(p1);
    };
  }
  function compareTo(a, b) {
    var tmp0_subject = typeof a;
    var tmp;
    switch (tmp0_subject) {
      case 'number':
        var tmp_0;
        if (typeof b === 'number') {
          tmp_0 = doubleCompareTo(a, b);
        } else {
          if (b instanceof Long) {
            tmp_0 = doubleCompareTo(a, b.toDouble_4());
          } else {
            {
              tmp_0 = primitiveCompareTo(a, b);
            }
          }
        }

        tmp = tmp_0;
        break;
      case 'string':
      case 'boolean':
        tmp = primitiveCompareTo(a, b);
        break;
      default:tmp = compareToDoNotIntrinsicify(a, b);
        break;
    }
    return tmp;
  }
  function doubleCompareTo(a, b) {
    var tmp;
    if (a < b) {
      tmp = -1;
    } else if (a > b) {
      tmp = 1;
    } else if (a === b) {
      var tmp_0;
      if (a !== 0) {
        tmp_0 = 0;
      } else {
        var tmp0_asDynamic_0 = 1;
        var ia = tmp0_asDynamic_0 / a;
        var tmp_1;
        var tmp1_asDynamic_0 = 1;
        if (ia === tmp1_asDynamic_0 / b) {
          tmp_1 = 0;
        } else {
          if (ia < 0) {
            tmp_1 = -1;
          } else {
            {
              tmp_1 = 1;
            }
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else if (a !== a) {
      tmp = b !== b ? 0 : 1;
    } else {
      tmp = -1;
    }
    return tmp;
  }
  function primitiveCompareTo(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  }
  function compareToDoNotIntrinsicify(a, b) {
    return a.compareTo_5(b);
  }
  function identityHashCode(obj) {
    return getObjectHashCode(obj);
  }
  function getObjectHashCode(obj) {
    if (!jsIn('kotlinHashCodeValue$', obj)) {
      var hash = jsBitwiseOr(Math.random() * 4.294967296E9, 0);
      var descriptor = new Object();
      descriptor.value = hash;
      descriptor.enumerable = false;
      Object.defineProperty(obj, 'kotlinHashCodeValue$', descriptor);
    }var tmp0_unsafeCast_0 = obj['kotlinHashCodeValue$'];
    return tmp0_unsafeCast_0;
  }
  function toString_1(o) {
    var tmp;
    if (o == null) {
      tmp = 'null';
    } else if (isArrayish(o)) {
      tmp = '[...]';
    } else {
      var tmp0_unsafeCast_0 = o.toString();
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function hashCode(obj) {
    if (obj == null)
      return 0;
    var tmp0_subject = typeof obj;
    var tmp;
    switch (tmp0_subject) {
      case 'object':
        tmp = 'function' === typeof obj.hashCode ? obj.hashCode() : getObjectHashCode(obj);
        break;
      case 'function':
        tmp = getObjectHashCode(obj);
        break;
      case 'number':
        tmp = getNumberHashCode(obj);
        break;
      case 'boolean':
        var tmp_0;
        if (obj) {
          tmp_0 = 1;
        } else {
          {
            tmp_0 = 0;
          }
        }

        tmp = tmp_0;
        break;
      default:tmp = getStringHashCode(String(obj));
        break;
    }
    return tmp;
  }
  function getStringHashCode(str) {
    var hash = 0;
    var length = str.length;
    var inductionVariable = 0;
    var last_0 = length - 1 | 0;
    if (inductionVariable <= last_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var code = str.charCodeAt(i);
        hash = imul(hash, 31) + code | 0;
      }
       while (!(i === last_0));
    return hash;
  }
  function equals_0(obj1, obj2) {
    if (obj1 == null) {
      return obj2 == null;
    }if (obj2 == null) {
      return false;
    }if (typeof obj1 === 'object' ? typeof obj1.equals === 'function' : false) {
      return obj1.equals(obj2);
    }if (obj1 !== obj1) {
      return obj2 !== obj2;
    }if (typeof obj1 === 'number' ? typeof obj2 === 'number' : false) {
      var tmp;
      if (obj1 === obj2) {
        var tmp_0;
        if (obj1 !== 0) {
          tmp_0 = true;
        } else {
          var tmp0_asDynamic_0 = 1;
          var tmp_1 = tmp0_asDynamic_0 / obj1;
          var tmp1_asDynamic_0 = 1;
          tmp_0 = tmp_1 === tmp1_asDynamic_0 / obj2;
        }
        tmp = tmp_0;
      } else {
        tmp = false;
      }
      return tmp;
    }return obj1 === obj2;
  }
  function captureStack(instance, constructorFunction) {
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(instance, constructorFunction);
    } else {
      instance.stack = (new Error()).stack;
    }
  }
  function extendThrowable(this_, message, cause) {
    Error.call(this_);
    setPropertiesToThrowableInstance(this_, message, cause);
  }
  function setPropertiesToThrowableInstance(this_, message, cause) {
    if (!hasOwnPrototypeProperty(this_, 'message')) {
      var tmp;
      if (message == null) {
        var tmp_0;
        if (!(message === null)) {
          var tmp0_safe_receiver = cause;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
          tmp_0 = tmp1_elvis_lhs == null ? undefined : tmp1_elvis_lhs;
        } else {
          tmp_0 = undefined;
        }
        tmp = tmp_0;
      } else {
        tmp = message;
      }
      this_.message = tmp;
    }if (!hasOwnPrototypeProperty(this_, 'cause')) {
      this_.cause = cause;
    }this_.name = Object.getPrototypeOf(this_).constructor.name;
  }
  function hasOwnPrototypeProperty(o, name) {
    var tmp0_unsafeCast_0 = Object.getPrototypeOf(o).hasOwnProperty(name);
    return tmp0_unsafeCast_0;
  }
  function ensureNotNull(v) {
    var tmp;
    if (v == null) {
      THROW_NPE();
    } else {
      tmp = v;
    }
    return tmp;
  }
  function THROW_NPE() {
    throw NullPointerException_init_$Create$();
  }
  function THROW_CCE() {
    throw ClassCastException_init_$Create$();
  }
  function Companion_8() {
    Companion_instance_7 = this;
    this._MIN_VALUE_1 = new Long(0, -2147483648);
    this._MAX_VALUE_1 = new Long(-1, 2147483647);
    this._SIZE_BYTES_1 = 8;
    this._SIZE_BITS_1 = 64;
  }
  Companion_8.$metadata$ = {
    simpleName: 'Companion',
    kind: 'object',
    interfaces: []
  };
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_8();
    return Companion_instance_7;
  }
  function Long(low, high) {
    Companion_getInstance_7();
    Number_0.call(this);
    this._low = low;
    this._high = high;
  }
  Long.prototype.compareTo_35 = function (other) {
    return compare(this, other);
  };
  Long.prototype.compareTo_5 = function (other) {
    return this.compareTo_35(other instanceof Long ? other : THROW_CCE());
  };
  Long.prototype.plus_27 = function (other) {
    return add(this, other);
  };
  Long.prototype.div_27 = function (other) {
    return divide(this, other);
  };
  Long.prototype.unaryMinus_4 = function () {
    return this.inv_0().plus_27(new Long(1, 0));
  };
  Long.prototype.inv_0 = function () {
    return new Long(~this._low, ~this._high);
  };
  Long.prototype.toInt_5 = function () {
    return this._low;
  };
  Long.prototype.toDouble_4 = function () {
    return toNumber(this);
  };
  Long.prototype.valueOf = function () {
    return this.toDouble_4();
  };
  Long.prototype.equals = function (other) {
    var tmp;
    if (other instanceof Long) {
      tmp = equalsLong(this, other);
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  Long.prototype.hashCode = function () {
    return hashCode_0(this);
  };
  Long.prototype.toString = function () {
    return toStringImpl(this, 10);
  };
  Long.$metadata$ = {
    simpleName: 'Long',
    kind: 'class',
    interfaces: [Comparable]
  };
  var ZERO;
  var ONE;
  var NEG_ONE;
  var MAX_VALUE;
  var MIN_VALUE;
  var TWO_PWR_24_;
  function compare(_this_, other) {
    if (equalsLong(_this_, other)) {
      return 0;
    }var thisNeg = isNegative(_this_);
    var otherNeg = isNegative(other);
    return (thisNeg ? !otherNeg : false) ? -1 : (!thisNeg ? otherNeg : false) ? 1 : isNegative(subtract(_this_, other)) ? -1 : 1;
  }
  function add(_this_, other) {
    var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + (a00 + b00 | 0) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + (a16 + b16 | 0) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + (a32 + b32 | 0) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (a48 + b48 | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function subtract(_this_, other) {
    return add(_this_, other.unaryMinus_4());
  }
  function multiply(_this_, other) {
    if (isZero(_this_)) {
      return ZERO;
    } else if (isZero(other)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      return isOdd(other) ? MIN_VALUE : ZERO;
    } else if (equalsLong(other, MIN_VALUE)) {
      return isOdd(_this_) ? MIN_VALUE : ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = multiply(negate(_this_), negate(other));
      } else {
        tmp = negate(multiply(negate(_this_), other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(multiply(_this_, negate(other)));
    }if (lessThan(_this_, TWO_PWR_24_) ? lessThan(other, TWO_PWR_24_) : false) {
      return fromNumber(toNumber(_this_) * toNumber(other));
    }var a48 = _this_._high >>> 16;
    var a32 = _this_._high & 65535;
    var a16 = _this_._low >>> 16;
    var a00 = _this_._low & 65535;
    var b48 = other._high >>> 16;
    var b32 = other._high & 65535;
    var b16 = other._low >>> 16;
    var b00 = other._low & 65535;
    var c48 = 0;
    var c32 = 0;
    var c16 = 0;
    var c00 = 0;
    c00 = c00 + imul(a00, b00) | 0;
    c16 = c16 + (c00 >>> 16) | 0;
    c00 = c00 & 65535;
    c16 = c16 + imul(a16, b00) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c16 = c16 + imul(a00, b16) | 0;
    c32 = c32 + (c16 >>> 16) | 0;
    c16 = c16 & 65535;
    c32 = c32 + imul(a32, b00) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a16, b16) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c32 = c32 + imul(a00, b32) | 0;
    c48 = c48 + (c32 >>> 16) | 0;
    c32 = c32 & 65535;
    c48 = c48 + (((imul(a48, b00) + imul(a32, b16) | 0) + imul(a16, b32) | 0) + imul(a00, b48) | 0) | 0;
    c48 = c48 & 65535;
    return new Long(c16 << 16 | c00, c48 << 16 | c32);
  }
  function divide(_this_, other) {
    if (isZero(other)) {
      throw Exception_init_$Create$('division by zero');
    } else if (isZero(_this_)) {
      return ZERO;
    }if (equalsLong(_this_, MIN_VALUE)) {
      if (equalsLong(other, ONE) ? true : equalsLong(other, NEG_ONE)) {
        return MIN_VALUE;
      } else if (equalsLong(other, MIN_VALUE)) {
        return ONE;
      } else {
        var halfThis = shiftRight(_this_, 1);
        var approx = shiftLeft(halfThis.div_27(other), 1);
        if (equalsLong(approx, ZERO)) {
          return isNegative(other) ? ONE : NEG_ONE;
        } else {
          var rem = subtract(_this_, multiply(other, approx));
          return add(approx, rem.div_27(other));
        }
      }
    } else if (equalsLong(other, MIN_VALUE)) {
      return ZERO;
    }if (isNegative(_this_)) {
      var tmp;
      if (isNegative(other)) {
        tmp = negate(_this_).div_27(negate(other));
      } else {
        tmp = negate(negate(_this_).div_27(other));
      }
      return tmp;
    } else if (isNegative(other)) {
      return negate(_this_.div_27(negate(other)));
    }var res = ZERO;
    var rem_0 = _this_;
    while (greaterThanOrEqual(rem_0, other)) {
      var approxDouble = toNumber(rem_0) / toNumber(other);
      var approx2 = Math.max(1.0, Math.floor(approxDouble));
      var log2 = Math.ceil(Math.log(approx2) / Math.LN2);
      var delta = log2 <= 48.0 ? 1.0 : Math.pow(2, log2 - 48);
      var approxRes = fromNumber(approx2);
      var approxRem = multiply(approxRes, other);
      while (isNegative(approxRem) ? true : greaterThan(approxRem, rem_0)) {
        approx2 = approx2 - delta;
        approxRes = fromNumber(approx2);
        approxRem = multiply(approxRes, other);
      }
      if (isZero(approxRes)) {
        approxRes = ONE;
      }res = add(res, approxRes);
      rem_0 = subtract(rem_0, approxRem);
    }
    return res;
  }
  function shiftLeft(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low << numBits_0, _this_._high << numBits_0 | _this_._low >>> (32 - numBits_0 | 0));
      } else {
        return new Long(0, _this_._low << (numBits_0 - 32 | 0));
      }
    }
  }
  function shiftRight(_this_, numBits) {
    var numBits_0 = numBits & 63;
    if (numBits_0 === 0) {
      return _this_;
    } else {
      if (numBits_0 < 32) {
        return new Long(_this_._low >>> numBits_0 | _this_._high << (32 - numBits_0 | 0), _this_._high >> numBits_0);
      } else {
        return new Long(_this_._high >> (numBits_0 - 32 | 0), _this_._high >= 0 ? 0 : -1);
      }
    }
  }
  function toNumber(_this_) {
    return _this_._high * 4.294967296E9 + getLowBitsUnsigned(_this_);
  }
  function equalsLong(_this_, other) {
    return _this_._high === other._high ? _this_._low === other._low : false;
  }
  function hashCode_0(l) {
    return l._low ^ l._high;
  }
  function toStringImpl(_this_, radix) {
    if (radix < 2 ? true : 36 < radix) {
      throw Exception_init_$Create$('' + 'radix out of range: ' + radix);
    }if (isZero(_this_)) {
      return '0';
    }if (isNegative(_this_)) {
      if (equalsLong(_this_, MIN_VALUE)) {
        var radixLong = fromInt(radix);
        var div = _this_.div_27(radixLong);
        var rem = subtract(multiply(div, radixLong), _this_).toInt_5();
        var tmp = toStringImpl(div, radix);
        var tmp0_unsafeCast_0 = rem.toString(radix);
        return tmp + tmp0_unsafeCast_0;
      } else {
        return '' + '-' + toStringImpl(negate(_this_), radix);
      }
    }var radixToPower = fromNumber(Math.pow(radix, 6.0));
    var rem_0 = _this_;
    var result = '';
    while (true) {
      var remDiv = rem_0.div_27(radixToPower);
      var intval = subtract(rem_0, multiply(remDiv, radixToPower)).toInt_5();
      var tmp1_unsafeCast_0 = intval.toString(radix);
      var digits = tmp1_unsafeCast_0;
      rem_0 = remDiv;
      if (isZero(rem_0)) {
        return digits + result;
      } else {
        while (digits.length < 6) {
          digits = '0' + digits;
        }
        result = digits + result;
      }
    }
  }
  function fromInt(value) {
    return new Long(value, value < 0 ? -1 : 0);
  }
  function isNegative(_this_) {
    return _this_._high < 0;
  }
  function isZero(_this_) {
    return _this_._high === 0 ? _this_._low === 0 : false;
  }
  function isOdd(_this_) {
    return (_this_._low & 1) === 1;
  }
  function negate(_this_) {
    return _this_.unaryMinus_4();
  }
  function lessThan(_this_, other) {
    return compare(_this_, other) < 0;
  }
  function fromNumber(value) {
    if (isNaN_0(value)) {
      return ZERO;
    } else if (value <= -9.223372036854776E18) {
      return MIN_VALUE;
    } else if (value + 1 >= 9.223372036854776E18) {
      return MAX_VALUE;
    } else if (value < 0.0) {
      return negate(fromNumber(-value));
    } else {
      var twoPwr32 = 4.294967296E9;
      return new Long(jsBitwiseOr(value % twoPwr32, 0), jsBitwiseOr(value / twoPwr32, 0));
    }
  }
  function greaterThan(_this_, other) {
    return compare(_this_, other) > 0;
  }
  function greaterThanOrEqual(_this_, other) {
    return compare(_this_, other) >= 0;
  }
  function getLowBitsUnsigned(_this_) {
    return _this_._low >= 0 ? _this_._low : 4.294967296E9 + _this_._low;
  }
  function imul(a_local, b_local) {
    var lhs = jsBitwiseAnd(a_local, 4.29490176E9) * jsBitwiseAnd(b_local, 65535);
    var rhs = jsBitwiseAnd(a_local, 65535) * b_local;
    return jsBitwiseOr(lhs + rhs, 0);
  }
  function numberToInt(a) {
    var tmp;
    if (a instanceof Long) {
      tmp = a.toInt_5();
    } else {
      {
        tmp = doubleToInt(a);
      }
    }
    return tmp;
  }
  function doubleToInt(a) {
    return a > 2.147483647E9 ? 2147483647 : a < -2.147483648E9 ? -2147483648 : jsBitwiseOr(a, 0);
  }
  function toShort(a) {
    var tmp0_unsafeCast_0 = a << 16 >> 16;
    return tmp0_unsafeCast_0;
  }
  function numberToChar(a) {
    var tmp0_Char_0 = numberToInt(a) & 65535;
    var tmp;
    var tmp0__get_code__0_1 = new Char(0);
    if (tmp0_Char_0 < tmp0__get_code__0_1.toInt_5()) {
      tmp = true;
    } else {
      {
        var tmp1__get_code__0_2 = new Char(65535);
        tmp = tmp0_Char_0 > tmp1__get_code__0_2.toInt_5();
      }
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$('' + 'Invalid Char code: ' + tmp0_Char_0);
    } else {
    }
    return new Char(_UShort___init__impl_(toShort(tmp0_Char_0)));
  }
  function numberRangeToNumber(start, endInclusive) {
    return new IntRange(start, endInclusive);
  }
  function isArrayish(o) {
    var tmp;
    if (isJsArray(o)) {
      tmp = true;
    } else {
      var tmp0_unsafeCast_0 = ArrayBuffer.isView(o);
      tmp = tmp0_unsafeCast_0;
    }
    return tmp;
  }
  function isJsArray(obj) {
    var tmp0_unsafeCast_0 = Array.isArray(obj);
    return tmp0_unsafeCast_0;
  }
  function isInterface(obj, iface) {
    var tmp0_elvis_lhs = obj.constructor;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var ctor = tmp;
    return isInterfaceImpl(ctor, iface);
  }
  function isInterfaceImpl(ctor, iface) {
    if (ctor === iface)
      return true;
    var metadata = ctor.$metadata$;
    if (!(metadata == null)) {
      var interfaces = metadata.interfaces;
      var indexedObject = interfaces;
      var inductionVariable = 0;
      var last_0 = indexedObject.length;
      while (inductionVariable < last_0) {
        var i = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (isInterfaceImpl(i, iface)) {
          return true;
        }}
    }var superPrototype = !(ctor.prototype == null) ? Object.getPrototypeOf(ctor.prototype) : null;
    var superConstructor = superPrototype != null ? superPrototype.constructor : null;
    return !(superConstructor == null) ? isInterfaceImpl(superConstructor, iface) : false;
  }
  function isArray(obj) {
    var tmp;
    if (isJsArray(obj)) {
      tmp = !obj.$type$;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isObject(obj) {
    var objTypeOf = typeof obj;
    var tmp0_subject = objTypeOf;
    switch (tmp0_subject) {
      case 'string':
        return true;
      case 'number':
        return true;
      case 'boolean':
        return true;
      case 'function':
        return true;
      default:return jsInstanceOf(obj, Object);
    }
  }
  function isNumber(a) {
    var tmp;
    if (typeof a === 'number') {
      tmp = true;
    } else {
      tmp = a instanceof Long;
    }
    return tmp;
  }
  function isCharSequence(value) {
    return typeof value === 'string' ? true : isInterface(value, _get_js_(getKClass_0(CharSequence)));
  }
  function isBooleanArray(a) {
    return isJsArray(a) ? a.$type$ === 'BooleanArray' : false;
  }
  function isByteArray(a) {
    return jsInstanceOf(a, Int8Array);
  }
  function isShortArray(a) {
    return jsInstanceOf(a, Int16Array);
  }
  function isCharArray(a) {
    return isJsArray(a) ? a.$type$ === 'CharArray' : false;
  }
  function isIntArray(a) {
    return jsInstanceOf(a, Int32Array);
  }
  function isFloatArray(a) {
    return jsInstanceOf(a, Float32Array);
  }
  function isLongArray(a) {
    return isJsArray(a) ? a.$type$ === 'LongArray' : false;
  }
  function isDoubleArray(a) {
    return jsInstanceOf(a, Float64Array);
  }
  function asList(_this_) {
    return new ArrayList(_this_);
  }
  function Exception_init_$Init$($this) {
    extendThrowable($this, void 1, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Init$_0(message, $this) {
    extendThrowable($this, message, void 1);
    Exception.call($this);
    return $this;
  }
  function Exception_init_$Create$(message) {
    var tmp = Exception_init_$Init$_0(message, Object.create(Exception.prototype));
    captureStack(tmp, Exception_init_$Create$);
    return tmp;
  }
  function Exception() {
    captureStack(this, Exception);
  }
  Exception.$metadata$ = {
    simpleName: 'Exception',
    kind: 'class',
    interfaces: []
  };
  function IllegalArgumentException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalArgumentException.call($this);
    return $this;
  }
  function IllegalArgumentException_init_$Create$(message) {
    var tmp = IllegalArgumentException_init_$Init$(message, Object.create(IllegalArgumentException.prototype));
    captureStack(tmp, IllegalArgumentException_init_$Create$);
    return tmp;
  }
  function IllegalArgumentException() {
    captureStack(this, IllegalArgumentException);
  }
  IllegalArgumentException.$metadata$ = {
    simpleName: 'IllegalArgumentException',
    kind: 'class',
    interfaces: []
  };
  function RuntimeException_init_$Init$($this) {
    Exception_init_$Init$($this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException_init_$Init$_0(message, $this) {
    Exception_init_$Init$_0(message, $this);
    RuntimeException.call($this);
    return $this;
  }
  function RuntimeException() {
    captureStack(this, RuntimeException);
  }
  RuntimeException.$metadata$ = {
    simpleName: 'RuntimeException',
    kind: 'class',
    interfaces: []
  };
  function NoSuchElementException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$() {
    var tmp = NoSuchElementException_init_$Init$(Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$);
    return tmp;
  }
  function NoSuchElementException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    NoSuchElementException.call($this);
    return $this;
  }
  function NoSuchElementException_init_$Create$_0(message) {
    var tmp = NoSuchElementException_init_$Init$_0(message, Object.create(NoSuchElementException.prototype));
    captureStack(tmp, NoSuchElementException_init_$Create$_0);
    return tmp;
  }
  function NoSuchElementException() {
    captureStack(this, NoSuchElementException);
  }
  NoSuchElementException.$metadata$ = {
    simpleName: 'NoSuchElementException',
    kind: 'class',
    interfaces: []
  };
  function IllegalStateException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IllegalStateException.call($this);
    return $this;
  }
  function IllegalStateException_init_$Create$(message) {
    var tmp = IllegalStateException_init_$Init$(message, Object.create(IllegalStateException.prototype));
    captureStack(tmp, IllegalStateException_init_$Create$);
    return tmp;
  }
  function IllegalStateException() {
    captureStack(this, IllegalStateException);
  }
  IllegalStateException.$metadata$ = {
    simpleName: 'IllegalStateException',
    kind: 'class',
    interfaces: []
  };
  function IndexOutOfBoundsException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    IndexOutOfBoundsException.call($this);
    return $this;
  }
  function IndexOutOfBoundsException_init_$Create$(message) {
    var tmp = IndexOutOfBoundsException_init_$Init$(message, Object.create(IndexOutOfBoundsException.prototype));
    captureStack(tmp, IndexOutOfBoundsException_init_$Create$);
    return tmp;
  }
  function IndexOutOfBoundsException() {
    captureStack(this, IndexOutOfBoundsException);
  }
  IndexOutOfBoundsException.$metadata$ = {
    simpleName: 'IndexOutOfBoundsException',
    kind: 'class',
    interfaces: []
  };
  function UnsupportedOperationException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$() {
    var tmp = UnsupportedOperationException_init_$Init$(Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$);
    return tmp;
  }
  function UnsupportedOperationException_init_$Init$_0(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    UnsupportedOperationException.call($this);
    return $this;
  }
  function UnsupportedOperationException_init_$Create$_0(message) {
    var tmp = UnsupportedOperationException_init_$Init$_0(message, Object.create(UnsupportedOperationException.prototype));
    captureStack(tmp, UnsupportedOperationException_init_$Create$_0);
    return tmp;
  }
  function UnsupportedOperationException() {
    captureStack(this, UnsupportedOperationException);
  }
  UnsupportedOperationException.$metadata$ = {
    simpleName: 'UnsupportedOperationException',
    kind: 'class',
    interfaces: []
  };
  function ArithmeticException_init_$Init$(message, $this) {
    RuntimeException_init_$Init$_0(message, $this);
    ArithmeticException.call($this);
    return $this;
  }
  function ArithmeticException_init_$Create$(message) {
    var tmp = ArithmeticException_init_$Init$(message, Object.create(ArithmeticException.prototype));
    captureStack(tmp, ArithmeticException_init_$Create$);
    return tmp;
  }
  function ArithmeticException() {
    captureStack(this, ArithmeticException);
  }
  ArithmeticException.$metadata$ = {
    simpleName: 'ArithmeticException',
    kind: 'class',
    interfaces: []
  };
  function NullPointerException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    NullPointerException.call($this);
    return $this;
  }
  function NullPointerException_init_$Create$() {
    var tmp = NullPointerException_init_$Init$(Object.create(NullPointerException.prototype));
    captureStack(tmp, NullPointerException_init_$Create$);
    return tmp;
  }
  function NullPointerException() {
    captureStack(this, NullPointerException);
  }
  NullPointerException.$metadata$ = {
    simpleName: 'NullPointerException',
    kind: 'class',
    interfaces: []
  };
  function ClassCastException_init_$Init$($this) {
    RuntimeException_init_$Init$($this);
    ClassCastException.call($this);
    return $this;
  }
  function ClassCastException_init_$Create$() {
    var tmp = ClassCastException_init_$Init$(Object.create(ClassCastException.prototype));
    captureStack(tmp, ClassCastException_init_$Create$);
    return tmp;
  }
  function ClassCastException() {
    captureStack(this, ClassCastException);
  }
  ClassCastException.$metadata$ = {
    simpleName: 'ClassCastException',
    kind: 'class',
    interfaces: []
  };
  function jsIn(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack in rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseOr(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack | rhs_hack;
    return tmp0_unsafeCast_0;
  }
  function jsTypeOf(value_hack) {
    var tmp0_unsafeCast_0 = typeof value_hack;
    return tmp0_unsafeCast_0;
  }
  function jsDeleteProperty(obj_hack, property_hack) {
    delete obj_hack[property_hack];
  }
  function jsInstanceOf(obj_hack, jsClass_hack) {
    var tmp0_unsafeCast_0 = obj_hack instanceof jsClass_hack;
    return tmp0_unsafeCast_0;
  }
  function jsBitwiseAnd(lhs_hack, rhs_hack) {
    var tmp0_unsafeCast_0 = lhs_hack & rhs_hack;
    return tmp0_unsafeCast_0;
  }
  var emptyMap_0;
  function AttributeEnum() {
  }
  AttributeEnum.$metadata$ = {
    simpleName: 'AttributeEnum',
    kind: 'interface',
    interfaces: []
  };
  function Tag() {
  }
  Tag.prototype.unaryPlus_4 = function (_this__0) {
    this.text_5(_this__0);
  };
  Tag.prototype.text_5 = function (s) {
    this._get_consumer__8().onTagContent_1(s);
  };
  Tag.$metadata$ = {
    simpleName: 'Tag',
    kind: 'interface',
    interfaces: []
  };
  function TagConsumer() {
  }
  TagConsumer.prototype.onTagError_1 = function (tag, exception) {
    throw exception;
  };
  TagConsumer.$metadata$ = {
    simpleName: 'TagConsumer',
    kind: 'interface',
    interfaces: []
  };
  function Unsafe() {
  }
  Unsafe.prototype.raw_0 = function (s) {
    this.unaryPlus_4(s);
  };
  Unsafe.$metadata$ = {
    simpleName: 'Unsafe',
    kind: 'interface',
    interfaces: []
  };
  function unsafe(_this_, block) {
    return _this_._get_consumer__8().onTagContentUnsafe_1(block);
  }
  function attributesMapOf(key, value) {
    var tmp0_subject = value;
    return tmp0_subject == null ? emptyMap_0 : singletonMapOf(key, value);
  }
  function singletonMapOf(key, value) {
    return new SingletonStringMap(key, value);
  }
  function SingletonStringMap(key, value) {
    this._key_0 = key;
    this._value_1 = value;
  }
  SingletonStringMap.prototype._get_key__3 = function () {
    return this._key_0;
  };
  SingletonStringMap.prototype._get_value__3 = function () {
    return this._value_1;
  };
  SingletonStringMap.prototype._get_entries__7 = function () {
    return setOf(this);
  };
  SingletonStringMap.prototype._get_size__26 = function () {
    return 1;
  };
  SingletonStringMap.prototype.containsKey_8 = function (key) {
    return key === this._key_0;
  };
  SingletonStringMap.prototype.containsKey_9 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_8((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  SingletonStringMap.prototype.get_26 = function (key) {
    return key === this._key_0 ? this._value_1 : null;
  };
  SingletonStringMap.prototype.get_25 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_26((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  SingletonStringMap.prototype.isEmpty_26 = function () {
    return false;
  };
  SingletonStringMap.prototype.toString = function () {
    return '' + 'SingletonStringMap(key=' + this._key_0 + ', value=' + this._value_1 + ')';
  };
  SingletonStringMap.prototype.hashCode = function () {
    return imul(getStringHashCode(this._key_0), 31) + getStringHashCode(this._value_1) | 0;
  };
  SingletonStringMap.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SingletonStringMap))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof SingletonStringMap ? other : THROW_CCE();
    if (!(this._key_0 === tmp0_other_with_cast._key_0))
      return false;
    if (!(this._value_1 === tmp0_other_with_cast._value_1))
      return false;
    return true;
  };
  SingletonStringMap.$metadata$ = {
    simpleName: 'SingletonStringMap',
    kind: 'class',
    interfaces: [Map_0, Entry]
  };
  function attributesMapOf_0(pairs) {
    var result = null;
    var nestedLast = pairs.length - 1 | 0;
    var inductionVariable = 0;
    var last_0 = getProgressionLastElement(0, nestedLast, 2);
    if (inductionVariable <= last_0)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 2 | 0;
        var k = pairs[i];
        var v = pairs[i + 1 | 0];
        if (!(k == null) ? !(v == null) : false) {
          if (result == null) {
            result = LinkedHashMap_init_$Create$();
          }result.put_7(k, v);
          Unit_getInstance();
        }}
       while (!(i === last_0));
    var tmp1_elvis_lhs = result;
    return tmp1_elvis_lhs == null ? emptyMap_0 : tmp1_elvis_lhs;
  }
  function DefaultUnsafe() {
    this._sb = StringBuilder_init_$Create$_0();
  }
  DefaultUnsafe.prototype.unaryPlus_4 = function (_this__0) {
    this._sb.append_4(_this__0);
    Unit_getInstance();
  };
  DefaultUnsafe.prototype.toString = function () {
    return this._sb.toString();
  };
  DefaultUnsafe.$metadata$ = {
    simpleName: 'DefaultUnsafe',
    kind: 'class',
    interfaces: [Unsafe]
  };
  function Attribute(encoder) {
    this._encoder = encoder;
  }
  Attribute.prototype.get_23 = function (thisRef, attributeName) {
    var tmp0_safe_receiver = thisRef._get_attributes__4().get_25(attributeName);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = this._encoder.decode_3(attributeName, tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? this._encoder.empty_3(attributeName, thisRef) : tmp1_elvis_lhs;
  };
  Attribute.prototype.set_4 = function (thisRef, attributeName, value) {
    thisRef._get_attributes__4().put_7(attributeName, this._encoder.encode_6(attributeName, value));
    Unit_getInstance();
  };
  Attribute.$metadata$ = {
    simpleName: 'Attribute',
    kind: 'class',
    interfaces: []
  };
  function StringAttribute() {
    Attribute.call(this, StringEncoder_getInstance());
  }
  StringAttribute.$metadata$ = {
    simpleName: 'StringAttribute',
    kind: 'class',
    interfaces: []
  };
  function StringSetAttribute() {
    Attribute.call(this, StringSetEncoder_getInstance());
  }
  StringSetAttribute.$metadata$ = {
    simpleName: 'StringSetAttribute',
    kind: 'class',
    interfaces: []
  };
  function BooleanAttribute(trueValue, falseValue) {
    Attribute.call(this, new BooleanEncoder(trueValue, falseValue));
  }
  BooleanAttribute.$metadata$ = {
    simpleName: 'BooleanAttribute',
    kind: 'class',
    interfaces: []
  };
  function EnumAttribute(values_0) {
    Attribute.call(this, new EnumEncoder(values_0));
    this._values_0 = values_0;
  }
  EnumAttribute.$metadata$ = {
    simpleName: 'EnumAttribute',
    kind: 'class',
    interfaces: []
  };
  function AttributeEncoder() {
  }
  AttributeEncoder.prototype.empty_3 = function (attributeName, tag) {
    throw IllegalStateException_init_$Create$('' + 'Attribute ' + attributeName + ' is not yet defined for tag ' + tag._get_tagName__4());
  };
  AttributeEncoder.$metadata$ = {
    simpleName: 'AttributeEncoder',
    kind: 'interface',
    interfaces: []
  };
  function StringEncoder() {
    StringEncoder_instance = this;
  }
  StringEncoder.prototype.encode_0 = function (attributeName, value) {
    return value;
  };
  StringEncoder.prototype.encode_6 = function (attributeName, value) {
    return this.encode_0(attributeName, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  StringEncoder.prototype.decode_3 = function (attributeName, value) {
    return value;
  };
  StringEncoder.$metadata$ = {
    simpleName: 'StringEncoder',
    kind: 'object',
    interfaces: [AttributeEncoder]
  };
  var StringEncoder_instance;
  function StringEncoder_getInstance() {
    if (StringEncoder_instance == null)
      new StringEncoder();
    return StringEncoder_instance;
  }
  function StringSetEncoder() {
    StringSetEncoder_instance = this;
  }
  StringSetEncoder.prototype.encode_2 = function (attributeName, value) {
    return joinToString$default_0(value, ' ', null, null, 0, null, null, 62, null);
  };
  StringSetEncoder.prototype.encode_6 = function (attributeName, value) {
    return this.encode_2(attributeName, (!(value == null) ? isInterface(value, Set) : false) ? value : THROW_CCE());
  };
  StringSetEncoder.prototype.decode_3 = function (attributeName, value) {
    return ensureNotNull(stringSetDecode(value));
  };
  StringSetEncoder.prototype.empty_3 = function (attributeName, tag) {
    return emptySet();
  };
  StringSetEncoder.$metadata$ = {
    simpleName: 'StringSetEncoder',
    kind: 'object',
    interfaces: [AttributeEncoder]
  };
  var StringSetEncoder_instance;
  function StringSetEncoder_getInstance() {
    if (StringSetEncoder_instance == null)
      new StringSetEncoder();
    return StringSetEncoder_instance;
  }
  function BooleanEncoder(trueValue, falseValue) {
    this._trueValue = trueValue;
    this._falseValue = falseValue;
  }
  BooleanEncoder.prototype.encode_4 = function (attributeName, value) {
    return value ? this._trueValue : this._falseValue;
  };
  BooleanEncoder.prototype.encode_6 = function (attributeName, value) {
    return this.encode_4(attributeName, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  BooleanEncoder.prototype.decode_3 = function (attributeName, value) {
    var tmp0_subject = value;
    var tmp;
    if (tmp0_subject === this._trueValue) {
      tmp = true;
    } else if (tmp0_subject === this._falseValue) {
      tmp = false;
    } else {
      throw IllegalArgumentException_init_$Create$('' + 'Unknown value ' + value + ' for ' + attributeName);
    }
    return tmp;
  };
  BooleanEncoder.$metadata$ = {
    simpleName: 'BooleanEncoder',
    kind: 'class',
    interfaces: [AttributeEncoder]
  };
  function EnumEncoder(valuesMap) {
    this._valuesMap = valuesMap;
  }
  EnumEncoder.prototype.encode_6 = function (attributeName, value) {
    return value._get_realValue__0();
  };
  EnumEncoder.prototype.decode_3 = function (attributeName, value) {
    var tmp0_elvis_lhs = this._valuesMap.get_25(value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$('' + 'Unknown value ' + value + ' for ' + attributeName);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  EnumEncoder.$metadata$ = {
    simpleName: 'EnumEncoder',
    kind: 'class',
    interfaces: [AttributeEncoder]
  };
  function stringSetDecode(value) {
    var tmp0_safe_receiver = value;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp0_toRegex_0 = '\\s+';
      var tmp1_split_0 = Regex_init_$Create$(tmp0_toRegex_0);
      var tmp2_split_0 = 0;
      tmp = tmp1_split_0.split(tmp0_safe_receiver, tmp2_split_0);
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_filterNotTo_0_1 = ArrayList_init_$Create$();
      var tmp0_iterator_1_2 = tmp1_safe_receiver.iterator_38();
      while (tmp0_iterator_1_2.hasNext_12()) {
        var element_2_3 = tmp0_iterator_1_2.next_14();
        if (!(charSequenceLength(element_2_3) === 0)) {
          tmp0_filterNotTo_0_1.add_16(element_2_3);
          Unit_getInstance();
        } else {
        }
      }
      tmp_0 = tmp0_filterNotTo_0_1;
    }
    var tmp2_safe_receiver = tmp_0;
    return tmp2_safe_receiver == null ? null : toSet(tmp2_safe_receiver);
  }
  function enumEncode(_this_) {
    return _this_._get_realValue__0();
  }
  function switchToMutable($this) {
    var tmp;
    if ($this._backingMutable) {
      tmp = $this._backing;
    } else {
      $this._backingMutable = true;
      $this._backing = LinkedHashMap_init_$Create$_2($this._backing);
      tmp = $this._backing;
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, MutableMap) ? tmp_0 : THROW_CCE();
  }
  function DelegatingMap(initialValues, tag, consumer) {
    this._tag = tag;
    this._consumer = consumer;
    this._backing = initialValues;
    this._backingMutable = false;
  }
  DelegatingMap.prototype._get_size__26 = function () {
    return this._backing._get_size__26();
  };
  DelegatingMap.prototype.isEmpty_26 = function () {
    return this._backing.isEmpty_26();
  };
  DelegatingMap.prototype.containsKey_8 = function (key) {
    return this._backing.containsKey_9(key);
  };
  DelegatingMap.prototype.containsKey_9 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    else {
    }
    return this.containsKey_8((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  DelegatingMap.prototype.get_26 = function (key) {
    return this._backing.get_25(key);
  };
  DelegatingMap.prototype.get_25 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    else {
    }
    return this.get_26((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  DelegatingMap.prototype.put_6 = function (key, value) {
    var mutable = switchToMutable(this);
    var old = mutable.put_7(key, value);
    if (!(old === value)) {
      this._consumer().onTagAttributeChange_1(this._tag, key, value);
    }return old;
  };
  DelegatingMap.prototype.put_7 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.put_6(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  DelegatingMap.prototype._get_immutableEntries_ = function () {
    return this._backing._get_entries__7();
  };
  DelegatingMap.prototype._get_entries__7 = function () {
    return switchToMutable(this)._get_entries__7();
  };
  DelegatingMap.$metadata$ = {
    simpleName: 'DelegatingMap',
    kind: 'class',
    interfaces: [MutableMap]
  };
  function onFinalize(_this_, block) {
    return new FinalizeConsumer(_this_, _no_name_provided_$factory_29(block));
  }
  function FinalizeConsumer(downstream, block) {
    this._downstream = downstream;
    this._block = block;
    this._level = 0;
  }
  FinalizeConsumer.prototype.onTagStart_1 = function (tag) {
    this._downstream.onTagStart_1(tag);
    var tmp0_this = this;
    var tmp1 = tmp0_this._level;
    tmp0_this._level = tmp1 + 1 | 0;
    Unit_getInstance();
  };
  FinalizeConsumer.prototype.onTagEnd_1 = function (tag) {
    this._downstream.onTagEnd_1(tag);
    var tmp0_this = this;
    var tmp1 = tmp0_this._level;
    tmp0_this._level = tmp1 - 1 | 0;
    Unit_getInstance();
  };
  FinalizeConsumer.prototype.onTagAttributeChange_1 = function (tag, attribute, value) {
    return this._downstream.onTagAttributeChange_1(tag, attribute, value);
  };
  FinalizeConsumer.prototype.onTagEvent_1 = function (tag, event, value) {
    return this._downstream.onTagEvent_1(tag, event, value);
  };
  FinalizeConsumer.prototype.onTagContent_1 = function (content) {
    return this._downstream.onTagContent_1(content);
  };
  FinalizeConsumer.prototype.onTagContentUnsafe_1 = function (block) {
    return this._downstream.onTagContentUnsafe_1(block);
  };
  FinalizeConsumer.prototype.onTagError_1 = function (tag, exception) {
    return this._downstream.onTagError_1(tag, exception);
  };
  FinalizeConsumer.prototype.finalize_1 = function () {
    return this._block(this._downstream.finalize_1(), this._level > 0);
  };
  FinalizeConsumer.$metadata$ = {
    simpleName: 'FinalizeConsumer',
    kind: 'class',
    interfaces: [TagConsumer]
  };
  function _no_name_provided__40($block) {
    this._$block = $block;
  }
  _no_name_provided__40.prototype.invoke_58 = function (to_0, partial) {
    this._$block(to_0, partial);
    return to_0;
  };
  _no_name_provided__40.prototype.invoke_62 = function (p1, p2) {
    var tmp = (p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE();
    return this.invoke_58(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE());
  };
  _no_name_provided__40.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_29($block) {
    var i = new _no_name_provided__40($block);
    return function (p1, p2) {
      return i.invoke_58(p1, p2);
    };
  }
  function _set_id_(_this_, newValue) {
    attributeStringString.set_4(_this_, 'id', newValue);
  }
  function _set_classes_(_this_, newValue) {
    attributeSetStringStringSet.set_4(_this_, 'class', newValue);
  }
  function _get_classes_(_this_) {
    return attributeSetStringStringSet.get_23(_this_, 'class');
  }
  function CommonAttributeGroupFacade() {
  }
  CommonAttributeGroupFacade.$metadata$ = {
    simpleName: 'CommonAttributeGroupFacade',
    kind: 'interface',
    interfaces: [Tag]
  };
  var attributeStringString;
  var attributeSetStringStringSet;
  var attributeBooleanBooleanOnOff;
  var attributeInputTypeEnumInputTypeValues;
  var inputTypeValues;
  var InputType_button_instance;
  var InputType_checkBox_instance;
  var InputType_color_instance;
  var InputType_date_instance;
  var InputType_dateTime_instance;
  var InputType_dateTimeLocal_instance;
  var InputType_email_instance;
  var InputType_file_instance;
  var InputType_hidden_instance;
  var InputType_image_instance;
  var InputType_month_instance;
  var InputType_number_instance;
  var InputType_password_instance;
  var InputType_radio_instance;
  var InputType_range_instance;
  var InputType_reset_instance;
  var InputType_search_instance;
  var InputType_submit_instance;
  var InputType_text_instance;
  var InputType_tel_instance;
  var InputType_time_instance;
  var InputType_url_instance;
  var InputType_week_instance;
  function values() {
    return [InputType_button_getInstance(), InputType_checkBox_getInstance(), InputType_color_getInstance(), InputType_date_getInstance(), InputType_dateTime_getInstance(), InputType_dateTimeLocal_getInstance(), InputType_email_getInstance(), InputType_file_getInstance(), InputType_hidden_getInstance(), InputType_image_getInstance(), InputType_month_getInstance(), InputType_number_getInstance(), InputType_password_getInstance(), InputType_radio_getInstance(), InputType_range_getInstance(), InputType_reset_getInstance(), InputType_search_getInstance(), InputType_submit_getInstance(), InputType_text_getInstance(), InputType_tel_getInstance(), InputType_time_getInstance(), InputType_url_getInstance(), InputType_week_getInstance()];
  }
  var InputType_entriesInitialized;
  function InputType_initEntries() {
    if (InputType_entriesInitialized)
      return Unit_getInstance();
    InputType_entriesInitialized = true;
    InputType_button_instance = new InputType('button', 0, 'button');
    InputType_checkBox_instance = new InputType('checkBox', 1, 'checkbox');
    InputType_color_instance = new InputType('color', 2, 'color');
    InputType_date_instance = new InputType('date', 3, 'date');
    InputType_dateTime_instance = new InputType('dateTime', 4, 'datetime');
    InputType_dateTimeLocal_instance = new InputType('dateTimeLocal', 5, 'datetime-local');
    InputType_email_instance = new InputType('email', 6, 'email');
    InputType_file_instance = new InputType('file', 7, 'file');
    InputType_hidden_instance = new InputType('hidden', 8, 'hidden');
    InputType_image_instance = new InputType('image', 9, 'image');
    InputType_month_instance = new InputType('month', 10, 'month');
    InputType_number_instance = new InputType('number', 11, 'number');
    InputType_password_instance = new InputType('password', 12, 'password');
    InputType_radio_instance = new InputType('radio', 13, 'radio');
    InputType_range_instance = new InputType('range', 14, 'range');
    InputType_reset_instance = new InputType('reset', 15, 'reset');
    InputType_search_instance = new InputType('search', 16, 'search');
    InputType_submit_instance = new InputType('submit', 17, 'submit');
    InputType_text_instance = new InputType('text', 18, 'text');
    InputType_tel_instance = new InputType('tel', 19, 'tel');
    InputType_time_instance = new InputType('time', 20, 'time');
    InputType_url_instance = new InputType('url', 21, 'url');
    InputType_week_instance = new InputType('week', 22, 'week');
  }
  function InputType(name, ordinal, realValue) {
    Enum.call(this, name, ordinal);
    this._realValue = realValue;
  }
  InputType.prototype._get_realValue__0 = function () {
    return this._realValue;
  };
  InputType.$metadata$ = {
    simpleName: 'InputType',
    kind: 'class',
    interfaces: [AttributeEnum]
  };
  function InputType_button_getInstance() {
    InputType_initEntries();
    return InputType_button_instance;
  }
  function InputType_checkBox_getInstance() {
    InputType_initEntries();
    return InputType_checkBox_instance;
  }
  function InputType_color_getInstance() {
    InputType_initEntries();
    return InputType_color_instance;
  }
  function InputType_date_getInstance() {
    InputType_initEntries();
    return InputType_date_instance;
  }
  function InputType_dateTime_getInstance() {
    InputType_initEntries();
    return InputType_dateTime_instance;
  }
  function InputType_dateTimeLocal_getInstance() {
    InputType_initEntries();
    return InputType_dateTimeLocal_instance;
  }
  function InputType_email_getInstance() {
    InputType_initEntries();
    return InputType_email_instance;
  }
  function InputType_file_getInstance() {
    InputType_initEntries();
    return InputType_file_instance;
  }
  function InputType_hidden_getInstance() {
    InputType_initEntries();
    return InputType_hidden_instance;
  }
  function InputType_image_getInstance() {
    InputType_initEntries();
    return InputType_image_instance;
  }
  function InputType_month_getInstance() {
    InputType_initEntries();
    return InputType_month_instance;
  }
  function InputType_number_getInstance() {
    InputType_initEntries();
    return InputType_number_instance;
  }
  function InputType_password_getInstance() {
    InputType_initEntries();
    return InputType_password_instance;
  }
  function InputType_radio_getInstance() {
    InputType_initEntries();
    return InputType_radio_instance;
  }
  function InputType_range_getInstance() {
    InputType_initEntries();
    return InputType_range_instance;
  }
  function InputType_reset_getInstance() {
    InputType_initEntries();
    return InputType_reset_instance;
  }
  function InputType_search_getInstance() {
    InputType_initEntries();
    return InputType_search_instance;
  }
  function InputType_submit_getInstance() {
    InputType_initEntries();
    return InputType_submit_instance;
  }
  function InputType_text_getInstance() {
    InputType_initEntries();
    return InputType_text_instance;
  }
  function InputType_tel_getInstance() {
    InputType_initEntries();
    return InputType_tel_instance;
  }
  function InputType_time_getInstance() {
    InputType_initEntries();
    return InputType_time_instance;
  }
  function InputType_url_getInstance() {
    InputType_initEntries();
    return InputType_url_instance;
  }
  function InputType_week_getInstance() {
    InputType_initEntries();
    return InputType_week_instance;
  }
  function inputTypeValues$init$() {
    var tmp0_associateBy_0 = values();
    var capacity_1 = coerceAtLeast(mapCapacity(tmp0_associateBy_0.length), 16);
    var tmp0_associateByTo_0_2 = LinkedHashMap_init_$Create$_1(capacity_1);
    var indexedObject = tmp0_associateBy_0;
    var inductionVariable = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable < last_0) {
      var element_2_4 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      tmp0_associateByTo_0_2.put_7(element_2_4._realValue, element_2_4);
      Unit_getInstance();
    }
    return tmp0_associateByTo_0_2;
  }
  function HtmlBlockTag() {
  }
  HtmlBlockTag.$metadata$ = {
    simpleName: 'HtmlBlockTag',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, FlowContent]
  };
  function HtmlBlockInlineTag() {
  }
  HtmlBlockInlineTag.$metadata$ = {
    simpleName: 'HtmlBlockInlineTag',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, FlowPhrasingContent, HtmlBlockTag, HtmlInlineTag]
  };
  function CommonAttributeGroupFacadeFlowInteractivePhrasingContent() {
  }
  CommonAttributeGroupFacadeFlowInteractivePhrasingContent.$metadata$ = {
    simpleName: 'CommonAttributeGroupFacadeFlowInteractivePhrasingContent',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, CommonAttributeGroupFacadeFlowInteractiveContent, FlowPhrasingContent, HtmlBlockInlineTag, HtmlBlockTag, HtmlInlineTag]
  };
  function FlowPhrasingContent() {
  }
  FlowPhrasingContent.$metadata$ = {
    simpleName: 'FlowPhrasingContent',
    kind: 'interface',
    interfaces: [FlowContent, PhrasingContent]
  };
  function HtmlInlineTag() {
  }
  HtmlInlineTag.$metadata$ = {
    simpleName: 'HtmlInlineTag',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, PhrasingContent]
  };
  function CommonAttributeGroupFacadeFlowInteractiveContent() {
  }
  CommonAttributeGroupFacadeFlowInteractiveContent.$metadata$ = {
    simpleName: 'CommonAttributeGroupFacadeFlowInteractiveContent',
    kind: 'interface',
    interfaces: [CommonAttributeGroupFacade, HtmlBlockTag, InteractiveContent]
  };
  function FlowContent() {
  }
  FlowContent.$metadata$ = {
    simpleName: 'FlowContent',
    kind: 'interface',
    interfaces: [FlowOrHeadingContent, FlowOrMetaDataContent, FlowOrInteractiveContent, FlowOrPhrasingContent, FlowOrPhrasingOrMetaDataContent, SectioningOrFlowContent, FlowOrInteractiveOrPhrasingContent, Tag]
  };
  function PhrasingContent() {
  }
  PhrasingContent.$metadata$ = {
    simpleName: 'PhrasingContent',
    kind: 'interface',
    interfaces: [FlowOrPhrasingContent, FlowOrPhrasingOrMetaDataContent, FlowOrInteractiveOrPhrasingContent, Tag]
  };
  function InteractiveContent() {
  }
  InteractiveContent.$metadata$ = {
    simpleName: 'InteractiveContent',
    kind: 'interface',
    interfaces: [FlowOrInteractiveContent, FlowOrInteractiveOrPhrasingContent, Tag]
  };
  function FlowOrHeadingContent() {
  }
  FlowOrHeadingContent.$metadata$ = {
    simpleName: 'FlowOrHeadingContent',
    kind: 'interface',
    interfaces: [Tag]
  };
  function FlowOrMetaDataContent() {
  }
  FlowOrMetaDataContent.$metadata$ = {
    simpleName: 'FlowOrMetaDataContent',
    kind: 'interface',
    interfaces: [FlowOrPhrasingOrMetaDataContent, Tag]
  };
  function FlowOrInteractiveContent() {
  }
  FlowOrInteractiveContent.$metadata$ = {
    simpleName: 'FlowOrInteractiveContent',
    kind: 'interface',
    interfaces: [FlowOrInteractiveOrPhrasingContent, Tag]
  };
  function FlowOrPhrasingContent() {
  }
  FlowOrPhrasingContent.$metadata$ = {
    simpleName: 'FlowOrPhrasingContent',
    kind: 'interface',
    interfaces: [FlowOrInteractiveOrPhrasingContent, FlowOrPhrasingOrMetaDataContent, Tag]
  };
  function FlowOrPhrasingOrMetaDataContent() {
  }
  FlowOrPhrasingOrMetaDataContent.$metadata$ = {
    simpleName: 'FlowOrPhrasingOrMetaDataContent',
    kind: 'interface',
    interfaces: [Tag]
  };
  function SectioningOrFlowContent() {
  }
  SectioningOrFlowContent.$metadata$ = {
    simpleName: 'SectioningOrFlowContent',
    kind: 'interface',
    interfaces: [Tag]
  };
  function FlowOrInteractiveOrPhrasingContent() {
  }
  FlowOrInteractiveOrPhrasingContent.$metadata$ = {
    simpleName: 'FlowOrInteractiveOrPhrasingContent',
    kind: 'interface',
    interfaces: [Tag]
  };
  function BUTTON(initialAttributes, consumer) {
    HTMLTag.call(this, 'button', consumer, initialAttributes, null, true, false);
    this._consumer_0 = consumer;
  }
  BUTTON.prototype._get_consumer__8 = function () {
    return this._consumer_0;
  };
  BUTTON.$metadata$ = {
    simpleName: 'BUTTON',
    kind: 'class',
    interfaces: [CommonAttributeGroupFacadeFlowInteractivePhrasingContent]
  };
  function DIV(initialAttributes, consumer) {
    HTMLTag.call(this, 'div', consumer, initialAttributes, null, false, false);
    this._consumer_1 = consumer;
  }
  DIV.prototype._get_consumer__8 = function () {
    return this._consumer_1;
  };
  DIV.$metadata$ = {
    simpleName: 'DIV',
    kind: 'class',
    interfaces: [HtmlBlockTag]
  };
  function INPUT(initialAttributes, consumer) {
    HTMLTag.call(this, 'input', consumer, initialAttributes, null, true, true);
    this._consumer_2 = consumer;
  }
  INPUT.prototype._get_consumer__8 = function () {
    return this._consumer_2;
  };
  INPUT.prototype._set_type_ = function (newValue) {
    attributeInputTypeEnumInputTypeValues.set_4(this, 'type', newValue);
  };
  INPUT.prototype._set_autoComplete_ = function (newValue) {
    attributeBooleanBooleanOnOff.set_4(this, 'autocomplete', newValue);
  };
  INPUT.prototype._set_placeholder_ = function (newValue) {
    attributeStringString.set_4(this, 'placeholder', newValue);
  };
  INPUT.prototype._set_name_ = function (newValue) {
    attributeStringString.set_4(this, 'name', newValue);
  };
  INPUT.$metadata$ = {
    simpleName: 'INPUT',
    kind: 'class',
    interfaces: [CommonAttributeGroupFacadeFlowInteractivePhrasingContent]
  };
  function SPAN(initialAttributes, consumer) {
    HTMLTag.call(this, 'span', consumer, initialAttributes, null, true, false);
    this._consumer_3 = consumer;
  }
  SPAN.prototype._get_consumer__8 = function () {
    return this._consumer_3;
  };
  SPAN.$metadata$ = {
    simpleName: 'SPAN',
    kind: 'class',
    interfaces: [HtmlBlockInlineTag]
  };
  function _no_name_provided__41(this$0) {
    this._this$0_9 = this$0;
  }
  _no_name_provided__41.prototype.invoke_287 = function () {
    return this._this$0_9._get_consumer__8();
  };
  _no_name_provided__41.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function HTMLTag(tagName, consumer, initialAttributes, namespace, inlineTag, emptyTag) {
    this._tagName = tagName;
    this._consumer_4 = consumer;
    this._namespace = namespace;
    this._inlineTag = inlineTag;
    this._emptyTag = emptyTag;
    var tmp = this;
    tmp._attributes = new DelegatingMap(initialAttributes, this, _no_name_provided_$factory_30(this));
  }
  HTMLTag.prototype._get_tagName__4 = function () {
    return this._tagName;
  };
  HTMLTag.prototype._get_consumer__8 = function () {
    return this._consumer_4;
  };
  HTMLTag.prototype._get_namespace__4 = function () {
    return this._namespace;
  };
  HTMLTag.prototype._get_attributes__4 = function () {
    return this._attributes;
  };
  HTMLTag.prototype._get_attributesEntries__4 = function () {
    return this._get_attributes__4()._get_immutableEntries_();
  };
  HTMLTag.$metadata$ = {
    simpleName: 'HTMLTag',
    kind: 'class',
    interfaces: [Tag]
  };
  function _no_name_provided_$factory_30(this$0) {
    var i = new _no_name_provided__41(this$0);
    return function () {
      return i.invoke_287();
    };
  }
  function _get_create_(_this_) {
    return new JSDOMBuilder(_this_);
  }
  function append(_this_, block) {
    var tmp0_let_0 = ArrayList_init_$Create$();
    var tmp = createTree(_get_ownerDocumentExt_(_this_));
    block(onFinalize(tmp, _no_name_provided_$factory_31(tmp0_let_0, _this_)));
    return tmp0_let_0;
  }
  function asR(_this_, $this) {
    return _this_;
  }
  function JSDOMBuilder(document_0) {
    this._document = document_0;
    var tmp = this;
    tmp._path = ArrayList_init_$Create$();
    this._lastLeaved = null;
  }
  JSDOMBuilder.prototype.onTagStart_1 = function (tag) {
    var tmp;
    if (!(tag._get_namespace__4() == null)) {
      var tmp0_asDynamic_0 = this._document.createElementNS(ensureNotNull(tag._get_namespace__4()), tag._get_tagName__4());
      tmp = tmp0_asDynamic_0;
    } else {
      var tmp_0 = this._document.createElement(tag._get_tagName__4());
      tmp = tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE();
    }
    var element = tmp;
    var tmp1_forEach_0 = tag._get_attributesEntries__4();
    var tmp0_iterator_1 = tmp1_forEach_0.iterator_38();
    while (tmp0_iterator_1.hasNext_12()) {
      var element_2 = tmp0_iterator_1.next_14();
      element.setAttribute(element_2._get_key__3(), element_2._get_value__3());
    }
    var tmp2_isNotEmpty_0 = this._path;
    if (!tmp2_isNotEmpty_0.isEmpty_26()) {
      last(this._path).appendChild(element);
      Unit_getInstance();
    } else {
    }
    this._path.add_16(element);
    Unit_getInstance();
  };
  JSDOMBuilder.prototype.onTagAttributeChange_1 = function (tag, attribute, value) {
    if (this._path.isEmpty_26())
      throw IllegalStateException_init_$Create$('No current tag');
    else {
      var tmp0_toLowerCase_0 = last(this._path).tagName;
      var tmp = tmp0_toLowerCase_0.toLowerCase();
      var tmp1_toLowerCase_0 = tag._get_tagName__4();
      if (!(tmp === tmp1_toLowerCase_0.toLowerCase()))
        throw IllegalStateException_init_$Create$('Wrong current tag');
      else {
        {
          var tmp2_let_0 = last(this._path);
          if (value == null) {
            tmp2_let_0.removeAttribute(attribute);
          } else {
            tmp2_let_0.setAttribute(attribute, value);
          }
        }
      }
    }
  };
  JSDOMBuilder.prototype.onTagEvent_1 = function (tag, event, value) {
    if (this._path.isEmpty_26())
      throw IllegalStateException_init_$Create$('No current tag');
    else {
      var tmp0_toLowerCase_0 = last(this._path).tagName;
      var tmp = tmp0_toLowerCase_0.toLowerCase();
      var tmp1_toLowerCase_0 = tag._get_tagName__4();
      if (!(tmp === tmp1_toLowerCase_0.toLowerCase()))
        throw IllegalStateException_init_$Create$('Wrong current tag');
      else {
        {
          var tmp2_setEvent_0 = last(this._path);
          tmp2_setEvent_0[event] = value;
        }
      }
    }
  };
  JSDOMBuilder.prototype.onTagEnd_1 = function (tag) {
    var tmp;
    if (this._path.isEmpty_26()) {
      tmp = true;
    } else {
      var tmp0_toLowerCase_0 = last(this._path).tagName;
      var tmp_0 = tmp0_toLowerCase_0.toLowerCase();
      var tmp1_toLowerCase_0 = tag._get_tagName__4();
      tmp = !(tmp_0 === tmp1_toLowerCase_0.toLowerCase());
    }
    if (tmp) {
      throw IllegalStateException_init_$Create$('' + "We haven't entered tag " + tag._get_tagName__4() + ' but trying to leave');
    } else {
    }
    this._lastLeaved = this._path.removeAt_0(_get_lastIndex__0(this._path));
  };
  JSDOMBuilder.prototype.onTagContent_1 = function (content) {
    if (this._path.isEmpty_26()) {
      throw IllegalStateException_init_$Create$('No current DOM node');
    }last(this._path).appendChild(this._document.createTextNode(toString_1(content)));
    Unit_getInstance();
  };
  JSDOMBuilder.prototype.onTagContentUnsafe_1 = function (block) {
    var tmp0_with_0 = new DefaultUnsafe();
    block(tmp0_with_0);
    var tmp0_this_2 = last(this._path);
    tmp0_this_2.innerHTML = tmp0_this_2.innerHTML + tmp0_with_0.toString();
  };
  JSDOMBuilder.prototype.finalize_1 = function () {
    var tmp0_safe_receiver = this._lastLeaved;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : asR(tmp0_safe_receiver, this);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$("We can't finalize as there was no tags");
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  JSDOMBuilder.$metadata$ = {
    simpleName: 'JSDOMBuilder',
    kind: 'class',
    interfaces: [TagConsumer]
  };
  function createTree(_this_) {
    return new JSDOMBuilder(_this_);
  }
  function _get_ownerDocumentExt_(_this_) {
    var tmp;
    if (_this_ instanceof Document) {
      tmp = _this_;
    } else {
      {
        var tmp0_elvis_lhs = _this_.ownerDocument;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          throw IllegalStateException_init_$Create$('Node has no ownerDocument');
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      }
    }
    return tmp;
  }
  function _no_name_provided__42($tmp0_let_0, $this_append) {
    this._$tmp0_let_0 = $tmp0_let_0;
    this._$this_append = $this_append;
  }
  _no_name_provided__42.prototype.invoke_61 = function (it, partial) {
    if (!partial) {
      this._$tmp0_let_0.add_16(it);
      Unit_getInstance();
      this._$this_append.appendChild(it);
      Unit_getInstance();
    }};
  _no_name_provided__42.prototype.invoke_62 = function (p1, p2) {
    var tmp = p1 instanceof HTMLElement ? p1 : THROW_CCE();
    this.invoke_61(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__42.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_31($tmp0_let_0, $this_append) {
    var i = new _no_name_provided__42($tmp0_let_0, $this_append);
    return function (p1, p2) {
      i.invoke_61(p1, p2);
      return Unit_getInstance();
    };
  }
  function _set_onClickFunction_(_this_, newValue) {
    _this_._get_consumer__8().onTagEvent_1(_this_, 'onclick', newValue);
  }
  function _set_onFocusFunction_(_this_, newValue) {
    _this_._get_consumer__8().onTagEvent_1(_this_, 'onfocus', newValue);
  }
  function _set_onBlurFunction_(_this_, newValue) {
    _this_._get_consumer__8().onTagEvent_1(_this_, 'onblur', newValue);
  }
  function _set_onKeyUpFunction_(_this_, newValue) {
    _this_._get_consumer__8().onTagEvent_1(_this_, 'onkeyup', newValue);
  }
  function visitTagAndFinalize(_this_, consumer, block) {
    if (!(_this_._get_consumer__8() === consumer)) {
      throw IllegalArgumentException_init_$Create$('Wrong exception');
    }visitTag(_this_, block);
    return consumer.finalize_1();
  }
  function visitTag(_this_, block) {
    _this_._get_consumer__8().onTagStart_1(_this_);
    try {
      block(_this_);
    } catch ($p) {
      if ($p instanceof Error) {
        _this_._get_consumer__8().onTagError_1(_this_, $p);
      } else {
        {
          throw $p;
        }
      }
    }
    finally {
      _this_._get_consumer__8().onTagEnd_1(_this_);
    }
  }
  function _no_name_provided__43($cardElement) {
    this._$cardElement = $cardElement;
  }
  _no_name_provided__43.prototype.invoke_283 = function () {
    interactions_getInstance().addInteractions(this._$cardElement);
  };
  _no_name_provided__43.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__43.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__44() {
  }
  _no_name_provided__44.prototype.invoke_287 = function () {
    var tmp0_copyOf_0 = cards;
    var tmp1_also_0 = tmp0_copyOf_0.slice();
    shuffle(tmp1_also_0);
    return tmp1_also_0;
  };
  _no_name_provided__44.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__45($cardDynamic, $cardElement) {
    this._$cardDynamic = $cardDynamic;
    this._$cardElement_0 = $cardElement;
  }
  _no_name_provided__45.prototype.invoke_287 = function () {
    this._$cardDynamic.style.transform = '' + 'matrix(1, 0, 0, 1, 0, ' + interactions_getInstance()._offsetY + ')';
    this._$cardDynamic.style.opacity = '1.0';
    var tmp = window;
    return function () {
      var $externalVarargReceiverTmp = tmp;
      return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_34(this._$cardElement_0), constants_getInstance()._get_animTimeIn_()]);
    }.call(this);
  };
  _no_name_provided__45.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function availableCards() {
    availableCards_instance = this;
    this._isLastCard = false;
    this._cardLimit = 25;
    this._cardCounter = 0;
    var tmp = this;
    tmp._deck = [];
  }
  availableCards.prototype._set_deck_ = function (value) {
    session_getInstance().set_5('deck', value);
    this._deck = value;
  };
  availableCards.prototype._get_deck_ = function () {
    this._isLastCard = this._deck.length === 1;
    var tmp0_isEmpty_0 = this._deck;
    if (tmp0_isEmpty_0.length === 0) {
      var tmp = this;
      var tmp_0 = session_getInstance().get_26('deck');
      var tmp_1 = (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : null;
      tmp._deck = whenNull(tmp_1, _no_name_provided_$factory_32());
    } else {
    }
    return this._deck;
  };
  availableCards.prototype.nextCard = function () {
    var tmp0_this = this;
    var tmp1 = tmp0_this._cardCounter;
    tmp0_this._cardCounter = tmp1 + 1 | 0;
    Unit_getInstance();
    (function () {
      var $externalVarargReceiverTmp = console;
      return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].concat(['' + this._cardCounter + '/25']));
    }.call(this));
    var tmp;
    if (!this._isLastCard ? this._cardCounter < 25 : false) {
      var res = first(this._get_deck_());
      var tmp0_toTypedArray_0 = drop(this._get_deck_(), 1);
      this._set_deck_(copyToArray_0(tmp0_toTypedArray_0));
      tmp = res;
    } else {
      game_getInstance()._set_isRunning_(false);
      tmp = endCard;
    }
    return tmp;
  };
  availableCards.prototype.putCard = function () {
    var tmp0_asDynamic_0 = document.querySelector('#play-name');
    tmp0_asDynamic_0.style.opacity = '1.0';
    var nc = this.nextCard();
    ensureNotNull(document.querySelector('#card-wrapper')).innerHTML = cardCompo(nc).outerHTML;
    var cardElement = ensureNotNull(document.querySelector('#card'));
    var cardDynamic = cardElement;
    cardDynamic.style.transition = 'all 0ms';
    cardDynamic.style.transform = '' + 'matrix(0.01, 0, 0, 0.01, 0, ' + interactions_getInstance()._offsetY + ')';
    cardDynamic.style.opacity = '0.01';
    cardDynamic.style.transition = '' + 'all ' + constants_getInstance()._get_animTimeIn_() + 'ms';
    var tmp = window;
    (function () {
      var $externalVarargReceiverTmp = tmp;
      return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_33(cardDynamic, cardElement), 20]);
    }.call(this));
    Unit_getInstance();
  };
  availableCards.$metadata$ = {
    simpleName: 'availableCards',
    kind: 'object',
    interfaces: []
  };
  var availableCards_instance;
  function availableCards_getInstance() {
    if (availableCards_instance == null)
      new availableCards();
    return availableCards_instance;
  }
  function _no_name_provided_$factory_32() {
    var i = new _no_name_provided__44();
    return function () {
      return i.invoke_287();
    };
  }
  function _no_name_provided_$factory_33($cardDynamic, $cardElement) {
    var i = new _no_name_provided__45($cardDynamic, $cardElement);
    return function () {
      return i.invoke_287();
    };
  }
  function _no_name_provided_$factory_34($cardElement) {
    var i = new _no_name_provided__43($cardElement);
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function cardCompo(data) {
    var tmp = data;
    var tmp_0 = data.title;
    tmp.title__error = (!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE();
    var tmp_1 = data;
    var tmp_2 = data.text;
    tmp_1.text__error = (!(tmp_2 == null) ? typeof tmp_2 === 'string' : false) ? tmp_2 : THROW_CCE();
    var tmp_3 = data;
    var tmp_4 = data.set;
    tmp_3.set__error = (!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : THROW_CCE();
    var tmp_5 = data;
    var tmp_6 = data.all;
    tmp_5.all__error = (!(tmp_6 == null) ? typeof tmp_6 === 'boolean' : false) ? tmp_6 : THROW_CCE();
    var tmp_7 = data;
    var tmp_8 = data.sips;
    tmp_7.sips__error = (!(tmp_8 == null) ? typeof tmp_8 === 'number' : false) ? tmp_8 : THROW_CCE();
    var cardPlayer = {_v: ''};
    if (data.all__error) {
      ensureNotNull(document.querySelector('#play-name')).textContent = 'Alle';
    } else {
      var tmp_9 = ensureNotNull(document.querySelector('#play-name'));
      var tmp0_also_0 = playerList_getInstance().randomPlayer();
      cardPlayer._v = tmp0_also_0;
      tmp_9.textContent = tmp0_also_0;
    }
    var tmp1_div_0 = _get_create_(document);
    var tmp2_div_0 = null;
    var tmp0_visitAndFinalize_0_2 = new DIV(attributesMapOf('class', tmp2_div_0), tmp1_div_0);
    return visitTagAndFinalize(tmp0_visitAndFinalize_0_2, tmp1_div_0, _no_name_provided_$factory_35(data, cardPlayer));
  }
  function _no_name_provided__46($cardPlayer) {
    this._$cardPlayer = $cardPlayer;
  }
  _no_name_provided__46.prototype.invoke_287 = function () {
    var zz_6_13 = playerList_getInstance().randomPlayer();
    while (zz_6_13 === this._$cardPlayer._v) {
      zz_6_13 = playerList_getInstance().randomPlayer();
    }
    return zz_6_13;
  };
  _no_name_provided__46.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__47() {
  }
  _no_name_provided__47.prototype.invoke_182 = function ($this$unsafe) {
    var tmp0_elvis_lhs_6_12_24 = difficulty_getInstance()._get_level_();
    $this$unsafe.raw_0(trimIndent('' + '\n                             <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="36"\n                                 viewBox="0 0 15 36" xml:space="preserve" style="background-color: transparent">\n                                <linearGradient id="rainbow" x1="0" x2="0" y1="0" y2="100%">\n                                    <stop stop-color="#FF0000" offset="0%"/>\n                                    <stop stop-color="#FF7F00" offset="20%"/>\n                                    <stop stop-color="#00BC3F" offset="40%"/>\n                                    <stop stop-color="#0068FF" offset="60%"/>\n                                    <stop stop-color="#7A00E5" offset="80%"/>\n                                    <stop stop-color="#D300C9" offset="100%"/>\n                                <\/linearGradient>\n                                <path fill="hsl(' + (120 - imul(60, tmp0_elvis_lhs_6_12_24 == null ? 0 : tmp0_elvis_lhs_6_12_24) | 0) + ', 90%, 64%)" d="m2,31 v-11 h11 v11 a1,.5,0,0,1,-11,0"/>\n                                <path stroke="floralwhite" fill="transparent" stroke-width="2px"\n                                    d="M2,31 v-18 c0,-3,3,0,3,-10 h5 m3,10 c0,-3,-3,0,-3,-10 h-1 m4,10 v18 a1,.5,0,0,1,-11,0" />\n                             <\/svg>\n                        '));
  };
  _no_name_provided__47.prototype.invoke_293 = function (p1) {
    this.invoke_182((!(p1 == null) ? isInterface(p1, Unsafe) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__47.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__48($data) {
    this._$data = $data;
  }
  _no_name_provided__48.prototype.invoke_290 = function (_this__0) {
    var tmp;
    if (this._$data.sips__error >= 0) {
      var tmp0_subject_6_11_17_29 = difficulty_getInstance()._get_level_();
      {
        var mul_5_10_16_28;
        switch (tmp0_subject_6_11_17_29) {
          case 0:
            mul_5_10_16_28 = 0.5;
            break;
          case 1:
            mul_5_10_16_28 = 1.0;
            break;
          case 2:
            mul_5_10_16_28 = 2.24;
            break;
          default:mul_5_10_16_28 = 1.0;
            break;
        }
      }
      var tmp0_ceil_0_7_12_18_30 = this._$data.sips__error * mul_5_10_16_28;
      var tmp0_unsafeCast_0_1_8_13_19_31 = Math.ceil(tmp0_ceil_0_7_12_18_30);
      tmp = '' + tmp0_unsafeCast_0_1_8_13_19_31;
    } else {
      tmp = '\u221E';
    }
    _this__0.unaryPlus_4(tmp);
  };
  _no_name_provided__48.prototype.invoke_293 = function (p1) {
    this.invoke_290(p1 instanceof SPAN ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__48.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__49($data) {
    this._$data_0 = $data;
  }
  _no_name_provided__49.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'card-set');
    _this__0.unaryPlus_4(this._$data_0.set__error);
  };
  _no_name_provided__49.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__49.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__50($data) {
    this._$data_1 = $data;
  }
  _no_name_provided__50.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'card-alt');
    unsafe(_this__0, _no_name_provided_$factory_42());
    var tmp0_span_0_7_13_25 = null;
    var tmp0_visit_0_2_8_14_26 = new SPAN(attributesMapOf('class', tmp0_span_0_7_13_25), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_8_14_26, _no_name_provided_$factory_43(this._$data_1));
  };
  _no_name_provided__50.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__50.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__51($data) {
    this._$data_2 = $data;
  }
  _no_name_provided__51.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'card-title');
    _this__0.unaryPlus_4(this._$data_2.title__error);
  };
  _no_name_provided__51.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__51.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__52($data, $cardPlayer) {
    this._$data_3 = $data;
    this._$cardPlayer_0 = $cardPlayer;
  }
  _no_name_provided__52.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'card-text');
    var tmp = this._$data_3.text__error;
    var tmp_0 = Regex_init_$Create$('\\[NAME\\d+]');
    _this__0.unaryPlus_4(replaceMultiple(tmp, tmp_0, _no_name_provided_$factory_39(this._$cardPlayer_0)));
  };
  _no_name_provided__52.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__52.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__53($data) {
    this._$data_4 = $data;
  }
  _no_name_provided__53.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'card-footer');
    var tmp0_div_0_5_17 = null;
    var tmp0_visit_0_2_6_18 = new DIV(attributesMapOf('class', tmp0_div_0_5_17), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_6_18, _no_name_provided_$factory_40(this._$data_4));
    var tmp1_div_0_8_20 = null;
    var tmp0_visit_0_2_9_21 = new DIV(attributesMapOf('class', tmp1_div_0_8_20), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_9_21, _no_name_provided_$factory_41(this._$data_4));
  };
  _no_name_provided__53.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__53.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__54($data, $cardPlayer) {
    this._$data_5 = $data;
    this._$cardPlayer_1 = $cardPlayer;
  }
  _no_name_provided__54.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'card');
    var tmp0_receiver_5 = _this__0;
    _set_classes_(tmp0_receiver_5, plus(_get_classes_(tmp0_receiver_5), 'blur'));
    var tmp0_div_0_6 = null;
    var tmp0_visit_0_2_7 = new DIV(attributesMapOf('class', tmp0_div_0_6), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7, _no_name_provided_$factory_36(this._$data_5));
    var tmp1_div_0_9 = null;
    var tmp0_visit_0_2_10 = new DIV(attributesMapOf('class', tmp1_div_0_9), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_10, _no_name_provided_$factory_37(this._$data_5, this._$cardPlayer_1));
    var tmp2_div_0_14 = null;
    var tmp0_visit_0_2_15 = new DIV(attributesMapOf('class', tmp2_div_0_14), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_15, _no_name_provided_$factory_38(this._$data_5));
  };
  _no_name_provided__54.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__54.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_35($data, $cardPlayer) {
    var i = new _no_name_provided__54($data, $cardPlayer);
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_36($data) {
    var i = new _no_name_provided__51($data);
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_37($data, $cardPlayer) {
    var i = new _no_name_provided__52($data, $cardPlayer);
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_38($data) {
    var i = new _no_name_provided__53($data);
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_39($cardPlayer) {
    var i = new _no_name_provided__46($cardPlayer);
    return function () {
      return i.invoke_287();
    };
  }
  function _no_name_provided_$factory_40($data) {
    var i = new _no_name_provided__49($data);
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_41($data) {
    var i = new _no_name_provided__50($data);
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_42() {
    var i = new _no_name_provided__47();
    return function (p1) {
      i.invoke_182(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_43($data) {
    var i = new _no_name_provided__48($data);
    return function (p1) {
      i.invoke_290(p1);
      return Unit_getInstance();
    };
  }
  function options() {
    window.location.hash = '#options';
    currentPage = '#options';
    var tmp0_div_0 = _get_create_(document);
    var tmp1_div_0 = null;
    var tmp0_visitAndFinalize_0_2 = new DIV(attributesMapOf('class', tmp1_div_0), tmp0_div_0);
    var tmp = visitTagAndFinalize(tmp0_visitAndFinalize_0_2, tmp0_div_0, _no_name_provided_$factory_44());
    return tmp instanceof HTMLDivElement ? tmp : THROW_CCE();
  }
  function _no_name_provided__55() {
  }
  _no_name_provided__55.prototype.invoke_285 = function (_anonymous_parameter_0_) {
    var tmp = startmenu();
    changePage$default(tmp, null, 2, null);
  };
  _no_name_provided__55.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__55.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__56($this) {
    this._$this_4 = $this;
  }
  _no_name_provided__56.prototype.invoke_285 = function (it) {
    var tmp = theme_getInstance();
    var tmp0_subject_11_15_19_27_30_38 = this._$this_4._get_attributes__4().get_26('data-id');
    tmp._set_isDark_(tmp0_subject_11_15_19_27_30_38 === '0' ? false : tmp0_subject_11_15_19_27_30_38 === '1' ? true : false);
  };
  _no_name_provided__56.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__56.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__57() {
  }
  _no_name_provided__57.prototype.invoke_285 = function (it) {
    var tmp = theme_getInstance();
    var tmp0_subject_7_21_25_33_36_44 = this.previousSibling.previousSibling.dataset.id;
    tmp._set_isDark_(tmp0_subject_7_21_25_33_36_44 == '0' ? false : tmp0_subject_7_21_25_33_36_44 == '1' ? true : false);
  };
  _no_name_provided__57.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__57.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__58() {
  }
  _no_name_provided__58.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_13_21_24_32 = _this__0;
    _set_classes_(tmp0_receiver_5_9_13_21_24_32, plus(_get_classes_(tmp0_receiver_5_9_13_21_24_32), 'options-chkbx'));
    var tmp1_receiver_6_10_14_22_25_33 = _this__0;
    _set_classes_(tmp1_receiver_6_10_14_22_25_33, plus(_get_classes_(tmp1_receiver_6_10_14_22_25_33), 'btn'));
    var tmp0_set_0_7_11_15_23_26_34 = _this__0._get_attributes__4();
    var tmp1_set_0_8_12_16_24_27_35 = 'data-id';
    var tmp2_set_0_9_13_17_25_28_36 = '0';
    tmp0_set_0_7_11_15_23_26_34.put_7(tmp1_set_0_8_12_16_24_27_35, tmp2_set_0_9_13_17_25_28_36);
    Unit_getInstance();
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_57(_this__0));
  };
  _no_name_provided__58.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__58.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__59() {
  }
  _no_name_provided__59.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_19_23_31_34_42 = _this__0;
    _set_classes_(tmp0_receiver_5_19_23_31_34_42, plus(_get_classes_(tmp0_receiver_5_19_23_31_34_42), 'options-switchTitle'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_58());
    _this__0.unaryPlus_4('Hell');
  };
  _no_name_provided__59.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__59.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__60($this) {
    this._$this_5 = $this;
  }
  _no_name_provided__60.prototype.invoke_285 = function (it) {
    var tmp = theme_getInstance();
    var tmp0_subject_11_15_39_47_50_58 = this._$this_5._get_attributes__4().get_26('data-id');
    tmp._set_isDark_(tmp0_subject_11_15_39_47_50_58 === '0' ? false : tmp0_subject_11_15_39_47_50_58 === '1' ? true : false);
  };
  _no_name_provided__60.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__60.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__61() {
  }
  _no_name_provided__61.prototype.invoke_285 = function (it) {
    var tmp = theme_getInstance();
    var tmp0_subject_7_21_45_53_56_64 = this.previousSibling.previousSibling.dataset.id;
    tmp._set_isDark_(tmp0_subject_7_21_45_53_56_64 == '0' ? false : tmp0_subject_7_21_45_53_56_64 == '1' ? true : false);
  };
  _no_name_provided__61.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__61.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__62() {
  }
  _no_name_provided__62.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_33_41_44_52 = _this__0;
    _set_classes_(tmp0_receiver_5_9_33_41_44_52, plus(_get_classes_(tmp0_receiver_5_9_33_41_44_52), 'options-chkbx'));
    var tmp1_receiver_6_10_34_42_45_53 = _this__0;
    _set_classes_(tmp1_receiver_6_10_34_42_45_53, plus(_get_classes_(tmp1_receiver_6_10_34_42_45_53), 'btn'));
    var tmp0_set_0_7_11_35_43_46_54 = _this__0._get_attributes__4();
    var tmp1_set_0_8_12_36_44_47_55 = 'data-id';
    var tmp2_set_0_9_13_37_45_48_56 = '1';
    tmp0_set_0_7_11_35_43_46_54.put_7(tmp1_set_0_8_12_36_44_47_55, tmp2_set_0_9_13_37_45_48_56);
    Unit_getInstance();
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_61(_this__0));
  };
  _no_name_provided__62.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__62.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__63() {
  }
  _no_name_provided__63.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_19_43_51_54_62 = _this__0;
    _set_classes_(tmp0_receiver_5_19_43_51_54_62, plus(_get_classes_(tmp0_receiver_5_19_43_51_54_62), 'options-switchTitle'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_62());
    _this__0.unaryPlus_4('Dunkel');
  };
  _no_name_provided__63.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__63.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__64() {
  }
  _no_name_provided__64.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_17_20_28 = _this__0;
    _set_classes_(tmp0_receiver_5_9_17_20_28, plus(_get_classes_(tmp0_receiver_5_9_17_20_28), 'options-switch'));
    var tmp0_div_0_6_10_18_21_29 = null;
    var tmp0_visit_0_2_7_11_19_22_30 = new DIV(attributesMapOf('class', tmp0_div_0_6_10_18_21_29), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_11_19_22_30, _no_name_provided_$factory_55());
    var tmp1_div_0_16_20_28_31_39 = null;
    var tmp0_visit_0_2_17_21_29_32_40 = new DIV(attributesMapOf('class', tmp1_div_0_16_20_28_31_39), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_17_21_29_32_40, _no_name_provided_$factory_56());
  };
  _no_name_provided__64.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__64.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__65() {
  }
  _no_name_provided__65.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_29_37_40_48 = _this__0;
    _set_classes_(tmp0_receiver_5_29_37_40_48, plus(_get_classes_(tmp0_receiver_5_29_37_40_48), 'options-switch'));
    var tmp0_div_0_6_30_38_41_49 = null;
    var tmp0_visit_0_2_7_31_39_42_50 = new DIV(attributesMapOf('class', tmp0_div_0_6_30_38_41_49), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_31_39_42_50, _no_name_provided_$factory_59());
    var tmp1_div_0_16_40_48_51_59 = null;
    var tmp0_visit_0_2_17_41_49_52_60 = new DIV(attributesMapOf('class', tmp1_div_0_16_40_48_51_59), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_17_41_49_52_60, _no_name_provided_$factory_60());
  };
  _no_name_provided__65.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__65.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__66() {
  }
  _no_name_provided__66.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_12_20 = _this__0;
    _set_classes_(tmp0_receiver_5_9_12_20, plus(_get_classes_(tmp0_receiver_5_9_12_20), 'options-wrapperTitle'));
    _this__0.unaryPlus_4('Theme');
  };
  _no_name_provided__66.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__66.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__67() {
  }
  _no_name_provided__67.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_13_16_24 = _this__0;
    _set_classes_(tmp0_receiver_5_13_16_24, plus(_get_classes_(tmp0_receiver_5_13_16_24), 'options-wrapperInside'));
    var tmp0_div_0_6_14_17_25 = null;
    var tmp0_visit_0_2_7_15_18_26 = new DIV(attributesMapOf('class', tmp0_div_0_6_14_17_25), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_15_18_26, _no_name_provided_$factory_53());
    var tmp1_div_0_26_34_37_45 = null;
    var tmp0_visit_0_2_27_35_38_46 = new DIV(attributesMapOf('class', tmp1_div_0_26_34_37_45), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_27_35_38_46, _no_name_provided_$factory_54());
  };
  _no_name_provided__67.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__67.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__68($this) {
    this._$this_6 = $this;
  }
  _no_name_provided__68.prototype.invoke_285 = function (it) {
    var tmp = difficulty_getInstance();
    var tmp0_subject_11_15_19_27_82_90 = this._$this_6._get_attributes__4().get_26('data-id');
    tmp._set_level_(tmp0_subject_11_15_19_27_82_90 === '0' ? 0 : tmp0_subject_11_15_19_27_82_90 === '1' ? 1 : tmp0_subject_11_15_19_27_82_90 === '2' ? 2 : 0);
  };
  _no_name_provided__68.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__68.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__69() {
  }
  _no_name_provided__69.prototype.invoke_285 = function (it) {
    var tmp = difficulty_getInstance();
    var tmp0_subject_7_21_25_33_88_96 = this.previousSibling.previousSibling.dataset.id;
    tmp._set_level_(tmp0_subject_7_21_25_33_88_96 == '0' ? 0 : tmp0_subject_7_21_25_33_88_96 == '1' ? 1 : tmp0_subject_7_21_25_33_88_96 == '2' ? 2 : 0);
  };
  _no_name_provided__69.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__69.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__70() {
  }
  _no_name_provided__70.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_13_21_76_84 = _this__0;
    _set_classes_(tmp0_receiver_5_9_13_21_76_84, plus(_get_classes_(tmp0_receiver_5_9_13_21_76_84), 'options-chkbx'));
    var tmp1_receiver_6_10_14_22_77_85 = _this__0;
    _set_classes_(tmp1_receiver_6_10_14_22_77_85, plus(_get_classes_(tmp1_receiver_6_10_14_22_77_85), 'btn'));
    var tmp0_set_0_7_11_15_23_78_86 = _this__0._get_attributes__4();
    var tmp1_set_0_8_12_16_24_79_87 = 'data-id';
    var tmp2_set_0_9_13_17_25_80_88 = '0';
    tmp0_set_0_7_11_15_23_78_86.put_7(tmp1_set_0_8_12_16_24_79_87, tmp2_set_0_9_13_17_25_80_88);
    Unit_getInstance();
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_70(_this__0));
  };
  _no_name_provided__70.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__70.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__71() {
  }
  _no_name_provided__71.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_19_23_31_86_94 = _this__0;
    _set_classes_(tmp0_receiver_5_19_23_31_86_94, plus(_get_classes_(tmp0_receiver_5_19_23_31_86_94), 'options-switchTitle'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_71());
    _this__0.unaryPlus_4('Chill');
  };
  _no_name_provided__71.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__71.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__72($this) {
    this._$this_7 = $this;
  }
  _no_name_provided__72.prototype.invoke_285 = function (it) {
    var tmp = difficulty_getInstance();
    var tmp0_subject_11_15_39_47_102_110 = this._$this_7._get_attributes__4().get_26('data-id');
    tmp._set_level_(tmp0_subject_11_15_39_47_102_110 === '0' ? 0 : tmp0_subject_11_15_39_47_102_110 === '1' ? 1 : tmp0_subject_11_15_39_47_102_110 === '2' ? 2 : 0);
  };
  _no_name_provided__72.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__72.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__73() {
  }
  _no_name_provided__73.prototype.invoke_285 = function (it) {
    var tmp = difficulty_getInstance();
    var tmp0_subject_7_21_45_53_108_116 = this.previousSibling.previousSibling.dataset.id;
    tmp._set_level_(tmp0_subject_7_21_45_53_108_116 == '0' ? 0 : tmp0_subject_7_21_45_53_108_116 == '1' ? 1 : tmp0_subject_7_21_45_53_108_116 == '2' ? 2 : 0);
  };
  _no_name_provided__73.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__73.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__74() {
  }
  _no_name_provided__74.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_33_41_96_104 = _this__0;
    _set_classes_(tmp0_receiver_5_9_33_41_96_104, plus(_get_classes_(tmp0_receiver_5_9_33_41_96_104), 'options-chkbx'));
    var tmp1_receiver_6_10_34_42_97_105 = _this__0;
    _set_classes_(tmp1_receiver_6_10_34_42_97_105, plus(_get_classes_(tmp1_receiver_6_10_34_42_97_105), 'btn'));
    var tmp0_set_0_7_11_35_43_98_106 = _this__0._get_attributes__4();
    var tmp1_set_0_8_12_36_44_99_107 = 'data-id';
    var tmp2_set_0_9_13_37_45_100_108 = '1';
    tmp0_set_0_7_11_35_43_98_106.put_7(tmp1_set_0_8_12_36_44_99_107, tmp2_set_0_9_13_37_45_100_108);
    Unit_getInstance();
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_74(_this__0));
  };
  _no_name_provided__74.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__74.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__75() {
  }
  _no_name_provided__75.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_19_43_51_106_114 = _this__0;
    _set_classes_(tmp0_receiver_5_19_43_51_106_114, plus(_get_classes_(tmp0_receiver_5_19_43_51_106_114), 'options-switchTitle'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_75());
    _this__0.unaryPlus_4('Geht ab');
  };
  _no_name_provided__75.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__75.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__76($this) {
    this._$this_8 = $this;
  }
  _no_name_provided__76.prototype.invoke_285 = function (it) {
    var tmp = difficulty_getInstance();
    var tmp0_subject_11_15_59_67_122_130 = this._$this_8._get_attributes__4().get_26('data-id');
    tmp._set_level_(tmp0_subject_11_15_59_67_122_130 === '0' ? 0 : tmp0_subject_11_15_59_67_122_130 === '1' ? 1 : tmp0_subject_11_15_59_67_122_130 === '2' ? 2 : 0);
  };
  _no_name_provided__76.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__76.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__77() {
  }
  _no_name_provided__77.prototype.invoke_285 = function (it) {
    var tmp = difficulty_getInstance();
    var tmp0_subject_7_21_65_73_128_136 = this.previousSibling.previousSibling.dataset.id;
    tmp._set_level_(tmp0_subject_7_21_65_73_128_136 == '0' ? 0 : tmp0_subject_7_21_65_73_128_136 == '1' ? 1 : tmp0_subject_7_21_65_73_128_136 == '2' ? 2 : 0);
  };
  _no_name_provided__77.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__77.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__78() {
  }
  _no_name_provided__78.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_53_61_116_124 = _this__0;
    _set_classes_(tmp0_receiver_5_9_53_61_116_124, plus(_get_classes_(tmp0_receiver_5_9_53_61_116_124), 'options-chkbx'));
    var tmp1_receiver_6_10_54_62_117_125 = _this__0;
    _set_classes_(tmp1_receiver_6_10_54_62_117_125, plus(_get_classes_(tmp1_receiver_6_10_54_62_117_125), 'btn'));
    var tmp0_set_0_7_11_55_63_118_126 = _this__0._get_attributes__4();
    var tmp1_set_0_8_12_56_64_119_127 = 'data-id';
    var tmp2_set_0_9_13_57_65_120_128 = '2';
    tmp0_set_0_7_11_55_63_118_126.put_7(tmp1_set_0_8_12_56_64_119_127, tmp2_set_0_9_13_57_65_120_128);
    Unit_getInstance();
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_78(_this__0));
  };
  _no_name_provided__78.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__78.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__79() {
  }
  _no_name_provided__79.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_19_63_71_126_134 = _this__0;
    _set_classes_(tmp0_receiver_5_19_63_71_126_134, plus(_get_classes_(tmp0_receiver_5_19_63_71_126_134), 'options-switchTitle'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_79());
    _this__0.unaryPlus_4('Absturz');
  };
  _no_name_provided__79.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__79.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__80() {
  }
  _no_name_provided__80.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_17_72_80 = _this__0;
    _set_classes_(tmp0_receiver_5_9_17_72_80, plus(_get_classes_(tmp0_receiver_5_9_17_72_80), 'options-switch'));
    var tmp0_div_0_6_10_18_73_81 = null;
    var tmp0_visit_0_2_7_11_19_74_82 = new DIV(attributesMapOf('class', tmp0_div_0_6_10_18_73_81), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_11_19_74_82, _no_name_provided_$factory_68());
    var tmp1_div_0_16_20_28_83_91 = null;
    var tmp0_visit_0_2_17_21_29_84_92 = new DIV(attributesMapOf('class', tmp1_div_0_16_20_28_83_91), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_17_21_29_84_92, _no_name_provided_$factory_69());
  };
  _no_name_provided__80.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__80.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__81() {
  }
  _no_name_provided__81.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_29_37_92_100 = _this__0;
    _set_classes_(tmp0_receiver_5_29_37_92_100, plus(_get_classes_(tmp0_receiver_5_29_37_92_100), 'options-switch'));
    var tmp0_div_0_6_30_38_93_101 = null;
    var tmp0_visit_0_2_7_31_39_94_102 = new DIV(attributesMapOf('class', tmp0_div_0_6_30_38_93_101), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_31_39_94_102, _no_name_provided_$factory_72());
    var tmp1_div_0_16_40_48_103_111 = null;
    var tmp0_visit_0_2_17_41_49_104_112 = new DIV(attributesMapOf('class', tmp1_div_0_16_40_48_103_111), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_17_41_49_104_112, _no_name_provided_$factory_73());
  };
  _no_name_provided__81.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__81.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__82() {
  }
  _no_name_provided__82.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_49_57_112_120 = _this__0;
    _set_classes_(tmp0_receiver_5_49_57_112_120, plus(_get_classes_(tmp0_receiver_5_49_57_112_120), 'options-switch'));
    var tmp0_div_0_6_50_58_113_121 = null;
    var tmp0_visit_0_2_7_51_59_114_122 = new DIV(attributesMapOf('class', tmp0_div_0_6_50_58_113_121), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_51_59_114_122, _no_name_provided_$factory_76());
    var tmp1_div_0_16_60_68_123_131 = null;
    var tmp0_visit_0_2_17_61_69_124_132 = new DIV(attributesMapOf('class', tmp1_div_0_16_60_68_123_131), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_17_61_69_124_132, _no_name_provided_$factory_77());
  };
  _no_name_provided__82.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__82.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__83() {
  }
  _no_name_provided__83.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_64_72 = _this__0;
    _set_classes_(tmp0_receiver_5_9_64_72, plus(_get_classes_(tmp0_receiver_5_9_64_72), 'options-wrapperTitle'));
    _this__0.unaryPlus_4('Spielstimmung');
  };
  _no_name_provided__83.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__83.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__84() {
  }
  _no_name_provided__84.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_13_68_76 = _this__0;
    _set_classes_(tmp0_receiver_5_13_68_76, plus(_get_classes_(tmp0_receiver_5_13_68_76), 'options-wrapperInside'));
    var tmp0_div_0_6_14_69_77 = null;
    var tmp0_visit_0_2_7_15_70_78 = new DIV(attributesMapOf('class', tmp0_div_0_6_14_69_77), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_15_70_78, _no_name_provided_$factory_65());
    var tmp1_div_0_26_34_89_97 = null;
    var tmp0_visit_0_2_27_35_90_98 = new DIV(attributesMapOf('class', tmp1_div_0_26_34_89_97), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_27_35_90_98, _no_name_provided_$factory_66());
    var tmp2_div_0_46_54_109_117 = null;
    var tmp0_visit_0_2_47_55_110_118 = new DIV(attributesMapOf('class', tmp2_div_0_46_54_109_117), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_47_55_110_118, _no_name_provided_$factory_67());
  };
  _no_name_provided__84.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__84.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__85($this) {
    this._$this_9 = $this;
  }
  _no_name_provided__85.prototype.invoke_285 = function (it) {
    var tmp = rumble_getInstance();
    var tmp0_subject_11_15_19_27_154_162 = this._$this_9._get_attributes__4().get_26('data-id');
    tmp._set_state_(tmp0_subject_11_15_19_27_154_162 === '0' ? true : tmp0_subject_11_15_19_27_154_162 === '1' ? false : true);
  };
  _no_name_provided__85.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__85.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__86() {
  }
  _no_name_provided__86.prototype.invoke_285 = function (it) {
    var tmp = rumble_getInstance();
    var tmp0_subject_7_21_25_33_160_168 = this.previousSibling.previousSibling.dataset.id;
    tmp._set_state_(tmp0_subject_7_21_25_33_160_168 == '0' ? true : tmp0_subject_7_21_25_33_160_168 == '1' ? false : true);
  };
  _no_name_provided__86.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__86.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__87() {
  }
  _no_name_provided__87.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_13_21_148_156 = _this__0;
    _set_classes_(tmp0_receiver_5_9_13_21_148_156, plus(_get_classes_(tmp0_receiver_5_9_13_21_148_156), 'options-chkbx'));
    var tmp1_receiver_6_10_14_22_149_157 = _this__0;
    _set_classes_(tmp1_receiver_6_10_14_22_149_157, plus(_get_classes_(tmp1_receiver_6_10_14_22_149_157), 'btn'));
    var tmp0_set_0_7_11_15_23_150_158 = _this__0._get_attributes__4();
    var tmp1_set_0_8_12_16_24_151_159 = 'data-id';
    var tmp2_set_0_9_13_17_25_152_160 = '0';
    tmp0_set_0_7_11_15_23_150_158.put_7(tmp1_set_0_8_12_16_24_151_159, tmp2_set_0_9_13_17_25_152_160);
    Unit_getInstance();
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_86(_this__0));
  };
  _no_name_provided__87.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__87.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__88() {
  }
  _no_name_provided__88.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_19_23_31_158_166 = _this__0;
    _set_classes_(tmp0_receiver_5_19_23_31_158_166, plus(_get_classes_(tmp0_receiver_5_19_23_31_158_166), 'options-switchTitle'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_87());
    _this__0.unaryPlus_4('Klar');
  };
  _no_name_provided__88.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__88.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__89($this) {
    this._$this_10 = $this;
  }
  _no_name_provided__89.prototype.invoke_285 = function (it) {
    var tmp = rumble_getInstance();
    var tmp0_subject_11_15_39_47_174_182 = this._$this_10._get_attributes__4().get_26('data-id');
    tmp._set_state_(tmp0_subject_11_15_39_47_174_182 === '0' ? true : tmp0_subject_11_15_39_47_174_182 === '1' ? false : true);
  };
  _no_name_provided__89.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__89.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__90() {
  }
  _no_name_provided__90.prototype.invoke_285 = function (it) {
    var tmp = rumble_getInstance();
    var tmp0_subject_7_21_45_53_180_188 = this.previousSibling.previousSibling.dataset.id;
    tmp._set_state_(tmp0_subject_7_21_45_53_180_188 == '0' ? true : tmp0_subject_7_21_45_53_180_188 == '1' ? false : true);
  };
  _no_name_provided__90.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__90.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__91() {
  }
  _no_name_provided__91.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_33_41_168_176 = _this__0;
    _set_classes_(tmp0_receiver_5_9_33_41_168_176, plus(_get_classes_(tmp0_receiver_5_9_33_41_168_176), 'options-chkbx'));
    var tmp1_receiver_6_10_34_42_169_177 = _this__0;
    _set_classes_(tmp1_receiver_6_10_34_42_169_177, plus(_get_classes_(tmp1_receiver_6_10_34_42_169_177), 'btn'));
    var tmp0_set_0_7_11_35_43_170_178 = _this__0._get_attributes__4();
    var tmp1_set_0_8_12_36_44_171_179 = 'data-id';
    var tmp2_set_0_9_13_37_45_172_180 = '1';
    tmp0_set_0_7_11_35_43_170_178.put_7(tmp1_set_0_8_12_36_44_171_179, tmp2_set_0_9_13_37_45_172_180);
    Unit_getInstance();
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_90(_this__0));
  };
  _no_name_provided__91.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__91.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__92() {
  }
  _no_name_provided__92.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_19_43_51_178_186 = _this__0;
    _set_classes_(tmp0_receiver_5_19_43_51_178_186, plus(_get_classes_(tmp0_receiver_5_19_43_51_178_186), 'options-switchTitle'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_91());
    _this__0.unaryPlus_4('Ne');
  };
  _no_name_provided__92.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__92.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__93() {
  }
  _no_name_provided__93.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_17_144_152 = _this__0;
    _set_classes_(tmp0_receiver_5_9_17_144_152, plus(_get_classes_(tmp0_receiver_5_9_17_144_152), 'options-switch'));
    var tmp0_div_0_6_10_18_145_153 = null;
    var tmp0_visit_0_2_7_11_19_146_154 = new DIV(attributesMapOf('class', tmp0_div_0_6_10_18_145_153), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_11_19_146_154, _no_name_provided_$factory_84());
    var tmp1_div_0_16_20_28_155_163 = null;
    var tmp0_visit_0_2_17_21_29_156_164 = new DIV(attributesMapOf('class', tmp1_div_0_16_20_28_155_163), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_17_21_29_156_164, _no_name_provided_$factory_85());
  };
  _no_name_provided__93.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__93.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__94() {
  }
  _no_name_provided__94.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_29_37_164_172 = _this__0;
    _set_classes_(tmp0_receiver_5_29_37_164_172, plus(_get_classes_(tmp0_receiver_5_29_37_164_172), 'options-switch'));
    var tmp0_div_0_6_30_38_165_173 = null;
    var tmp0_visit_0_2_7_31_39_166_174 = new DIV(attributesMapOf('class', tmp0_div_0_6_30_38_165_173), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_31_39_166_174, _no_name_provided_$factory_88());
    var tmp1_div_0_16_40_48_175_183 = null;
    var tmp0_visit_0_2_17_41_49_176_184 = new DIV(attributesMapOf('class', tmp1_div_0_16_40_48_175_183), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_17_41_49_176_184, _no_name_provided_$factory_89());
  };
  _no_name_provided__94.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__94.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__95() {
  }
  _no_name_provided__95.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_9_136_144 = _this__0;
    _set_classes_(tmp0_receiver_5_9_136_144, plus(_get_classes_(tmp0_receiver_5_9_136_144), 'options-wrapperTitle'));
    _this__0.unaryPlus_4('Vibrationen?');
  };
  _no_name_provided__95.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__95.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__96() {
  }
  _no_name_provided__96.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_13_140_148 = _this__0;
    _set_classes_(tmp0_receiver_5_13_140_148, plus(_get_classes_(tmp0_receiver_5_13_140_148), 'options-wrapperInside'));
    var tmp0_div_0_6_14_141_149 = null;
    var tmp0_visit_0_2_7_15_142_150 = new DIV(attributesMapOf('class', tmp0_div_0_6_14_141_149), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_15_142_150, _no_name_provided_$factory_82());
    var tmp1_div_0_26_34_161_169 = null;
    var tmp0_visit_0_2_27_35_162_170 = new DIV(attributesMapOf('class', tmp1_div_0_26_34_161_169), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_27_35_162_170, _no_name_provided_$factory_83());
  };
  _no_name_provided__96.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__96.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__97() {
  }
  _no_name_provided__97.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'options-themeWrapper');
    var tmp0_receiver_5_8_16 = _this__0;
    _set_classes_(tmp0_receiver_5_8_16, plus(_get_classes_(tmp0_receiver_5_8_16), 'options-wrapper'));
    var tmp0_div_0_6_9_17 = null;
    var tmp0_visit_0_2_7_10_18 = new DIV(attributesMapOf('class', tmp0_div_0_6_9_17), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_10_18, _no_name_provided_$factory_51());
    var tmp1_div_0_10_13_21 = null;
    var tmp0_visit_0_2_11_14_22 = new DIV(attributesMapOf('class', tmp1_div_0_10_13_21), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_11_14_22, _no_name_provided_$factory_52());
  };
  _no_name_provided__97.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__97.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__98() {
  }
  _no_name_provided__98.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'options-difficultyWrapper');
    var tmp0_receiver_5_60_68 = _this__0;
    _set_classes_(tmp0_receiver_5_60_68, plus(_get_classes_(tmp0_receiver_5_60_68), 'options-wrapper'));
    var tmp0_div_0_6_61_69 = null;
    var tmp0_visit_0_2_7_62_70 = new DIV(attributesMapOf('class', tmp0_div_0_6_61_69), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_62_70, _no_name_provided_$factory_63());
    var tmp1_div_0_10_65_73 = null;
    var tmp0_visit_0_2_11_66_74 = new DIV(attributesMapOf('class', tmp1_div_0_10_65_73), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_11_66_74, _no_name_provided_$factory_64());
  };
  _no_name_provided__98.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__98.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__99() {
  }
  _no_name_provided__99.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'options-rumbleWrapper');
    var tmp0_receiver_5_132_140 = _this__0;
    _set_classes_(tmp0_receiver_5_132_140, plus(_get_classes_(tmp0_receiver_5_132_140), 'options-wrapper'));
    var tmp0_div_0_6_133_141 = null;
    var tmp0_visit_0_2_7_134_142 = new DIV(attributesMapOf('class', tmp0_div_0_6_133_141), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_7_134_142, _no_name_provided_$factory_80());
    var tmp1_div_0_10_137_145 = null;
    var tmp0_visit_0_2_11_138_146 = new DIV(attributesMapOf('class', tmp1_div_0_10_137_145), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_11_138_146, _no_name_provided_$factory_81());
  };
  _no_name_provided__99.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__99.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__100() {
  }
  _no_name_provided__100.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'options-backbtn');
    var tmp0_receiver_5_8 = _this__0;
    _set_classes_(tmp0_receiver_5_8, plus(_get_classes_(tmp0_receiver_5_8), 'btn'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_47());
    _this__0.unaryPlus_4('\xAB');
  };
  _no_name_provided__100.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__100.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__101() {
  }
  _no_name_provided__101.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'options-switches');
    var tmp0_div_0_5_13 = null;
    var tmp0_visit_0_2_6_14 = new DIV(attributesMapOf('class', tmp0_div_0_5_13), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_6_14, _no_name_provided_$factory_48());
    var tmp1_div_0_57_65 = null;
    var tmp0_visit_0_2_58_66 = new DIV(attributesMapOf('class', tmp1_div_0_57_65), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_58_66, _no_name_provided_$factory_49());
    var tmp2_div_0_129_137 = null;
    var tmp0_visit_0_2_130_138 = new DIV(attributesMapOf('class', tmp2_div_0_129_137), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_130_138, _no_name_provided_$factory_50());
  };
  _no_name_provided__101.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__101.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__102() {
  }
  _no_name_provided__102.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'root');
    var tmp0_div_0_5 = null;
    var tmp0_visit_0_2_6 = new DIV(attributesMapOf('class', tmp0_div_0_5), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_6, _no_name_provided_$factory_45());
    var tmp1_div_0_10 = null;
    var tmp0_visit_0_2_11 = new DIV(attributesMapOf('class', tmp1_div_0_10), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_11, _no_name_provided_$factory_46());
  };
  _no_name_provided__102.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__102.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_44() {
    var i = new _no_name_provided__102();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_45() {
    var i = new _no_name_provided__100();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_46() {
    var i = new _no_name_provided__101();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_47() {
    var i = new _no_name_provided__55();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_48() {
    var i = new _no_name_provided__97();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_49() {
    var i = new _no_name_provided__98();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_50() {
    var i = new _no_name_provided__99();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_51() {
    var i = new _no_name_provided__66();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_52() {
    var i = new _no_name_provided__67();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_53() {
    var i = new _no_name_provided__64();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_54() {
    var i = new _no_name_provided__65();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_55() {
    var i = new _no_name_provided__58();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_56() {
    var i = new _no_name_provided__59();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_57($this) {
    var i = new _no_name_provided__56($this);
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_58() {
    var i = new _no_name_provided__57();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_59() {
    var i = new _no_name_provided__62();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_60() {
    var i = new _no_name_provided__63();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_61($this) {
    var i = new _no_name_provided__60($this);
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_62() {
    var i = new _no_name_provided__61();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_63() {
    var i = new _no_name_provided__83();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_64() {
    var i = new _no_name_provided__84();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_65() {
    var i = new _no_name_provided__80();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_66() {
    var i = new _no_name_provided__81();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_67() {
    var i = new _no_name_provided__82();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_68() {
    var i = new _no_name_provided__70();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_69() {
    var i = new _no_name_provided__71();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_70($this) {
    var i = new _no_name_provided__68($this);
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_71() {
    var i = new _no_name_provided__69();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_72() {
    var i = new _no_name_provided__74();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_73() {
    var i = new _no_name_provided__75();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_74($this) {
    var i = new _no_name_provided__72($this);
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_75() {
    var i = new _no_name_provided__73();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_76() {
    var i = new _no_name_provided__78();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_77() {
    var i = new _no_name_provided__79();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_78($this) {
    var i = new _no_name_provided__76($this);
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_79() {
    var i = new _no_name_provided__77();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_80() {
    var i = new _no_name_provided__95();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_81() {
    var i = new _no_name_provided__96();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_82() {
    var i = new _no_name_provided__93();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_83() {
    var i = new _no_name_provided__94();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_84() {
    var i = new _no_name_provided__87();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_85() {
    var i = new _no_name_provided__88();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_86($this) {
    var i = new _no_name_provided__85($this);
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_87() {
    var i = new _no_name_provided__86();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_88() {
    var i = new _no_name_provided__91();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_89() {
    var i = new _no_name_provided__92();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_90($this) {
    var i = new _no_name_provided__89($this);
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_91() {
    var i = new _no_name_provided__90();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function play() {
    window.location.hash = '#play';
    currentPage = '#play';
    game_getInstance()._set_isRunning_(true);
    var tmp0_div_0 = _get_create_(document);
    var tmp1_div_0 = null;
    var tmp0_visitAndFinalize_0_2 = new DIV(attributesMapOf('class', tmp1_div_0), tmp0_div_0);
    var tmp = visitTagAndFinalize(tmp0_visitAndFinalize_0_2, tmp0_div_0, _no_name_provided_$factory_92());
    return tmp instanceof HTMLDivElement ? tmp : THROW_CCE();
  }
  function _no_name_provided__103() {
  }
  _no_name_provided__103.prototype.invoke_290 = function (_this__0) {
    _this__0.unaryPlus_4('Trinkalternative');
  };
  _no_name_provided__103.prototype.invoke_293 = function (p1) {
    this.invoke_290(p1 instanceof SPAN ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__103.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__104() {
  }
  _no_name_provided__104.prototype.invoke_182 = function ($this$unsafe) {
    $this$unsafe.raw_0(trimIndent('\n                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="36"\n                                height="36" viewBox="0 0 36 36" xml:space="preserve" style="background-color: transparent">\n                                <path stroke="floralwhite" stroke-width="3px" stroke-linejoin="round" stroke-linecap="round" fill="black"\n                                    d="m18 3 v20 m0 0 l-5 -5 h10 l-5 5 z" />\n                            <\/svg>\n                        '));
  };
  _no_name_provided__104.prototype.invoke_293 = function (p1) {
    this.invoke_182((!(p1 == null) ? isInterface(p1, Unsafe) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__104.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__105() {
  }
  _no_name_provided__105.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'card');
  };
  _no_name_provided__105.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__105.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__106() {
  }
  _no_name_provided__106.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'play-name');
    _this__0.unaryPlus_4('spater');
  };
  _no_name_provided__106.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__106.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__107() {
  }
  _no_name_provided__107.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'play-spacer');
    var tmp0_span_0_5_11 = null;
    var tmp0_visit_0_2_6_12 = new SPAN(attributesMapOf('class', tmp0_span_0_5_11), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_6_12, _no_name_provided_$factory_96());
    unsafe(_this__0, _no_name_provided_$factory_97());
  };
  _no_name_provided__107.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__107.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__108() {
  }
  _no_name_provided__108.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'card-wrapper');
    var tmp0_div_0_5_18 = null;
    var tmp0_visit_0_2_6_19 = new DIV(attributesMapOf('class', tmp0_div_0_5_18), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_6_19, _no_name_provided_$factory_98());
  };
  _no_name_provided__108.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__108.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__109() {
  }
  _no_name_provided__109.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'root');
    var tmp0_div_0_5 = null;
    var tmp0_visit_0_2_6 = new DIV(attributesMapOf('class', tmp0_div_0_5), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_6, _no_name_provided_$factory_93());
    var tmp1_div_0_8 = null;
    var tmp0_visit_0_2_9 = new DIV(attributesMapOf('class', tmp1_div_0_8), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_9, _no_name_provided_$factory_94());
    var tmp2_div_0_15 = null;
    var tmp0_visit_0_2_16 = new DIV(attributesMapOf('class', tmp2_div_0_15), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_16, _no_name_provided_$factory_95());
  };
  _no_name_provided__109.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__109.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_92() {
    var i = new _no_name_provided__109();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_93() {
    var i = new _no_name_provided__106();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_94() {
    var i = new _no_name_provided__107();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_95() {
    var i = new _no_name_provided__108();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_96() {
    var i = new _no_name_provided__103();
    return function (p1) {
      i.invoke_290(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_97() {
    var i = new _no_name_provided__104();
    return function (p1) {
      i.invoke_182(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_98() {
    var i = new _no_name_provided__105();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function pregame() {
    window.location.hash = '#pregame';
    currentPage = '#pregame';
    var tmp0_div_0 = _get_create_(document);
    var tmp1_div_0 = null;
    var tmp0_visitAndFinalize_0_2 = new DIV(attributesMapOf('class', tmp1_div_0), tmp0_div_0);
    var tmp = visitTagAndFinalize(tmp0_visitAndFinalize_0_2, tmp0_div_0, _no_name_provided_$factory_99());
    return tmp instanceof HTMLDivElement ? tmp : THROW_CCE();
  }
  function inpFocusOut() {
    var tmp;
    if (isMobile()) {
      var tmp0_asDynamic_0 = document.querySelector('#pregame-playernameInp');
      tmp = tmp0_asDynamic_0.value.trim().length <= 1;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp0_safe_receiver = document.querySelector('#pregame-playerList');
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.classList;
      if (tmp1_safe_receiver == null)
        null;
      else {
        (function () {
          var $externalVarargReceiverTmp = tmp1_safe_receiver;
          return $externalVarargReceiverTmp.remove.apply($externalVarargReceiverTmp, [].concat(['pregame-hidden']));
        }.call(this));
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp2_safe_receiver = document.querySelector('#pregame-playerBtn');
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.classList;
      if (tmp3_safe_receiver == null)
        null;
      else {
        (function () {
          var $externalVarargReceiverTmp = tmp3_safe_receiver;
          return $externalVarargReceiverTmp.remove.apply($externalVarargReceiverTmp, [].concat(['pregame-hidden']));
        }.call(this));
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp4_safe_receiver = document.querySelector('#pregame-addPlayerBtn');
      var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.classList;
      if (tmp5_safe_receiver == null)
        null;
      else {
        (function () {
          var $externalVarargReceiverTmp = tmp5_safe_receiver;
          return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].concat(['pregame-hidden']));
        }.call(this));
        Unit_getInstance();
      }
      Unit_getInstance();
      playerList_getInstance().update_0();
    } else {
    }
  }
  function _no_name_provided__110() {
  }
  _no_name_provided__110.prototype.invoke_285 = function (it) {
    if (isMobile()) {
      var tmp0_safe_receiver_10_17_23 = document.querySelector('#pregame-playerList');
      var tmp1_safe_receiver_9_16_22 = tmp0_safe_receiver_10_17_23 == null ? null : tmp0_safe_receiver_10_17_23.classList;
      if (tmp1_safe_receiver_9_16_22 == null)
        null;
      else {
        (function () {
          var $externalVarargReceiverTmp = tmp1_safe_receiver_9_16_22;
          return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].concat(['pregame-hidden']));
        }.call(this));
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp2_safe_receiver_12_19_25 = document.querySelector('#pregame-playerBtn');
      var tmp3_safe_receiver_11_18_24 = tmp2_safe_receiver_12_19_25 == null ? null : tmp2_safe_receiver_12_19_25.classList;
      if (tmp3_safe_receiver_11_18_24 == null)
        null;
      else {
        (function () {
          var $externalVarargReceiverTmp = tmp3_safe_receiver_11_18_24;
          return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].concat(['pregame-hidden']));
        }.call(this));
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp4_safe_receiver_14_21_27 = document.querySelector('#pregame-addPlayerBtn');
      var tmp5_safe_receiver_13_20_26 = tmp4_safe_receiver_14_21_27 == null ? null : tmp4_safe_receiver_14_21_27.classList;
      if (tmp5_safe_receiver_13_20_26 == null)
        null;
      else {
        (function () {
          var $externalVarargReceiverTmp = tmp5_safe_receiver_13_20_26;
          return $externalVarargReceiverTmp.remove.apply($externalVarargReceiverTmp, [].concat(['pregame-hidden']));
        }.call(this));
        Unit_getInstance();
      }
      Unit_getInstance();
    }};
  _no_name_provided__110.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__110.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__111() {
  }
  _no_name_provided__111.prototype.invoke_285 = function (it) {
    inpFocusOut();
  };
  _no_name_provided__111.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__111.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__112() {
  }
  _no_name_provided__112.prototype.invoke_285 = function (it) {
    if (it instanceof KeyboardEvent)
      it;
    else
      THROW_CCE();
    Unit_getInstance();
    if (it.key === 'Enter') {
      var tmp0_asDynamic_0_17_24_30 = document.querySelector('#pregame-addPlayerBtn');
      tmp0_asDynamic_0_17_24_30.click();
    }};
  _no_name_provided__112.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__112.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__113() {
  }
  _no_name_provided__113.prototype.invoke_285 = function (it) {
    var tmp = rumbler_getInstance();
    tmp.rumble$default(0.0, 1, null);
    var tmp0_asDynamic_0_14_41_47 = document.querySelector('#pregame-playernameInp');
    var tmp0_safe_receiver_13_40_46 = tmp0_asDynamic_0_14_41_47.value;
    var tmp1_safe_receiver_12_39_45 = tmp0_safe_receiver_13_40_46 == null ? null : toString_1(tmp0_safe_receiver_13_40_46);
    var tmp_0;
    if (tmp1_safe_receiver_12_39_45 == null) {
      tmp_0 = null;
    } else {
      tmp_0 = toString_1(trim((!(tmp1_safe_receiver_12_39_45 == null) ? isCharSequence(tmp1_safe_receiver_12_39_45) : false) ? tmp1_safe_receiver_12_39_45 : THROW_CCE()));
    }
    var tmp2_safe_receiver_11_38_44 = tmp_0;
    var tmp3_safe_receiver_10_37_43 = tmp2_safe_receiver_11_38_44 == null ? null : capitalize(tmp2_safe_receiver_11_38_44);
    if (tmp3_safe_receiver_10_37_43 == null)
      null;
    else {
      playerList_getInstance().add_17(tmp3_safe_receiver_10_37_43);
      inpFocusOut();
      var tmp0_asDynamic_0_2_15_42_48 = document.querySelector('#pregame-playernameInp');
      tmp0_asDynamic_0_2_15_42_48.value = '';
      Unit_getInstance();
    }
    Unit_getInstance();
  };
  _no_name_provided__113.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__113.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__114() {
  }
  _no_name_provided__114.prototype.invoke_283 = function () {
    availableCards_getInstance().putCard();
  };
  _no_name_provided__114.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__114.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__115() {
  }
  _no_name_provided__115.prototype.invoke_285 = function (it) {
    var tmp = rumbler_getInstance();
    tmp.rumble$default(0.0, 1, null);
    var tmp_0 = play();
    changePage(tmp_0, _no_name_provided_$factory_112());
  };
  _no_name_provided__115.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__115.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__116() {
  }
  _no_name_provided__116.prototype.invoke_236 = function (_this__0) {
    _set_id_(_this__0, 'pregame-playBtn');
    var tmp0_receiver_8_15_59_65 = _this__0;
    _set_classes_(tmp0_receiver_8_15_59_65, plus(_get_classes_(tmp0_receiver_8_15_59_65), 'btn'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_111());
    _this__0.unaryPlus_4('Trinken!');
  };
  _no_name_provided__116.prototype.invoke_293 = function (p1) {
    this.invoke_236(p1 instanceof BUTTON ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__116.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__117() {
  }
  _no_name_provided__117.prototype.invoke_208 = function (_this__0) {
    _this__0._set_type_(InputType_text_getInstance());
    _this__0._set_name_('playername');
    _set_id_(_this__0, 'pregame-playernameInp');
    _this__0._set_autoComplete_(false);
    _this__0._set_placeholder_('Name');
    _set_onFocusFunction_(_this__0, _no_name_provided_$factory_106());
    _set_onBlurFunction_(_this__0, _no_name_provided_$factory_107());
    _set_onKeyUpFunction_(_this__0, _no_name_provided_$factory_108());
  };
  _no_name_provided__117.prototype.invoke_293 = function (p1) {
    this.invoke_208(p1 instanceof INPUT ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__117.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__118() {
  }
  _no_name_provided__118.prototype.invoke_236 = function (_this__0) {
    _set_id_(_this__0, 'pregame-addPlayerBtn');
    var tmp0_receiver_8_35_41 = _this__0;
    _set_classes_(tmp0_receiver_8_35_41, plus(_get_classes_(tmp0_receiver_8_35_41), 'btn'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_109());
    _this__0.unaryPlus_4('+');
  };
  _no_name_provided__118.prototype.invoke_293 = function (p1) {
    this.invoke_236(p1 instanceof BUTTON ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__118.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__119() {
  }
  _no_name_provided__119.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'pregame-playerList');
  };
  _no_name_provided__119.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__119.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__120() {
  }
  _no_name_provided__120.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'pregame-buttonWrapper');
    var tmp0_button_0_5_49_55 = null;
    var tmp1_button_0_6_50_56 = null;
    var tmp2_button_0_7_51_57 = null;
    var tmp3_button_0_8_52_58 = null;
    var tmp4_button_0_9_53_59 = null;
    var tmp0_safe_receiver_3_11_55_61 = tmp0_button_0_5_49_55;
    var tmp = tmp0_safe_receiver_3_11_55_61 == null ? null : enumEncode(tmp0_safe_receiver_3_11_55_61);
    var tmp1_safe_receiver_4_12_56_62 = tmp1_button_0_6_50_56;
    var tmp_0 = tmp1_safe_receiver_4_12_56_62 == null ? null : enumEncode(tmp1_safe_receiver_4_12_56_62);
    var tmp2_safe_receiver_5_13_57_63 = tmp3_button_0_8_52_58;
    var tmp0_visit_0_2_10_54_60 = new BUTTON(attributesMapOf_0(['formenctype', tmp, 'formmethod', tmp_0, 'name', tmp2_button_0_7_51_57, 'type', tmp2_safe_receiver_5_13_57_63 == null ? null : enumEncode(tmp2_safe_receiver_5_13_57_63), 'class', tmp4_button_0_9_53_59]), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_10_54_60, _no_name_provided_$factory_110());
  };
  _no_name_provided__120.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__120.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__121() {
  }
  _no_name_provided__121.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'pregame-title');
    _this__0.unaryPlus_4('Pregame');
  };
  _no_name_provided__121.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__121.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__122() {
  }
  _no_name_provided__122.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'pregame-content');
    var tmp0_input_0_5_11 = null;
    var tmp1_input_0_6_12 = null;
    var tmp2_input_0_7_13 = null;
    var tmp3_input_0_8_14 = null;
    var tmp4_input_0_9_15 = null;
    var tmp0_safe_receiver_3_11_17 = tmp0_input_0_5_11;
    var tmp = tmp0_safe_receiver_3_11_17 == null ? null : enumEncode(tmp0_safe_receiver_3_11_17);
    var tmp1_safe_receiver_4_12_18 = tmp1_input_0_6_12;
    var tmp_0 = tmp1_safe_receiver_4_12_18 == null ? null : enumEncode(tmp1_safe_receiver_4_12_18);
    var tmp2_safe_receiver_5_13_19 = tmp2_input_0_7_13;
    var tmp0_visit_0_2_10_16 = new INPUT(attributesMapOf_0(['type', tmp, 'formenctype', tmp_0, 'formmethod', tmp2_safe_receiver_5_13_19 == null ? null : enumEncode(tmp2_safe_receiver_5_13_19), 'name', tmp3_input_0_8_14, 'class', tmp4_input_0_9_15]), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_10_16, _no_name_provided_$factory_102());
    var tmp5_button_0_25_31 = null;
    var tmp6_button_0_26_32 = null;
    var tmp7_button_0_27_33 = null;
    var tmp8_button_0_28_34 = null;
    var tmp9_button_0_29_35 = null;
    var tmp0_safe_receiver_3_31_37 = tmp5_button_0_25_31;
    var tmp_1 = tmp0_safe_receiver_3_31_37 == null ? null : enumEncode(tmp0_safe_receiver_3_31_37);
    var tmp1_safe_receiver_4_32_38 = tmp6_button_0_26_32;
    var tmp_2 = tmp1_safe_receiver_4_32_38 == null ? null : enumEncode(tmp1_safe_receiver_4_32_38);
    var tmp2_safe_receiver_5_33_39 = tmp8_button_0_28_34;
    var tmp0_visit_0_2_30_36 = new BUTTON(attributesMapOf_0(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', tmp7_button_0_27_33, 'type', tmp2_safe_receiver_5_33_39 == null ? null : enumEncode(tmp2_safe_receiver_5_33_39), 'class', tmp9_button_0_29_35]), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_30_36, _no_name_provided_$factory_103());
    var tmp10_div_0_43_49 = null;
    var tmp0_visit_0_2_44_50 = new DIV(attributesMapOf('class', tmp10_div_0_43_49), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_44_50, _no_name_provided_$factory_104());
    var tmp11_div_0_46_52 = null;
    var tmp0_visit_0_2_47_53 = new DIV(attributesMapOf('class', tmp11_div_0_46_52), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_47_53, _no_name_provided_$factory_105());
  };
  _no_name_provided__122.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__122.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__123() {
  }
  _no_name_provided__123.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'root');
    var tmp0_div_0_5 = null;
    var tmp0_visit_0_2_6 = new DIV(attributesMapOf('class', tmp0_div_0_5), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_6, _no_name_provided_$factory_100());
    var tmp1_div_0_8 = null;
    var tmp0_visit_0_2_9 = new DIV(attributesMapOf('class', tmp1_div_0_8), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_9, _no_name_provided_$factory_101());
  };
  _no_name_provided__123.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__123.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_99() {
    var i = new _no_name_provided__123();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_100() {
    var i = new _no_name_provided__121();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_101() {
    var i = new _no_name_provided__122();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_102() {
    var i = new _no_name_provided__117();
    return function (p1) {
      i.invoke_208(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_103() {
    var i = new _no_name_provided__118();
    return function (p1) {
      i.invoke_236(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_104() {
    var i = new _no_name_provided__119();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_105() {
    var i = new _no_name_provided__120();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_106() {
    var i = new _no_name_provided__110();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_107() {
    var i = new _no_name_provided__111();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_108() {
    var i = new _no_name_provided__112();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_109() {
    var i = new _no_name_provided__113();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_110() {
    var i = new _no_name_provided__116();
    return function (p1) {
      i.invoke_236(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_111() {
    var i = new _no_name_provided__115();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_112() {
    var i = new _no_name_provided__114();
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function startmenu() {
    window.location.hash = '#startmenu';
    currentPage = '#startmenu';
    game_getInstance()._set_isRunning_(false);
    var tmp0_div_0 = _get_create_(document);
    var tmp1_div_0 = null;
    var tmp0_visitAndFinalize_0_2 = new DIV(attributesMapOf('class', tmp1_div_0), tmp0_div_0);
    var tmp = visitTagAndFinalize(tmp0_visitAndFinalize_0_2, tmp0_div_0, _no_name_provided_$factory_113());
    return tmp instanceof HTMLDivElement ? tmp : THROW_CCE();
  }
  function _no_name_provided__124() {
  }
  _no_name_provided__124.prototype.invoke_283 = function () {
    playerList_getInstance().update_0();
  };
  _no_name_provided__124.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__124.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__125() {
  }
  _no_name_provided__125.prototype.invoke_285 = function (_anonymous_parameter_0_) {
    var tmp = pregame();
    changePage(tmp, _no_name_provided_$factory_120());
  };
  _no_name_provided__125.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__125.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__126() {
  }
  _no_name_provided__126.prototype.invoke_283 = function () {
    optionsDoAfter();
  };
  _no_name_provided__126.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__126.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__127() {
  }
  _no_name_provided__127.prototype.invoke_285 = function (_anonymous_parameter_0_) {
    var tmp = options();
    changePage(tmp, _no_name_provided_$factory_122());
  };
  _no_name_provided__127.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__127.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__128() {
  }
  _no_name_provided__128.prototype.invoke_236 = function (_this__0) {
    _set_id_(_this__0, 'playBtn');
    var tmp0_receiver_8_16_22 = _this__0;
    _set_classes_(tmp0_receiver_8_16_22, plus(_get_classes_(tmp0_receiver_8_16_22), 'startMenu-btn'));
    var tmp1_receiver_9_17_23 = _this__0;
    _set_classes_(tmp1_receiver_9_17_23, plus(_get_classes_(tmp1_receiver_9_17_23), 'btn'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_119());
    _this__0.unaryPlus_4('Spielen!');
  };
  _no_name_provided__128.prototype.invoke_293 = function (p1) {
    this.invoke_236(p1 instanceof BUTTON ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__128.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__129() {
  }
  _no_name_provided__129.prototype.invoke_236 = function (_this__0) {
    _set_id_(_this__0, 'optionBtn');
    var tmp0_receiver_8_30_36 = _this__0;
    _set_classes_(tmp0_receiver_8_30_36, plus(_get_classes_(tmp0_receiver_8_30_36), 'startMenu-btn'));
    var tmp1_receiver_9_31_37 = _this__0;
    _set_classes_(tmp1_receiver_9_31_37, plus(_get_classes_(tmp1_receiver_9_31_37), 'btn'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_121());
    _this__0.unaryPlus_4('Einstellungen');
  };
  _no_name_provided__129.prototype.invoke_293 = function (p1) {
    this.invoke_236(p1 instanceof BUTTON ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__129.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__130() {
  }
  _no_name_provided__130.prototype.invoke_285 = function (_anonymous_parameter_0_) {
    shareRoutine();
  };
  _no_name_provided__130.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__130.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__131() {
  }
  _no_name_provided__131.prototype.invoke_236 = function (_this__0) {
    _set_id_(_this__0, 'shareBtn');
    var tmp0_receiver_8_16_54 = _this__0;
    _set_classes_(tmp0_receiver_8_16_54, plus(_get_classes_(tmp0_receiver_8_16_54), 'startMenu-btn'));
    var tmp1_receiver_9_17_55 = _this__0;
    _set_classes_(tmp1_receiver_9_17_55, plus(_get_classes_(tmp1_receiver_9_17_55), 'btn'));
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_124());
    _this__0.unaryPlus_4('Teilen');
  };
  _no_name_provided__131.prototype.invoke_293 = function (p1) {
    this.invoke_236(p1 instanceof BUTTON ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__131.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__132() {
  }
  _no_name_provided__132.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'startMenu-title');
    _this__0.unaryPlus_4('Trink!Trink!');
  };
  _no_name_provided__132.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__132.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__133() {
  }
  _no_name_provided__133.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_11 = _this__0;
    _set_classes_(tmp0_receiver_5_11, plus(_get_classes_(tmp0_receiver_5_11), 'startMenu-btns'));
    var tmp0_button_0_6_12 = null;
    var tmp1_button_0_7_13 = null;
    var tmp2_button_0_8_14 = null;
    var tmp3_button_0_9_15 = null;
    var tmp4_button_0_10_16 = null;
    var tmp0_safe_receiver_3_12_18 = tmp0_button_0_6_12;
    var tmp = tmp0_safe_receiver_3_12_18 == null ? null : enumEncode(tmp0_safe_receiver_3_12_18);
    var tmp1_safe_receiver_4_13_19 = tmp1_button_0_7_13;
    var tmp_0 = tmp1_safe_receiver_4_13_19 == null ? null : enumEncode(tmp1_safe_receiver_4_13_19);
    var tmp2_safe_receiver_5_14_20 = tmp3_button_0_9_15;
    var tmp0_visit_0_2_11_17 = new BUTTON(attributesMapOf_0(['formenctype', tmp, 'formmethod', tmp_0, 'name', tmp2_button_0_8_14, 'type', tmp2_safe_receiver_5_14_20 == null ? null : enumEncode(tmp2_safe_receiver_5_14_20), 'class', tmp4_button_0_10_16]), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_11_17, _no_name_provided_$factory_117());
    var tmp5_button_0_20_26 = null;
    var tmp6_button_0_21_27 = null;
    var tmp7_button_0_22_28 = null;
    var tmp8_button_0_23_29 = null;
    var tmp9_button_0_24_30 = null;
    var tmp0_safe_receiver_3_26_32 = tmp5_button_0_20_26;
    var tmp_1 = tmp0_safe_receiver_3_26_32 == null ? null : enumEncode(tmp0_safe_receiver_3_26_32);
    var tmp1_safe_receiver_4_27_33 = tmp6_button_0_21_27;
    var tmp_2 = tmp1_safe_receiver_4_27_33 == null ? null : enumEncode(tmp1_safe_receiver_4_27_33);
    var tmp2_safe_receiver_5_28_34 = tmp8_button_0_23_29;
    var tmp0_visit_0_2_25_31 = new BUTTON(attributesMapOf_0(['formenctype', tmp_1, 'formmethod', tmp_2, 'name', tmp7_button_0_22_28, 'type', tmp2_safe_receiver_5_28_34 == null ? null : enumEncode(tmp2_safe_receiver_5_28_34), 'class', tmp9_button_0_24_30]), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_25_31, _no_name_provided_$factory_118());
  };
  _no_name_provided__133.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__133.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__134() {
  }
  _no_name_provided__134.prototype.invoke_288 = function (_this__0) {
    var tmp0_receiver_5_43 = _this__0;
    _set_classes_(tmp0_receiver_5_43, plus(_get_classes_(tmp0_receiver_5_43), 'startMenu-btns'));
    var tmp0_button_0_6_44 = null;
    var tmp1_button_0_7_45 = null;
    var tmp2_button_0_8_46 = null;
    var tmp3_button_0_9_47 = null;
    var tmp4_button_0_10_48 = null;
    var tmp0_safe_receiver_3_12_50 = tmp0_button_0_6_44;
    var tmp = tmp0_safe_receiver_3_12_50 == null ? null : enumEncode(tmp0_safe_receiver_3_12_50);
    var tmp1_safe_receiver_4_13_51 = tmp1_button_0_7_45;
    var tmp_0 = tmp1_safe_receiver_4_13_51 == null ? null : enumEncode(tmp1_safe_receiver_4_13_51);
    var tmp2_safe_receiver_5_14_52 = tmp3_button_0_9_47;
    var tmp0_visit_0_2_11_49 = new BUTTON(attributesMapOf_0(['formenctype', tmp, 'formmethod', tmp_0, 'name', tmp2_button_0_8_46, 'type', tmp2_safe_receiver_5_14_52 == null ? null : enumEncode(tmp2_safe_receiver_5_14_52), 'class', tmp4_button_0_10_48]), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_11_49, _no_name_provided_$factory_123());
  };
  _no_name_provided__134.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__134.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__135() {
  }
  _no_name_provided__135.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'root');
    var tmp0_div_0_5 = null;
    var tmp0_visit_0_2_6 = new DIV(attributesMapOf('class', tmp0_div_0_5), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_6, _no_name_provided_$factory_114());
    var tmp1_div_0_8 = null;
    var tmp0_visit_0_2_9 = new DIV(attributesMapOf('class', tmp1_div_0_8), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_9, _no_name_provided_$factory_115());
    var tmp2_div_0_40 = null;
    var tmp0_visit_0_2_41 = new DIV(attributesMapOf('class', tmp2_div_0_40), _this__0._get_consumer__8());
    visitTag(tmp0_visit_0_2_41, _no_name_provided_$factory_116());
  };
  _no_name_provided__135.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__135.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_113() {
    var i = new _no_name_provided__135();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_114() {
    var i = new _no_name_provided__132();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_115() {
    var i = new _no_name_provided__133();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_116() {
    var i = new _no_name_provided__134();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_117() {
    var i = new _no_name_provided__128();
    return function (p1) {
      i.invoke_236(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_118() {
    var i = new _no_name_provided__129();
    return function (p1) {
      i.invoke_236(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_119() {
    var i = new _no_name_provided__125();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_120() {
    var i = new _no_name_provided__124();
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_121() {
    var i = new _no_name_provided__127();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_122() {
    var i = new _no_name_provided__126();
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_123() {
    var i = new _no_name_provided__131();
    return function (p1) {
      i.invoke_236(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_124() {
    var i = new _no_name_provided__130();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function game() {
    game_instance = this;
    this._isRunning = null;
    this._askNextOpportunity = null;
  }
  game.prototype._set_isRunning_ = function (value) {
    session_getInstance().set_5('isRunning', value);
    this._isRunning = value;
  };
  game.prototype._get_isRunning_ = function () {
    var tmp = session_getInstance().get_26('isRunning');
    return (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null;
  };
  game.$metadata$ = {
    simpleName: 'game',
    kind: 'object',
    interfaces: []
  };
  var game_instance;
  function game_getInstance() {
    if (game_instance == null)
      new game();
    return game_instance;
  }
  function _no_name_provided__136($cardDyn) {
    this._$cardDyn = $cardDyn;
  }
  _no_name_provided__136.prototype.invoke_283 = function () {
    interactions_getInstance()._isMoving = false;
    this._$cardDyn.style.transition = '' + 'all ' + constants_getInstance()._turnTime + 'ms';
  };
  _no_name_provided__136.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__136.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__137($cardDyn) {
    this._$cardDyn_0 = $cardDyn;
  }
  _no_name_provided__137.prototype.invoke_287 = function () {
    this._$cardDyn_0.style.transition = '' + 'all ' + constants_getInstance()._animTimeBounce + 'ms';
    this._$cardDyn_0.style.transform = getMatrix(interactions_getInstance(), 0.0, 0.0, interactions_getInstance()._offsetY);
    var tmp = window;
    return function () {
      var $externalVarargReceiverTmp = tmp;
      return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_132(this._$cardDyn_0), constants_getInstance()._animTimeBounce]);
    }.call(this);
  };
  _no_name_provided__137.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__138() {
  }
  _no_name_provided__138.prototype.invoke_283 = function () {
    availableCards_getInstance().putCard();
    rumbler_getInstance().rumble(1.3);
    interactions_getInstance()._isMoving = false;
  };
  _no_name_provided__138.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__138.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__139() {
  }
  _no_name_provided__139.prototype.invoke_283 = function () {
    var tmp = startmenu();
    changePage$default(tmp, null, 2, null);
    var tmp_0 = rumbler_getInstance();
    tmp_0.rumble$default(0.0, 1, null);
  };
  _no_name_provided__139.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__139.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__140() {
  }
  _no_name_provided__140.prototype.invoke_283 = function () {
    interactions_getInstance()._shouldRotate = true;
  };
  _no_name_provided__140.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__140.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__141() {
  }
  _no_name_provided__141.prototype.invoke_283 = function () {
    availableCards_getInstance().putCard();
    interactions_getInstance()._isMoving = false;
  };
  _no_name_provided__141.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__141.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__142() {
  }
  _no_name_provided__142.prototype.invoke_283 = function () {
    var tmp = startmenu();
    changePage$default(tmp, null, 2, null);
  };
  _no_name_provided__142.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__142.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function constants() {
    constants_instance = this;
    this._animTimeRet = 100;
    this._animTimeBounce = 80;
    this._animTimeOut = 150;
    this._animTimeDef = 150;
    this._turnTime = 5;
  }
  constants.prototype._get_animTimeIn_ = function () {
    return isMobile() ? 250 : 100;
  };
  constants.$metadata$ = {
    simpleName: 'constants',
    kind: 'object',
    interfaces: []
  };
  var constants_instance;
  function constants_getInstance() {
    if (constants_instance == null)
      new constants();
    return constants_instance;
  }
  function getMatrix($this, angle, tx, ty) {
    var tmp = Math.cos(angle);
    var tmp_0 = Math.sin(angle);
    var tmp0_sin_0 = -angle;
    var tmp_1 = Math.sin(tmp0_sin_0);
    return '' + 'matrix(' + tmp + ', ' + tmp_0 + ', ' + tmp_1 + ', ' + Math.cos(angle) + ', ' + tx + ', ' + ty + ')';
  }
  function _no_name_provided__143() {
  }
  _no_name_provided__143.prototype.invoke_285 = function (it) {
    var tmp0_asDynamic_0 = it.target;
    tmp0_asDynamic_0.style.transition = '' + 'all ' + constants_getInstance()._turnTime + 'ms';
    interactions_getInstance()._dX = 0.0;
    interactions_getInstance()._dY = 0.0;
    if (!interactions_getInstance()._isMoving) {
      var tmp = interactions_getInstance();
      var tmp_0 = it.touches[0].clientX;
      tmp._oriX = (!(tmp_0 == null) ? typeof tmp_0 === 'number' : false) ? tmp_0 : THROW_CCE();
      var tmp_1 = interactions_getInstance();
      var tmp_2 = it.touches[0].clientY;
      tmp_1._oriY = (!(tmp_2 == null) ? typeof tmp_2 === 'number' : false) ? tmp_2 : THROW_CCE();
    }};
  _no_name_provided__143.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__143.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__144() {
  }
  _no_name_provided__144.prototype.invoke_285 = function (it) {
    var tmp0_asDynamic_0 = document.querySelector('#card');
    var cardDyn = tmp0_asDynamic_0;
    var tmp1_asDynamic_0 = document.querySelector('#play-name');
    var playNameDyn = tmp1_asDynamic_0;
    var zoneSize = new Pair(ensureNotNull(document.body).clientWidth * 0.3, ensureNotNull(document.body).clientHeight * 0.33);
    if ((interactions_getInstance()._dX < zoneSize._first ? interactions_getInstance()._dX > -zoneSize._first : false) ? interactions_getInstance()._dY < zoneSize._second : false) {
      interactions_getInstance()._isMoving = true;
      playNameDyn.style.opacity = '1.0';
      cardDyn.style.transition = '' + 'all ' + constants_getInstance()._animTimeRet + 'ms';
      var tmp = interactions_getInstance();
      var tmp2_sin_0 = interactions_getInstance()._dX;
      var tmp_0 = -Math.sin(tmp2_sin_0) * 15;
      var tmp3_sin_0 = interactions_getInstance()._dY;
      cardDyn.style.transform = getMatrix(tmp, 0.0, tmp_0, -Math.sin(tmp3_sin_0) * 15 + interactions_getInstance()._offsetY);
      var tmp_1 = window;
      (function () {
        var $externalVarargReceiverTmp = tmp_1;
        return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_129(cardDyn), constants_getInstance()._animTimeRet]);
      }.call(this));
      Unit_getInstance();
    } else {
      if ((interactions_getInstance()._dY > zoneSize._second ? interactions_getInstance()._dX < zoneSize._first : false) ? interactions_getInstance()._dX > -zoneSize._first : false) {
        interactions_getInstance()._isMoving = true;
        cardDyn.style.transition = '' + 'all ' + constants_getInstance()._animTimeOut + 'ms';
        cardDyn.style.transform = getMatrix(interactions_getInstance(), interactions_getInstance()._angle, interactions_getInstance()._dX, interactions_getInstance()._dY + zoneSize._second * 1.5);
      } else {
        interactions_getInstance()._isMoving = true;
        cardDyn.style.transition = '' + 'all ' + constants_getInstance()._animTimeOut + 'ms';
        var tmp_2 = interactions_getInstance();
        var tmp_3 = interactions_getInstance()._angle;
        var tmp_4 = interactions_getInstance()._dX;
        var tmp4_sign_0 = interactions_getInstance()._dX;
        cardDyn.style.transform = getMatrix(tmp_2, tmp_3, tmp_4 + Math.sign(tmp4_sign_0) * zoneSize._first * 2.2, interactions_getInstance()._dY + interactions_getInstance()._offsetY);
      }
      if (game_getInstance()._get_isRunning_() === true) {
        var tmp_5 = window;
        (function () {
          var $externalVarargReceiverTmp = tmp_5;
          return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_130(), roundToInt(constants_getInstance()._animTimeOut * 1.5)]);
        }.call(this));
        Unit_getInstance();
      } else {
        var tmp_6 = window;
        (function () {
          var $externalVarargReceiverTmp = tmp_6;
          return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_131(), imul(constants_getInstance()._animTimeOut, 2)]);
        }.call(this));
        Unit_getInstance();
      }
    }
  };
  _no_name_provided__144.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__144.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__145() {
  }
  _no_name_provided__145.prototype.invoke_285 = function (it) {
    if (!interactions_getInstance()._isMoving) {
      if (interactions_getInstance()._shouldRotate) {
        interactions_getInstance()._shouldRotate = false;
        var tmp = window;
        (function () {
          var $externalVarargReceiverTmp = tmp;
          return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_133(), interactions_getInstance()._rotateTimeout]);
        }.call(this));
        Unit_getInstance();
        var tmp_0 = interactions_getInstance();
        var tmp_1 = it.touches[0].clientX;
        tmp_0._lastPoint = new Pair(tmp_1, it.touches[0].clientY);
        var tmp_2 = interactions_getInstance();
        var tmp_3 = it.touches[0].clientX - interactions_getInstance()._oriX;
        tmp_2._dX = (!(tmp_3 == null) ? typeof tmp_3 === 'number' : false) ? tmp_3 : THROW_CCE();
        var tmp_4 = interactions_getInstance();
        var tmp_5 = it.touches[0].clientY - interactions_getInstance()._oriY;
        tmp_4._dY = (!(tmp_5 == null) ? typeof tmp_5 === 'number' : false) ? tmp_5 : THROW_CCE();
        if (interactions_getInstance()._dX >= 0.0) {
          interactions_getInstance()._angle = (coerce(interactions_getInstance()._dX, 0.0, 200.0) - 0) / 200 * 20 * 3.141592653589793 / 180;
          var tmp0_asDynamic_0 = document.querySelector('#play-name');
          tmp0_asDynamic_0.style.opacity = (coerce(interactions_getInstance()._dX, 0.0, 100.0) - 0) / 100 * -1.0 + 1.0;
        } else {
          interactions_getInstance()._angle = -((coerce(-interactions_getInstance()._dX, 0.0, 200.0) - 0) / 200 * 20) * 3.141592653589793 / 180;
          var tmp1_asDynamic_0 = document.querySelector('#play-name');
          tmp1_asDynamic_0.style.opacity = (coerce(-interactions_getInstance()._dX, 0.0, 100.0) - 0) / 100 * -1.0 + 1.0;
        }
        var tmp2_asDynamic_0 = it.target;
        tmp2_asDynamic_0.style.transform = getMatrix(interactions_getInstance(), interactions_getInstance()._angle, interactions_getInstance()._dX + interactions_getInstance()._offsetX, interactions_getInstance()._dY + interactions_getInstance()._offsetY);
      }}};
  _no_name_provided__145.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__145.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__146() {
  }
  _no_name_provided__146.prototype.invoke_265 = function (it) {
    if (((it.code === 'ArrowRight' ? true : it.code === 'ArrowLeft') ? true : it.code === 'ArrowDown') ? !interactions_getInstance()._isMoving : false) {
      var tmp0_subject = it.code;
      {
        var params;
        switch (tmp0_subject) {
          case 'ArrowRight':
            params = new Pair(1.0, 0.0);
            break;
          case 'ArrowLeft':
            params = new Pair(-1.0, 0.0);
            break;
          case 'ArrowDown':
            params = new Pair(0.0, 1.0);
            break;
          default:params = new Pair(0.0, 0.0);
            break;
        }
      }
      var zoneSize = new Pair(ensureNotNull(document.body).clientWidth * 0.3, ensureNotNull(document.body).clientHeight * 0.33);
      interactions_getInstance()._isMoving = true;
      var tmp0_asDynamic_0 = document.querySelector('#card');
      tmp0_asDynamic_0.style.transition = '' + 'all ' + imul(constants_getInstance()._animTimeOut, 2) + 'ms';
      var tmp1_asDynamic_0 = document.querySelector('#play-name');
      tmp1_asDynamic_0.style.transition = '' + 'all ' + imul(constants_getInstance()._animTimeOut, 2) + 'ms';
      var tmp2_asDynamic_0 = document.querySelector('#play-name');
      tmp2_asDynamic_0.style.opacity = '0.0';
      var tmp3_asDynamic_0 = document.querySelector('#card');
      var tmp = interactions_getInstance();
      var tmp4_sin_0 = params._first;
      var tmp_0 = 0.4 * Math.sin(tmp4_sin_0);
      var tmp5_sign_0 = params._first;
      tmp3_asDynamic_0.style.transform = getMatrix(tmp, tmp_0, Math.sign(tmp5_sign_0) * zoneSize._first * 3.5, interactions_getInstance()._offsetY + params._second * zoneSize._second * 2.3);
      if (game_getInstance()._get_isRunning_() === true) {
        var tmp_1 = window;
        (function () {
          var $externalVarargReceiverTmp = tmp_1;
          return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_134(), roundToInt(imul(constants_getInstance()._animTimeOut, 2) * 1.2)]);
        }.call(this));
        Unit_getInstance();
      } else {
        var tmp_2 = window;
        (function () {
          var $externalVarargReceiverTmp = tmp_2;
          return $externalVarargReceiverTmp.setTimeout.apply($externalVarargReceiverTmp, [_no_name_provided_$factory_135(), imul(constants_getInstance()._animTimeOut, 4)]);
        }.call(this));
        Unit_getInstance();
      }
    }};
  _no_name_provided__146.prototype.invoke_293 = function (p1) {
    this.invoke_265(p1 instanceof KeyboardEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__146.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function interactions() {
    interactions_instance = this;
    this._oriX = 0.0;
    this._oriY = 0.0;
    this._dX = 0.0;
    this._dY = 0.0;
    this._offsetX = 0.0;
    this._offsetY = 40.0;
    this._angle = 0.0;
    this._isMoving = false;
    this._shouldRotate = true;
    this._rotateTimeout = 5;
    this._lastPoint = new Pair(0.0, 0.0);
  }
  interactions.prototype.addInteractions = function (_this__0) {
    _this__0.addEventListener('touchstart', _no_name_provided_$factory_125());
    _this__0.addEventListener('touchend', _no_name_provided_$factory_126());
    _this__0.addEventListener('touchmove', _no_name_provided_$factory_127());
    var tmp = window;
    tmp.onkeyup = _no_name_provided_$factory_128();
  };
  interactions.$metadata$ = {
    simpleName: 'interactions',
    kind: 'object',
    interfaces: []
  };
  var interactions_instance;
  function interactions_getInstance() {
    if (interactions_instance == null)
      new interactions();
    return interactions_instance;
  }
  function _no_name_provided_$factory_125() {
    var i = new _no_name_provided__143();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_126() {
    var i = new _no_name_provided__144();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_127() {
    var i = new _no_name_provided__145();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_128() {
    var i = new _no_name_provided__146();
    return function (p1) {
      i.invoke_265(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_129($cardDyn) {
    var i = new _no_name_provided__137($cardDyn);
    return function () {
      return i.invoke_287();
    };
  }
  function _no_name_provided_$factory_130() {
    var i = new _no_name_provided__138();
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_131() {
    var i = new _no_name_provided__139();
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_132($cardDyn) {
    var i = new _no_name_provided__136($cardDyn);
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_133() {
    var i = new _no_name_provided__140();
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_134() {
    var i = new _no_name_provided__141();
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_135() {
    var i = new _no_name_provided__142();
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  var currentPage;
  function main() {
    var tmp = window;
    tmp.onpopstate = _no_name_provided_$factory_136();
    var tmp_0 = window;
    tmp_0.onload = _no_name_provided_$factory_137();
  }
  function handlePageChange() {
    if (window.location.hash === '#pregame' ? currentPage === '#play' : false) {
      window.location.hash = '#play';
      return Unit_getInstance();
    }var tmp0_subject = window.location.hash;
    switch (tmp0_subject) {
      case '#startemenu':
        var tmp = startmenu();
        changePage$default(tmp, null, 2, null);
        break;
      case '#pregame':
        var tmp_0 = pregame();
        changePage(tmp_0, _no_name_provided_$factory_138());
        break;
      case '#play':
        var tmp_1 = play();
        changePage(tmp_1, _no_name_provided_$factory_139());
        break;
      case '#options':
        var tmp_2 = options();
        changePage(tmp_2, _no_name_provided_$factory_140());
        break;
      default:var tmp_3 = startmenu();
        changePage$default(tmp_3, null, 2, null);
        break;
    }
  }
  function optionsDoAfter() {
    var wrapper = document.querySelectorAll('.options-wrapperInside');
    options_getInstance().updateAllViews();
    if (isMobile()) {
      var tmp0_repeat_0 = wrapper.length;
      var inductionVariable = 0;
      if (inductionVariable < tmp0_repeat_0)
        do {
          var index_2 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0_asDynamic_0_4 = wrapper[index_2];
          tmp0_asDynamic_0_4.style.flexDirection = 'column';
        }
         while (inductionVariable < tmp0_repeat_0);
    } else {
      var tmp1_repeat_0 = wrapper.length;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < tmp1_repeat_0)
        do {
          var index_2_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp0_asDynamic_0_4_0 = wrapper[index_2_0];
          tmp0_asDynamic_0_4_0.style.flexDirection = 'row';
        }
         while (inductionVariable_0 < tmp1_repeat_0);
    }
  }
  function changePage(compo, doAfter) {
    (function () {
      var $externalVarargReceiverTmp = ensureNotNull(document.getElementById('root'));
      return $externalVarargReceiverTmp.replaceWith.apply($externalVarargReceiverTmp, [].concat([compo]));
    }.call(this));
    doAfter();
  }
  function changePage$default(compo, doAfter, $mask0, $handler) {
    if (!(($mask0 & 2) === 0)) {
      doAfter = _no_name_provided_$factory_141();
    }return changePage(compo, doAfter);
  }
  function _no_name_provided__147() {
  }
  _no_name_provided__147.prototype.invoke_267 = function (it) {
    handlePageChange();
  };
  _no_name_provided__147.prototype.invoke_293 = function (p1) {
    this.invoke_267(p1 instanceof PopStateEvent ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__147.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__148() {
  }
  _no_name_provided__148.prototype.invoke_285 = function (it) {
    reloadFresh();
  };
  _no_name_provided__148.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__148.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__149() {
  }
  _no_name_provided__149.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'version');
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_144());
    _this__0.unaryPlus_4('v1.2.0');
  };
  _no_name_provided__149.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__149.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__150() {
  }
  _no_name_provided__150.prototype.invoke_273 = function ($this$append) {
    var tmp0_div_0 = null;
    var tmp0_visitAndFinalize_0_2 = new DIV(attributesMapOf('class', tmp0_div_0), $this$append);
    var tmp = visitTagAndFinalize(tmp0_visitAndFinalize_0_2, $this$append, _no_name_provided_$factory_143());
    if (tmp instanceof HTMLDivElement)
      tmp;
    else
      THROW_CCE();
    Unit_getInstance();
  };
  _no_name_provided__150.prototype.invoke_293 = function (p1) {
    this.invoke_273((!(p1 == null) ? isInterface(p1, TagConsumer) : false) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__150.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__151() {
  }
  _no_name_provided__151.prototype.invoke_285 = function (it) {
    (function () {
      var $externalVarargReceiverTmp = ensureNotNull(document.documentElement).classList;
      return $externalVarargReceiverTmp.remove.apply($externalVarargReceiverTmp, [].concat(['themeLight']));
    }.call(this));
    (function () {
      var $externalVarargReceiverTmp = ensureNotNull(document.documentElement).classList;
      return $externalVarargReceiverTmp.remove.apply($externalVarargReceiverTmp, [].concat(['themeDark']));
    }.call(this));
    (function () {
      var $externalVarargReceiverTmp = ensureNotNull(document.documentElement).classList;
      return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].concat([session_getInstance().get_26('isDark') == true ? 'themeDark' : 'themeLight']));
    }.call(this));
    var tmp = ensureNotNull(document.body);
    append(tmp, _no_name_provided_$factory_142());
    Unit_getInstance();
    handlePageChange();
  };
  _no_name_provided__151.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__151.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__152() {
  }
  _no_name_provided__152.prototype.invoke_283 = function () {
    playerList_getInstance().update_0();
  };
  _no_name_provided__152.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__152.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__153() {
  }
  _no_name_provided__153.prototype.invoke_283 = function () {
    availableCards_getInstance().putCard();
  };
  _no_name_provided__153.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__153.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__154() {
  }
  _no_name_provided__154.prototype.invoke_283 = function () {
    optionsDoAfter();
  };
  _no_name_provided__154.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__154.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__155() {
  }
  _no_name_provided__155.prototype.invoke_283 = function () {
    return Unit_getInstance();
  };
  _no_name_provided__155.prototype.invoke_287 = function () {
    this.invoke_283();
    return Unit_getInstance();
  };
  _no_name_provided__155.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_136() {
    var i = new _no_name_provided__147();
    return function (p1) {
      i.invoke_267(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_137() {
    var i = new _no_name_provided__151();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_138() {
    var i = new _no_name_provided__152();
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_139() {
    var i = new _no_name_provided__153();
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_140() {
    var i = new _no_name_provided__154();
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_141() {
    var i = new _no_name_provided__155();
    return function () {
      i.invoke_283();
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_142() {
    var i = new _no_name_provided__150();
    return function (p1) {
      i.invoke_273(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_143() {
    var i = new _no_name_provided__149();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_144() {
    var i = new _no_name_provided__148();
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function theme() {
    theme_instance = this;
    this._isDark = null;
  }
  theme.prototype._set_isDark_ = function (value) {
    session_getInstance().set_5('isDark', value);
    this._isDark = value;
    this.updateView_1();
  };
  theme.prototype._get_isDark_ = function () {
    var tmp = this;
    var tmp0_elvis_lhs = this._isDark;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp_1 = session_getInstance().get_26('isDark');
      tmp_0 = (!(tmp_1 == null) ? typeof tmp_1 === 'boolean' : false) ? tmp_1 : null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      tmp_2 = false;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    tmp._isDark = tmp_2;
    return this._isDark;
  };
  theme.prototype.updateView_1 = function () {
    if (this._get_isDark_() === true) {
      var tmp0_safe_receiver = document.querySelector('#options-themeWrapper .options-chkbx[data-id="0"]');
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.removeAttribute('active');
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp1_safe_receiver = document.querySelector('#options-themeWrapper .options-chkbx[data-id="1"]');
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.setAttribute('active', '');
        Unit_getInstance();
      }
      Unit_getInstance();
    } else {
      var tmp2_safe_receiver = document.querySelector('#options-themeWrapper .options-chkbx[data-id="0"]');
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.setAttribute('active', '');
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp3_safe_receiver = document.querySelector('#options-themeWrapper .options-chkbx[data-id="1"]');
      if (tmp3_safe_receiver == null)
        null;
      else {
        tmp3_safe_receiver.removeAttribute('active');
        Unit_getInstance();
      }
      Unit_getInstance();
    }
    (function () {
      var $externalVarargReceiverTmp = ensureNotNull(document.documentElement).classList;
      return $externalVarargReceiverTmp.remove.apply($externalVarargReceiverTmp, [].concat(['themeDark']));
    }.call(this));
    (function () {
      var $externalVarargReceiverTmp = ensureNotNull(document.documentElement).classList;
      return $externalVarargReceiverTmp.remove.apply($externalVarargReceiverTmp, [].concat(['themeLight']));
    }.call(this));
    (function () {
      var $externalVarargReceiverTmp = ensureNotNull(document.documentElement).classList;
      return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].concat([this._get_isDark_() === true ? 'themeDark' : 'themeLight']));
    }.call(this));
  };
  theme.$metadata$ = {
    simpleName: 'theme',
    kind: 'object',
    interfaces: []
  };
  var theme_instance;
  function theme_getInstance() {
    if (theme_instance == null)
      new theme();
    return theme_instance;
  }
  function difficulty() {
    difficulty_instance = this;
    this._level_0 = null;
  }
  difficulty.prototype._set_level_ = function (value) {
    session_getInstance().set_5('difficulty.level', value);
    this._level_0 = value;
    this.updateView_1();
  };
  difficulty.prototype._get_level_ = function () {
    var tmp = this;
    var tmp0_elvis_lhs = this._level_0;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp_1 = session_getInstance().get_26('difficulty.level');
      tmp_0 = (!(tmp_1 == null) ? typeof tmp_1 === 'number' : false) ? tmp_1 : null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp_0;
    tmp._level_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    return this._level_0;
  };
  difficulty.prototype.updateView_1 = function () {
    var tmp0_subject = this._get_level_();
    switch (tmp0_subject) {
      case 0:
        var tmp1_safe_receiver = document.querySelector('#options-difficultyWrapper .options-chkbx[data-id="0"]');
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.setAttribute('active', '');
          Unit_getInstance();
        }

        Unit_getInstance();
        var tmp2_safe_receiver = document.querySelector('#options-difficultyWrapper .options-chkbx[data-id="1"]');
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.removeAttribute('active');
          Unit_getInstance();
        }

        Unit_getInstance();
        var tmp3_safe_receiver = document.querySelector('#options-difficultyWrapper .options-chkbx[data-id="2"]');
        if (tmp3_safe_receiver == null)
          null;
        else {
          tmp3_safe_receiver.removeAttribute('active');
          Unit_getInstance();
        }

        Unit_getInstance();
        break;
      case 1:
        var tmp4_safe_receiver = document.querySelector('#options-difficultyWrapper .options-chkbx[data-id="0"]');
        if (tmp4_safe_receiver == null)
          null;
        else {
          tmp4_safe_receiver.removeAttribute('active');
          Unit_getInstance();
        }

        Unit_getInstance();
        var tmp5_safe_receiver = document.querySelector('#options-difficultyWrapper .options-chkbx[data-id="1"]');
        if (tmp5_safe_receiver == null)
          null;
        else {
          tmp5_safe_receiver.setAttribute('active', '');
          Unit_getInstance();
        }

        Unit_getInstance();
        var tmp6_safe_receiver = document.querySelector('#options-difficultyWrapper .options-chkbx[data-id="2"]');
        if (tmp6_safe_receiver == null)
          null;
        else {
          tmp6_safe_receiver.removeAttribute('active');
          Unit_getInstance();
        }

        Unit_getInstance();
        break;
      case 2:
        var tmp7_safe_receiver = document.querySelector('#options-difficultyWrapper .options-chkbx[data-id="0"]');
        if (tmp7_safe_receiver == null)
          null;
        else {
          tmp7_safe_receiver.removeAttribute('active');
          Unit_getInstance();
        }

        Unit_getInstance();
        var tmp8_safe_receiver = document.querySelector('#options-difficultyWrapper .options-chkbx[data-id="1"]');
        if (tmp8_safe_receiver == null)
          null;
        else {
          tmp8_safe_receiver.removeAttribute('active');
          Unit_getInstance();
        }

        Unit_getInstance();
        var tmp9_safe_receiver = document.querySelector('#options-difficultyWrapper .options-chkbx[data-id="2"]');
        if (tmp9_safe_receiver == null)
          null;
        else {
          tmp9_safe_receiver.setAttribute('active', '');
          Unit_getInstance();
        }

        Unit_getInstance();
        break;
    }
  };
  difficulty.$metadata$ = {
    simpleName: 'difficulty',
    kind: 'object',
    interfaces: []
  };
  var difficulty_instance;
  function difficulty_getInstance() {
    if (difficulty_instance == null)
      new difficulty();
    return difficulty_instance;
  }
  function rumble() {
    rumble_instance = this;
    this._state_0 = null;
  }
  rumble.prototype._set_state_ = function (value) {
    session_getInstance().set_5('rumble.state', value);
    this._state_0 = value;
    this.updateView_1();
  };
  rumble.prototype._get_state_ = function () {
    var tmp = this;
    var tmp0_elvis_lhs = this._state_0;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp_1 = session_getInstance().get_26('rumble.state');
      tmp_0 = (!(tmp_1 == null) ? typeof tmp_1 === 'boolean' : false) ? tmp_1 : null;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      tmp_2 = true;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    tmp._state_0 = tmp_2;
    return this._state_0;
  };
  rumble.prototype.updateView_1 = function () {
    if (this._get_state_() === true) {
      var tmp0_safe_receiver = document.querySelector('#options-rumbleWrapper .options-chkbx[data-id="0"]');
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.setAttribute('active', '');
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp1_safe_receiver = document.querySelector('#options-rumbleWrapper .options-chkbx[data-id="1"]');
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.removeAttribute('active');
        Unit_getInstance();
      }
      Unit_getInstance();
    } else {
      var tmp2_safe_receiver = document.querySelector('#options-rumbleWrapper .options-chkbx[data-id="0"]');
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.removeAttribute('active');
        Unit_getInstance();
      }
      Unit_getInstance();
      var tmp3_safe_receiver = document.querySelector('#options-rumbleWrapper .options-chkbx[data-id="1"]');
      if (tmp3_safe_receiver == null)
        null;
      else {
        tmp3_safe_receiver.setAttribute('active', '');
        Unit_getInstance();
      }
      Unit_getInstance();
    }
  };
  rumble.$metadata$ = {
    simpleName: 'rumble',
    kind: 'object',
    interfaces: []
  };
  var rumble_instance;
  function rumble_getInstance() {
    if (rumble_instance == null)
      new rumble();
    return rumble_instance;
  }
  function options_0() {
    options_instance = this;
  }
  options_0.prototype.updateAllViews = function () {
    difficulty_getInstance().updateView_1();
    rumble_getInstance().updateView_1();
    theme_getInstance().updateView_1();
  };
  options_0.$metadata$ = {
    simpleName: 'options',
    kind: 'object',
    interfaces: []
  };
  var options_instance;
  function options_getInstance() {
    if (options_instance == null)
      new options_0();
    return options_instance;
  }
  function _no_name_provided__156($each_4) {
    this._$each_4 = $each_4;
  }
  _no_name_provided__156.prototype.invoke_285 = function (it) {
    playerList_getInstance().remove_13(this._$each_4);
  };
  _no_name_provided__156.prototype.invoke_293 = function (p1) {
    this.invoke_285(p1 instanceof Event ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__156.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__157() {
  }
  _no_name_provided__157.prototype.invoke_287 = function () {
    return [];
  };
  _no_name_provided__157.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__158() {
  }
  _no_name_provided__158.prototype.invoke_288 = function (_this__0) {
    _set_id_(_this__0, 'pregame-playerList');
  };
  _no_name_provided__158.prototype.invoke_293 = function (p1) {
    this.invoke_288(p1 instanceof DIV ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__158.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided__159($each_4) {
    this._$each_4_0 = $each_4;
  }
  _no_name_provided__159.prototype.invoke_290 = function (_this__0) {
    _set_onClickFunction_(_this__0, _no_name_provided_$factory_148(this._$each_4_0));
    _this__0.unaryPlus_4(this._$each_4_0);
  };
  _no_name_provided__159.prototype.invoke_293 = function (p1) {
    this.invoke_290(p1 instanceof SPAN ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__159.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function playerList() {
    playerList_instance = this;
    var tmp = this;
    tmp._players = [];
  }
  playerList.prototype._set_players_ = function (value) {
    session_getInstance().set_5('players', value);
    this._players = value;
  };
  playerList.prototype._get_players_ = function () {
    var tmp0_isEmpty_0 = this._players;
    if (tmp0_isEmpty_0.length === 0) {
      var tmp = this;
      var tmp_0 = session_getInstance().get_26('players');
      var tmp_1 = (!(tmp_0 == null) ? isArray(tmp_0) : false) ? tmp_0 : null;
      tmp._players = whenNull(tmp_1, _no_name_provided_$factory_145());
    } else {
    }
    return this._players;
  };
  playerList.prototype.add_17 = function (name) {
    var tmp0_also_0 = toMutableList(this._get_players_());
    tmp0_also_0.add_16(name);
    Unit_getInstance();
    var tmp1_toTypedArray_0 = tmp0_also_0;
    this._set_players_(copyToArray_0(tmp1_toTypedArray_0));
    this.update_0();
  };
  playerList.prototype.remove_13 = function (name) {
    var tmp0_also_0 = toMutableList(this._get_players_());
    tmp0_also_0.remove_12(name);
    Unit_getInstance();
    var tmp1_toTypedArray_0 = tmp0_also_0;
    this._set_players_(copyToArray_0(tmp1_toTypedArray_0));
    this.update_0();
  };
  playerList.prototype.randomPlayer = function () {
    return this._get_players_()[Default_getInstance().nextInt_6(this._get_players_().length)];
  };
  playerList.prototype.update_0 = function () {
    var tmp0_div_0 = _get_create_(document);
    var tmp1_div_0 = null;
    var tmp0_visitAndFinalize_0_2 = new DIV(attributesMapOf('class', tmp1_div_0), tmp0_div_0);
    var tmp = visitTagAndFinalize(tmp0_visitAndFinalize_0_2, tmp0_div_0, _no_name_provided_$factory_146());
    var newList = tmp instanceof HTMLDivElement ? tmp : THROW_CCE();
    var tmp2_forEach_0 = this._get_players_();
    var indexedObject = tmp2_forEach_0;
    var inductionVariable = 0;
    var last_0 = indexedObject.length;
    while (inductionVariable < last_0) {
      var element_2 = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var each_4 = element_2;
      var tmp0_span_0_5 = _get_create_(document);
      var tmp1_span_0_6 = null;
      var tmp0_visitAndFinalize_0_2_7 = new SPAN(attributesMapOf('class', tmp1_span_0_6), tmp0_span_0_5);
      (function () {
        var $externalVarargReceiverTmp = newList;
        return $externalVarargReceiverTmp.append.apply($externalVarargReceiverTmp, [].concat([visitTagAndFinalize(tmp0_visitAndFinalize_0_2_7, tmp0_span_0_5, _no_name_provided_$factory_147(each_4))]));
      }.call(this));
    }
    (function () {
      var $externalVarargReceiverTmp = ensureNotNull(document.querySelector('#pregame-playerList'));
      return $externalVarargReceiverTmp.replaceWith.apply($externalVarargReceiverTmp, [].concat([newList]));
    }.call(this));
  };
  playerList.$metadata$ = {
    simpleName: 'playerList',
    kind: 'object',
    interfaces: []
  };
  var playerList_instance;
  function playerList_getInstance() {
    if (playerList_instance == null)
      new playerList();
    return playerList_instance;
  }
  function _no_name_provided_$factory_145() {
    var i = new _no_name_provided__157();
    return function () {
      return i.invoke_287();
    };
  }
  function _no_name_provided_$factory_146() {
    var i = new _no_name_provided__158();
    return function (p1) {
      i.invoke_288(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_147($each_4) {
    var i = new _no_name_provided__159($each_4);
    return function (p1) {
      i.invoke_290(p1);
      return Unit_getInstance();
    };
  }
  function _no_name_provided_$factory_148($each_4) {
    var i = new _no_name_provided__156($each_4);
    return function (p1) {
      i.invoke_285(p1);
      return Unit_getInstance();
    };
  }
  function rumbler() {
    rumbler_instance = this;
  }
  rumbler.prototype.rumble = function (mul) {
    if (rumble_getInstance()._get_state_() === true) {
      window.navigator.vibrate(mul * 80);
      Unit_getInstance();
    }};
  rumbler.prototype.rumble$default = function (mul, $mask0, $handler) {
    if (!(($mask0 & 1) === 0))
      mul = 1.0;
    return this.rumble(mul);
  };
  rumbler.$metadata$ = {
    simpleName: 'rumbler',
    kind: 'object',
    interfaces: []
  };
  var rumbler_instance;
  function rumbler_getInstance() {
    if (rumbler_instance == null)
      new rumbler();
    return rumbler_instance;
  }
  function isMobile() {
    return window.navigator.maxTouchPoints > 1;
  }
  function session() {
    session_instance = this;
  }
  session.prototype.set_5 = function (id, content) {
    var tmp;
    if (typeof content === 'object') {
      tmp = JSON.stringify(content);
    } else {
      tmp = content;
    }
    var value = tmp;
    var tmp0_set_0 = sessionStorage;
    var tmp1_set_0 = value;
    tmp0_set_0[id] = tmp1_set_0;
  };
  session.prototype.get_26 = function (id) {
    var tmp0_get_0 = sessionStorage;
    var value = tmp0_get_0[id];
    var tmp0_safe_receiver = value;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      var tmp_0;
      try {
        tmp_0 = JSON.parse(tmp0_safe_receiver);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Exception) {
          tmp_1 = tmp0_safe_receiver;
        } else {
          {
            throw $p;
          }
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  session.$metadata$ = {
    simpleName: 'session',
    kind: 'object',
    interfaces: []
  };
  var session_instance;
  function session_getInstance() {
    if (session_instance == null)
      new session();
    return session_instance;
  }
  function coerce(input, min, max) {
    var tmp;
    if (input < min) {
      tmp = min;
    } else if (input > max) {
      tmp = max;
    } else {
      tmp = input;
    }
    return tmp;
  }
  function shareRoutine() {
    var tmp = rumbler_getInstance();
    tmp.rumble$default(0.0, 1, null);
    try {
      navigator.share({url: 'https://drinkingapp-4376b.web.app/', title: 'Trink! Trink!'}).then(function (d) {
        console.log(d);
      });
    } catch ($p) {
      if ($p instanceof Exception) {
        (function () {
          var $externalVarargReceiverTmp = console;
          return $externalVarargReceiverTmp.log.apply($externalVarargReceiverTmp, [].concat([$p]));
        }.call(this));
      } else {
        {
          throw $p;
        }
      }
    }
  }
  function reloadFresh() {
    var tmp = window.navigator.serviceWorker.getRegistration();
    tmp.then(_no_name_provided_$factory_149());
    Unit_getInstance();
  }
  function whenNull(_this_, function_0) {
    var tmp0_elvis_lhs = _this_;
    return tmp0_elvis_lhs == null ? function_0() : tmp0_elvis_lhs;
  }
  function replaceMultiple(_this_, regex, function_0) {
    var str = _this_;
    var tmp0_repeat_0 = toList_0(regex.findAll$default(_this_, 0, 2, null))._get_size__26();
    var inductionVariable = 0;
    if (inductionVariable < tmp0_repeat_0)
      do {
        var index_2 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_replaceFirst_0_4 = str;
        var tmp1_replaceFirst_0_5 = function_0();
        str = regex.replaceFirst(tmp0_replaceFirst_0_4, tmp1_replaceFirst_0_5);
      }
       while (inductionVariable < tmp0_repeat_0);
    return str;
  }
  function _no_name_provided__160() {
  }
  _no_name_provided__160.prototype.invoke_292 = function (it) {
    if (it instanceof ServiceWorkerRegistration)
      it;
    else
      THROW_CCE();
    Unit_getInstance();
    if (!(currentPage === '#play')) {
      sessionStorage.clear();
      localStorage.clear();
      it.unregister();
      Unit_getInstance();
      window.location.reload();
    }};
  _no_name_provided__160.prototype.invoke_293 = function (p1) {
    this.invoke_292((p1 == null ? true : isObject(p1)) ? p1 : THROW_CCE());
    return Unit_getInstance();
  };
  _no_name_provided__160.$metadata$ = {
    kind: 'class',
    interfaces: []
  };
  function _no_name_provided_$factory_149() {
    var i = new _no_name_provided__160();
    return function (p1) {
      i.invoke_292(p1);
      return Unit_getInstance();
    };
  }
  AbstractMap.prototype._get_entries__7 = Map_0.prototype._get_entries__7;
  IntIterator.prototype.hasNext_12 = Iterator.prototype.hasNext_12;
  AbstractMutableList.prototype.get_36 = List.prototype.get_36;
  AbstractMutableMap.prototype._get_entries__7 = MutableMap.prototype._get_entries__7;
  InternalHashCodeMap.prototype.createJsMap_0 = InternalMap.prototype.createJsMap_0;
  KClassImpl.prototype._get_simpleName__2 = KClass.prototype._get_simpleName__2;
  DefaultUnsafe.prototype.raw_0 = Unsafe.prototype.raw_0;
  StringEncoder.prototype.empty_3 = AttributeEncoder.prototype.empty_3;
  BooleanEncoder.prototype.empty_3 = AttributeEncoder.prototype.empty_3;
  EnumEncoder.prototype.empty_3 = AttributeEncoder.prototype.empty_3;
  HTMLTag.prototype.text_5 = Tag.prototype.text_5;
  BUTTON.prototype.unaryPlus_4 = Tag.prototype.unaryPlus_4;
  BUTTON.prototype.text_5 = Tag.prototype.text_5;
  DIV.prototype.unaryPlus_4 = Tag.prototype.unaryPlus_4;
  DIV.prototype.text_5 = Tag.prototype.text_5;
  INPUT.prototype.text_5 = Tag.prototype.text_5;
  SPAN.prototype.unaryPlus_4 = Tag.prototype.unaryPlus_4;
  SPAN.prototype.text_5 = Tag.prototype.text_5;
  JSDOMBuilder.prototype.onTagError_1 = TagConsumer.prototype.onTagError_1;
  functionClasses = functionClasses$init$();
  buf = new ArrayBuffer(8);
  bufFloat64 = bufFloat64$init$();
  bufInt32 = bufInt32$init$();
  lowIndex = lowIndex$init$();
  highIndex = 1 - lowIndex | 0;
  ZERO = fromInt(0);
  ONE = fromInt(1);
  NEG_ONE = fromInt(-1);
  MAX_VALUE = new Long(-1, 2147483647);
  MIN_VALUE = new Long(0, -2147483648);
  TWO_PWR_24_ = fromInt(16777216);
  emptyMap_0 = emptyMap();
  attributeStringString = new StringAttribute();
  attributeSetStringStringSet = new StringSetAttribute();
  attributeBooleanBooleanOnOff = new BooleanAttribute('on', 'off');
  attributeInputTypeEnumInputTypeValues = new EnumAttribute(inputTypeValues);
  inputTypeValues = inputTypeValues$init$();
  currentPage = '#startmenu';
  main();
  return _;
}));
